{
  "material.outdated.title": "This material has been updated",
  "material.outdated.description": "Please copy any answers you have not submitted, then refresh this page in your browser to continue.",
  "material.autosave.saved": "Saved",
  "material.autosave.description": "Changes are saved automatically.",
  "material.autosave.saving": "Saving …",
  "material.autosave.failed": "Not saved",
  "ai.assistant.sharing.title": "Share material",
  "ai.assistant.sharing.recipients": "Share with",
  "ai.assistant.sharing.hide.title": "Hide material",
  "ai.assistant.sharing.hide.recipients": "Hide from",
  "ai.assistant.sharing.hide.confirm": "Hide",
  "ai.assistant.sharing.hide.confirmed": "Hidden",
  "ai.assistant.sharing.all_students": "All students in this course",
  "ai.assistant.sharing.pending": "Visibility for these materials changes only when you confirm.",
  "ai.assistant.sharing.confirmed": "Shared",
  "ai.assistant.sharing.discarded": "Change discarded",
  "ai.assistant.sharing.error": "Visibility could not be updated. Please try again.",
  "ai.assistant.composer.attachment_size_limit": "Files must be {{size}} MiB or smaller. Please choose a smaller file.",
  "course_students.access_cards.login_instruction": "Open {{url}} and enter your code.",
  "course_students.access_cards.course_scope_hint": "These codes give students access to all shared materials in the course “{{courseName}}”.",
  "ai.assistant.student_note.loading": "Loading documentation …",
  "ai.assistant.student_note.discarded": "This documentation draft was discarded or is no longer available.",
  "ai.assistant.student_note.student": "Student",
  "ai.assistant.student_note.edit": "Change documentation or student",
  "ai.assistant.student_note.discard": "Discard draft",
  "ai.assistant.student_note.open_student": "Open student",
  "ai.assistant.student_note.error": "The documentation could not be loaded or updated. Please try again.",
  "ai.assistant.student_note.retry": "Try again",
  "ai.assistant.student_privacy.protected": "Protected",
  "ai.assistant.student_privacy.hint": "The name is automatically replaced with a random pseudonym",
  "auth.signup_v2.continue_with_provider": "Continue with {{provider}}",
  "auth.signup_v2.marketing_title": "The teaching platform\nthat thinks with you.",
  "auth.signup_v2.marketing_description": "Planning, materials, assignments and documentation in one place – connected by an AI assistant that works alongside you and turns ideas into action.",
  "auth.signup_v2.start_free": "Start for free",
  "integration.google.description": "Sign in to Teachino with your Google account.",
  "integration.authenticate_google.description": "Sign in to Teachino with your Google account.",
  "onboarding.iam_banner.title": "Activate your free Teachino license with IAM",
  "onboarding.iam_banner.description": "WebUntis is already connected. Sign in with your IAM (CGIE) account to finish setup and activate your free license.",
  "onboarding.iam_banner.connect": "Sign in with IAM",
  "onboarding.webuntis_banner.title": "Connect your timetable to import courses from WebUntis",
  "onboarding.webuntis_banner.step_open": "Open WebUntis in a new tab, sign in, and select “Teachino” in the main navigation. If you don’t see it, ask your administrator to enable it.",
  "onboarding.webuntis_banner.step_connect": "Confirm the connection to your Teachino account.",
  "onboarding.webuntis_banner.step_ready": "Your WebUntis courses, timetable, and students will then appear here.",
  "onboarding.webuntis_banner.tutorial": "View the full setup guide",
  "onboarding.webuntis_banner.dismiss": "Dismiss",
  "generic_prompt": "Prompt",
  "timetable.course_first_banner.feedback": "We look forward to your feedback: hello@teachino.io",
  "integration.authenticate_europathek.description": "Connecting Teachino and the EUROPATHEK enables automatic sign-in to Teachino.",
  "integration.europathek.description": "For teachers: Link Teachino with EUROPATHEK.",
  "feature_course.onboarding.progress.aria_label": "Onboarding progress",
  "feature_course.onboarding.step_label.country": "Country",
  "feature_course.onboarding.step_label.school_type": "School Type",
  "feature_course.onboarding.step_label.subject": "Subject",
  "feature_course.onboarding.step_label.class_level": "Class",
  "feature_course.onboarding.step_label.summary": "Summary",
  "feature_course.onboarding.step_label.unknown": "Unknown",
  "feature_course.onboarding.country.title": "Welcome to Teachino",
  "feature_course.onboarding.country.description": "Let’s start with a few short questions so Teachino fits your school day.",
  "feature_course.onboarding.country.other_option": "Other country",
  "feature_course.onboarding.country.other_input_label": "Country",
  "feature_course.onboarding.country.other_placeholder": "Enter own country",
  "feature_course.onboarding.state.title": "State",
  "feature_course.onboarding.state.other_option": "Other state",
  "feature_course.onboarding.state.other_input_label": "State",
  "feature_course.onboarding.state.other_placeholder": "Enter own state",
  "feature_course.onboarding.school_type.title": "Which school type?",
  "feature_course.onboarding.school_type.description": "The AI adapts results to your school",
  "feature_course.onboarding.school_type.other_option": "Other school type",
  "feature_course.onboarding.school_type.other_input_label": "School Type",
  "feature_course.onboarding.school_type.other_placeholder": "Enter own school type",
  "feature_course.onboarding.subject.title": "Which subject would you like to start with?",
  "feature_course.onboarding.subject.description": "You can add more subjects later.",
  "feature_course.onboarding.subject_group.languages": "Languages",
  "feature_course.onboarding.subject_group.natural_sciences": "Natural sciences",
  "feature_course.onboarding.subject_group.social_studies": "Social studies",
  "feature_course.onboarding.subject_group.vocational": "Vocational",
  "feature_course.onboarding.subject_group.mandatory": "Mandatory subjects",
  "feature_course.onboarding.subject_group.other": "Other subjects",
  "feature_course.onboarding.subject.other_option": "Other subject",
  "feature_course.onboarding.subject.other_placeholder": "Enter own subject",
  "feature_course.onboarding.subject.other_label": "Enter Subject",
  "feature_course.onboarding.class_level.title": "Which class do you teach {{subject}}?",
  "feature_course.onboarding.class_level.description": "You can add more classes later.",
  "feature_course.onboarding.class_level.other_option": "Other Class",
  "feature_course.onboarding.class_level.other_input_label": "Class",
  "feature_course.onboarding.class_level.other_placeholder": "Enter own class",
  "feature_course.onboarding.summary.title": "Almost done!",
  "feature_course.onboarding.summary.description": "Review and adjust your course",
  "feature_course.onboarding.summary.more_courses_hint": "You can create more courses at any time later.",
  "feature_course.onboarding.summary.course_name_label": "Course name",
  "feature_course.onboarding.summary.class_name_label": "Class",
  "feature_course.onboarding.summary.class_name_label_example": "Class (e.g. {{example}})",
  "feature_course.onboarding.summary.subject_name_label": "Subject",
  "feature_course.onboarding.summary.course_name_preview": "Your course name",
  "feature_course.onboarding.summary.color_label": "Color",
  "feature_course.onboarding.fallback.step": "Step {{step}}: {{label}}",
  "feature_course.onboarding.fallback.not_implemented": "This step is not implemented yet.",
  "feature_course.onboarding.fallback.content_area": "Content Area",
  "feature_course.onboarding.debug.title": "Debug Information",
  "feature_course.onboarding.debug.no_selections": "No selection yet.",
  "feature_course.onboarding.debug.toggle": "Show Debug",
  "feature_course.onboarding.action.create_course": "Create course",
  "feature_course.onboarding.common.other": "Other",
  "feature_course.onboarding.common.type_own_value": "Enter own value",
  "editor.image_selector.libraries.search": "Search textbook",
  "material.tab_share_preview": "Preview & Share",
  "material.share.visibility_hint": "Students only see the material after it is unlocked with the eye.",
  "generic_link_copied_to_clipboard": "Link copied to clipboard",
  "generic_loading": "Loading…",
  "auth_verify_resend_success": "A new email has been sent to you.",
  "library.recent_materials.empty_state.title": "No materials created yet.",
  "library.recent_materials.empty_state.description": "Once you create your first material, it will appear here. Materials can contain interactive tasks with AI feedback, images, links, files, and much more.",
  "library.recent_materials.empty_state.cta": "Create material",
  "item_detail.file_replace": "Replace file",
  "onboarding.skip": "Skip",
  "editor.tools.video.caption.label": "Video description",
  "editor.tools.video.caption.placeholder": "Describe the video",
  "material.block_menu.text": "Text",
  "material.block_menu.open_question": "Open question",
  "material.block_menu.questions_reproduction": "Generate reproduction questions",
  "material.block_menu.questions_reorganisation": "Generate reorganization questions",
  "material.block_menu.questions_reflection": "Generate reflection questions",
  "material.block_menu.multiple_choice": "Multiple-choice question",
  "material.block_menu.matching": "Matching task",
  "material.editor.matching.badge": "Matching task",
  "material.editor.matching.instruction_placeholder": "Type the task here, e.g. “Find the correct translations”.",
  "material.editor.matching.no_instruction": "No task",
  "material.editor.matching.left_placeholder": "Term (left)",
  "material.editor.matching.right_placeholder": "Matching term (right)",
  "material.editor.matching.add_pair": "Add pair",
  "material.editor.matching.reorder": "Move",
  "material.editor.matching.connect_hint": "Connect the matching terms: drag a line from left to right, or tap one term and then the other.",
  "material.editor.matching.print_hint": "Match each card on the left with the correct card on the right. Draw a line between the two cards.",
  "material.editor.matching.read_hint": "Press and hold a term to read its full text.",
  "material.editor.matching.peek_label": "Full text",
  "material.editor.matching.submit": "Submit",
  "material.editor.matching.redo": "Revise matches",
  "material.editor.matching.reset": "Reset",
  "material.editor.matching.validation.min_pairs": "Add at least two complete pairs.",
  "material.editor.matching.feedback.correct": "Great! All pairs are matched correctly.",
  "material.editor.matching.feedback.partially": "Partially correct. Check your matches and try again.",
  "material.editor.matching.feedback.incorrect": "Not correct yet. Check your matches and try again.",
  "material.editor.matching.state.correct": "Matched correctly",
  "material.editor.matching.state.incorrect": "Matched incorrectly",
  "material.editor.matching.state.missing": "Not matched",
  "material.editor.matching.correct_answer": "Correct answer",
  "material.editor.matching.shuffle_hint": "Note: for students the right column is shuffled automatically.",
  "material.block_menu.listening": "Listening block",
  "material.block_menu.gap_text": "Gap text",
  "material.block_menu.gap_text_generate": "Generate gap text",
  "material.block_menu.flashcards": "Flashcards",
  "material.block_menu.flashcards_add": "Add flashcards",
  "material.block_menu.flashcards_generate": "Generate flashcards",
  "material.tab_share": "Share",
  "material.ai_create.title": "Create material with AI",
  "material.ai.edit.suggestion_1_label": "Simplify",
  "material.ai.edit.suggestion_2_label": "Change focus",
  "material.ai.edit.suggestion_3_label": "Translate",
  "material.ai.edit.suggestion_4_label": "Interactive assignments",
  "material.ai.edit.suggestion_5_label": "Deepen",
  "material.ai.edit.suggestion_6_label": "Shorten",
  "material.ai.edit.suggestion_7_label": "Add tasks",
  "material.ai.edit.suggestion_8_label": "Additional tasks",
  "material.ai.edit.suggestion_9_label": "Improve structure",
  "material.ai.edit.suggestion_10_label": "Summarize",
  "material.ai.edit.suggestion_11_label": "Regenerate",
  "material.ai_edit.suggestion_11": "Regenerate the entire material.",
  "material.ai.create.suggestion_1_label": "Worksheet",
  "material.ai.create.suggestion_1": "Create a worksheet on the topic: ",
  "material.ai.create.suggestion_2_label": "Lesson outline",
  "material.ai.create.suggestion_2": "Create a lesson outline on the topic: ",
  "material.ai.create.suggestion_3_label": "Interactive exercise",
  "material.ai.create.suggestion_3": "Create an interactive exercise on the topic: ",
  "material.ai.create.suggestion_4_label": "Lesson opener",
  "material.ai.create.suggestion_4": "Create a motivating, student-oriented lesson opener on the topic: ",
  "material.ai.create.suggestion_5_label": "Ideas for the next lesson",
  "material.ai.create.suggestion_5": "Develop ideas for the next lesson.",
  "material.ai.create.suggestion_6_label": "Learning objectives",
  "material.ai.create.suggestion_6": "Formulate learning objectives on the topic: ",
  "material.ai_state.generated": "Material has been generated",
  "material.ai_state.undo": "Undo",
  "material.ai_state.save_as_new": "Save as new material",
  "material.ai_state.accept": "save",
  "material.ai_save_as_new.description": "The result is saved as new material. This allows for differentiated versions of a material.",
  "material.ai_save_as_new.name_label": "Name of the new material",
  "material.ai_save_as_new.name_placeholder": "Name of the new material",
  "material.ai_save_as_new.copy_suffix": " (Copy)",
  "material.ai_save_as_new.success_title": "New material saved",
  "material.ai_save_as_new.success_message": "The new material has been created and opened.",
  "material.pdf_export": "Save / print PDF",
  "material.pdf_export_beautiful": "Beautiful PDF",
  "material.docx_export": "Word (.docx)",
  "material.docx_export_with_notes": "Word (.docx) with notes",
  "material.search_placeholder": "Search materials",
  "material.generate": "Generate material with AI",
  "material.editor.text.generate_questions": "Generate questions about the text",
  "material.editor.text.simplify": "Simplify text",
  "material.editor.text.label": "Text block",
  "material.editor.text.placeholder": "Type text",
  "material.editor.callout.label": "Key takeaway",
  "material.editor.callout.placeholder": "Write here",
  "material.save_conflict.title": "Newer material version available",
  "material.save_conflict.close": "Close",
  "material.save_conflict.reload": "Reload material",
  "material.save_conflict.body_updated": "This material was updated after this editor was opened.",
  "material.save_conflict.body_reload_warning": "Reloading will load the latest version of the material. Unsaved changes in this outdated version will be lost.",
  "material.editor.details.summary_label": "Drop-down list title",
  "material.editor.details.summary_placeholder": "Title",
  "material.editor.details.content_label": "Content of the drop-down list",
  "material.editor.details.placeholder": "Write here",
  "material.editor.block.ai_suggestion": "AI suggestion",
  "material.editor.block.reject": "Reject",
  "material.editor.block.accept": "Accept",
  "material.editor.block.teacher_only": "Visible to teacher only",
  "material.editor.block.adjust_results": "Adjust results",
  "material.editor.block.prompt_placeholder": "Enter prompt",
  "material.editor.block_number.image": "B{{number}}",
  "material.editor.assignment_open_question.placeholder": "Type question here",
  "material.editor.assignment_open_question.hint_loading": "Hint is loading",
  "material.editor.assignment_open_question.badge": "Assignment with AI-feedback",
  "material.editor.assignment_open_question.guidance_hint": "Enter feedback criteria or a model answer here.",
  "material.editor.assignment_open_question.guidance_hint_short": "Enter feedback criteria here",
  "material.editor.assignment_open_question.guidance_input_placeholder": "Enter feedback criteria here",
  "material.editor.assignment_open_question.guidance_collapsed_empty": "Not set yet",
  "material.editor.assignment_open_question.preview_cta": "Test AI-feedback",
  "material.editor.assignment_open_question.preview_title": "Try the question from your students' perspective",
  "material.editor.assignment_open_question.language_assessment.label": "Criteria for language-related AI-feedback",
  "material.editor.assignment_open_question.language_assessment.description": "Enable or disable the options you want to apply.",
  "material.editor.assignment_open_question.language_assessment.chip.grammar_spelling": "Grammar and spelling",
  "material.editor.assignment_open_question.language_assessment.chip.allow_all_languages": "Allow all languages",
  "material.editor.assignment_open_question.language_assessment.feedback_label": "Language",
  "material.editor.assignment_open_question.help.cta": "Read complete guide",
  "material.editor.assignment_open_question.help.title": "Guide: Use AI in the classroom",
  "material.editor.assignment_open_question.help.link": "Guide: Use AI in the classroom",
  "material.editor.multiple_choice.badge": "Multiple-choice question",
  "material.editor.multiple_choice.choice_type": "Choice type",
  "material.editor.multiple_choice.single_choice": "Single-choice",
  "material.editor.multiple_choice.multiple_choice": "Multiple choice",
  "material.editor.multiple_choice.option_placeholder": "Answer {{index}}",
  "material.editor.multiple_choice.allow_multiple": "Allow multiple answers",
  "material.editor.multiple_choice.add_option": "Add answer",
  "material.editor.multiple_choice.randomized_order_hint": "The order of answers is randomized for students.",
  "material.editor.multiple_choice.no_question": "The teacher has not formulated a question yet.",
  "material.editor.multiple_choice.answer_option_default": "Answer option",
  "material.editor.multiple_choice.correct": "Correct",
  "material.editor.multiple_choice.info.title": "Students receive AI tips",
  "material.editor.multiple_choice.info.description": "If the wrong answer is selected, students receive a tip.",
  "material.editor.multiple_choice.preview_cta": "Try it",
  "material.editor.multiple_choice.validation.min_answers": "Please provide at least two answers.",
  "material.editor.multiple_choice.validation.correct_answer": "Please mark at least one correct answer.",
  "material.editor.multiple_choice.feedback.correct": "Great! Everything is correct.",
  "material.editor.multiple_choice.feedback.partially": "Some answers are correct, but not all yet.",
  "material.editor.multiple_choice.feedback.incorrect": "Not correct yet. Review the highlights and try again.",
  "material.editor.multiple_choice.state.correct_selected": "Correct selection",
  "material.editor.multiple_choice.state.incorrect_selected": "Incorrect selection",
  "material.editor.multiple_choice.state.missed_correct": "Correct answer not selected",
  "material.editor.listening.badge": "Listening block",
  "material.editor.listening.placeholder": "Type the text that should be read aloud",
  "material.editor.listening.edit_open": "Edit text",
  "material.editor.listening.edit_close": "Hide text editor",
  "material.editor.listening.generating": "Generating audio…",
  "material.editor.listening.empty_state": "Add text to generate audio.",
  "material.editor.listening.audio_unavailable": "Audio unavailable",
  "material.editor.listening.listen": "Listen",
  "material.editor.listening.stop": "Stop",
  "material.editor.listening.generation_failed": "Audio generation failed.",
  "material.editor.listening.retry": "Retry",
  "material.editor.gap_text.placeholder": "Enter your text here",
  "material.editor.gap_text.hint": "Select text to mark a gap, or click a highlighted word and choose “Remove gap”",
  "material.editor.gap_text.validation.min_gaps": "Mark at least one word as a gap",
  "material.editor.gap_text.word_bank_for_students": "Word bank for students",
  "material.editor.gap_text.word_bank_off": "Off",
  "material.editor.gap_text.word_bank_on": "On",
  "material.editor.gap_text.word_bank": "Word bank",
  "material.editor.gap_text.word_bank_drop_return": "Drop here to return the word",
  "material.editor.gap_text.word_bank_all_used": "All words used",
  "material.editor.gap_text.actions": "Gap text actions",
  "material.editor.gap_text.mark_as_gap": "Mark as gap",
  "material.editor.gap_text.remove_gap": "Remove gap",
  "material.editor.gap_text.evaluation.correct": "Correct",
  "material.editor.gap_text.evaluation.capitalization": "Check capitalization",
  "material.editor.gap_text.evaluation.incorrect": "Incorrect",
  "material.editor.image.search_other": "Search for another image",
  "material.editor.image.upload_other": "Upload another image",
  "material.editor.image.generate": "Generate image",
  "material.editor.image.no_results": "No results found.",
  "material.editor.image.alternative_for": "Alternative images for \"{{keywords}}\"",
  "material.editor.image.source_label": "Source:",
  "material.editor.image.author_label": "Author:",
  "material.editor.image.suggestions_title": "Alternative <br /> suggestions",
  "material.editor.file.uploading": "Uploading file",
  "material.editor.file.upload_error": "File could not be uploaded.",
  "material.editor.file.retry": "Try again",
  "material.editor.file.upload": "Upload file",
  "material.editor.link.enter": "Enter link",
  "material.editor.link.invalid": "Please enter a valid link.",
  "material.editor.link.remove_preview": "Remove preview",
  "material.save_as_new_dialog.title": "Save as new material",
  "material.save_as_new_dialog.description": "Enter a name for the new material.",
  "material.save_as_new_dialog.placeholder": "Enter name",
  "material.save_as_new_dialog.confirm": "Save as new material",
  "material.chat.age_select.tooltip": "Students' age: The AI adjusts the difficulty and methods to your students' age",
  "material.chat.language_select.tooltip": "In which language should the AI generate results?",
  "ipi.system_prompt.label": "System prompt (if empty, the default prompt is used)",
  "ipi.system_prompt.placeholder": "The main prompt",
  "ipi.usage.remaining_1": "One request still possible",
  "ipi.prompt.too_generic": "Your request is too general. Please specify a topic, subject, or content focus (e.g., \"worksheet on photosynthesis\" or \"explanation of the French Revolution\") to create suitable material.",
  "ipi.prompt.rejected_by_agent": "Please ask a question on an educational topic suitable for teaching or learning.",
  "ipi.prompt.generic_error": "Something went wrong. Please try again.",
  "ipi.prompt_history.title": "Prompt history",
  "ipi.prompt_history.open": "Open prompt history",
  "ipi.prompt_history.empty_state": "You haven't used any prompts yet.",
  "ipi.prompt_history.select": "Use prompt",
  "ipi.prompt.failed": "Material could not be generated. Please try again.",
  "ipi.more_tools.title": "More AI tools",
  "ipi.material.done_description_after": ", to adapt the material.",
  "ipi.inspiration.heading": "Inspiration",
  "ipi.inspiration.try_example": "Try example",
  "ipi.inspiration.examples.1.subject": "Digital education",
  "ipi.inspiration.examples.1.title": "Artificial intelligence",
  "ipi.inspiration.examples.1.prompt": "Create a worksheet where students learn step by step what AI is, its advantages, disadvantages, and risks. Students have little prior knowledge of this topic.",
  "ipi.inspiration.examples.2.subject": "Digital education",
  "ipi.inspiration.examples.2.title": "Social media",
  "ipi.inspiration.examples.2.prompt": "Create a worksheet on the topic of social media. Address opportunities, risks, and rules for responsible use. Students know basic internet dangers and use various apps (mainly TikTok and Instagram).",
  "ipi.inspiration.examples.3.subject": "Interdisciplinary",
  "ipi.inspiration.examples.3.title": "Sustainability",
  "ipi.inspiration.examples.3.prompt": "Create a worksheet on the topic of sustainability from different perspectives.",
  "ipi.inspiration.examples.4.subject": "English",
  "ipi.inspiration.examples.4.title": "Fake news",
  "ipi.inspiration.examples.4.prompt": "Create a long reading text with interactive comprehension and reflection questions on the topic of fake news.",
  "ipi.rework": "Revise",
  "help_center.materials.title": "Create & edit materials",
  "help_center.materials.sub_title": "A subtitle",
  "help_center.materials.description": "In Teachino, you can create high-quality teaching materials with just a few clicks. The easiest way is with the AI on the homepage. Just enter a topic and add details such as age and language, specify which topic the material should be saved under, or add a source, e.g., a PDF or link that the AI should refer to, and off you go. Within seconds, the AI creates suitable material for you with images, texts, and tasks. The more details you give the AI, the better the outcome.",
  "help_center.materials.faq1.question": "How can I create a material?",
  "help_center.materials.faq1.answer": "To create a material, go to the homepage and enter a topic.",
  "navigation.profile_settings": "Profile settings",
  "navigation.profile.trial_days_left": "{{days}} trial days left",
  "navigation.profile.grace_days_left": "{{days}} Pro days left",
  "material.tab_edit": "Edit",
  "material.tab_preview": "Preview",
  "material.tab_evaluate": "Evaluate",
  "material.ai_suggestions.title": "Improve your material with AI",
  "material.ai_suggestions.subtitle": "Pick an idea or start with your own prompt.",
  "material.ai_suggestions.label_simplify": "Simplify",
  "material.ai_suggestions.label_rebuild": "Rebuild",
  "material.ai_suggestions.label_deepen": "Deepen",
  "material.ai_suggestions.label_focus": "Focus",
  "material.ai_suggestions.label_add_example": "Examples",
  "material.ai_suggestions.label_structure": "Structure",
  "material.ai_suggestions.label_methods": "Methods",
  "material.ai_suggestions.label_summary": "Summary",
  "material.ai_suggestions.custom_prompt": "Enter prompt",
  "material.ai_edit.title": "Revise material with AI",
  "material.ai_edit.paywall.description": "Subscribe to a license now to revise lesson materials with AI.",
  "material.ai_edit.placeholder": "Type how the AI should revise the material",
  "material.ai_edit.suggestions_title": "Suggestions",
  "material.ai_edit.suggestion_1": "Simplify the entire material",
  "material.ai_edit.suggestion_2": "Change the focus of the entire material to:",
  "material.ai_edit.suggestion_3": "Translate the material into:",
  "material.ai_edit.suggestion_4": "Add suitable interactive assignments to the material.",
  "material.ai_edit.suggestion_5": "Expand and deepen the entire material",
  "material.ai_edit.suggestion_6": "Shorten the material to the essentials.",
  "material.ai_edit.suggestion_7": "Add more assignments using the following operators:",
  "material.ai_edit.suggestion_8": "Add challenging extension assignments for students who finish early.",
  "material.ai_edit.suggestion_9": "Make the material clearer with distinct headings, logical sections, and paragraphs.",
  "material.ai_edit.suggestion_10": "Create a short summary of the key points at the end.",
  "ipi.material.done_description": "Not quite what you need? Use the AI ",
  "ipi.hints.improvements": "Tip: Add desired details like <strong>Focus</strong>, <strong>Learning Objective</strong>, <strong>Prior Knowledge</strong>, <strong>Duration</strong>, <strong>Group Form</strong>, <strong>Complexity Level</strong>, <strong>Language Style</strong>.",
  "ipi.feedback.thank_you": "Thank you for your feedback!",
  "ipi.feedback.regenerate": "Click \"Regenerate\" to try again.",
  "ipi.add_source.add_youtube": "Enter YouTube link",
  "ipi.add_topic_description": "In which folder should the material be created? The AI uses the folder as additional context.",
  "ipi.regenerate": "Regenerate",
  "ipi.regenerate.title": "Regenerate Material",
  "ipi.improve.hint.title": "Tips",
  "ipi.improve.hint.1_label": "🧠 Too difficult?",
  "ipi.improve.hint.1_cta": "Adjust age",
  "ipi.improve.hint.2_label": "✍️ Too vague?",
  "ipi.improve.hint.2_cta": "Mention focus",
  "ipi.improve.hint.3_label": "🎯 Imprecise?",
  "ipi.improve.hint.3_cta": "Add learning objective",
  "ipi.improve.hint.4_label": "🗣️ Wrong language?",
  "ipi.improve.hint.4_cta": "Select language.",
  "editor.tools.code.note": "Teacher's note",
  "editor.tools.youtube": "YouTube",
  "material.editor.assignments": "Interactive assignments",
  "material.editor.assignments_ai_hint": "With AI for students",
  "material.editor.interactive_tag": "Interactive",
  "material.editor.interactive_ai_tag": "Interactive with AI",
  "topic.summary_item_0": "No material",
  "topic.summary_item_1": "1 Material",
  "topic.summary_item_many": "{{number}} Materials",
  "topic.lesson_goals.description": "AI can generate new goals or optimize your text. When creating materials for {{topicName}} with AI, these goals and skills will be included.",
  "library.topics_autocomplete.label": "Select topic",
  "library.topics_autocomplete.placeholder": "Search folder",
  "library.topics_autocomplete.current_course": "Folders in course",
  "library.topics_autocomplete.all_courses": "All folders",
  "library.topics_autocomplete.create_description": "In which folder should the material be created?",
  "library.topics_autocomplete.new_topic": "New folder",
  "library.topics_autocomplete.back": "Back to list",
  "library.duplicate_items.duplicate_one_description": "Copy {{item}}",
  "library.duplicate_items.duplicate_many_description": "Copy {{number}} materials",
  "library.duplicate_items.confirm": "Copy to {{topic}}",
  "library.duplicate_items.success": "Material copied",
  "library.move_items.move_one_description": "Move {{item}}",
  "library.move_items.move_many_description": "Move {{number}} materials",
  "library.move_items.confirm": "Move to {{topic}}",
  "library.move_items.success": "Material moved",
  "library.add_topic_to_courses": "Add folder to courses",
  "library.add_topic_to_courses.link": "Add folder to more courses",
  "presentation.title": "Presentation mode",
  "presentation.course_title": "{{courseName}} on {{date}}",
  "presentation.empty.title": "No materials planned",
  "presentation.empty.description": "Once the lesson is planned, it can be presented here on the projector or digital board. You control which sections students see.",
  "presentation.empty.material": "This material is empty.",
  "presentation.empty.cta": "To schedule",
  "create_item.create_item": "Create material",
  "create_item.generate_item": "Generate material with AI",
  "create_item.new_item": "New material",
  "create_item.save_item": "Save material",
  "create_item.topic_tooltip": "Materials are assigned to topics so you can quickly find them later.",
  "create_item.topic_only_description": "Choose the topic where {{itemName}} should be saved.",
  "create_item.topic_only_footer_course": "You will find the material later in the course and in your library",
  "create_item.search_topic": "Select folder",
  "create_item.title_label": "Material name",
  "create_item.new_topic": "Create new topic",
  "create_item.new_topic_extension": "create",
  "create_item.item_input_placeholder": "Worksheet, textbook exercise, video, …",
  "create_item.generic_error": "Error creating material",
  "create_item.add_snippets": "Add materials",
  "create_item.empty_title": "Please enter a name for the material.",
  "create_item.empty_topic": "Please select the topic this material should be assigned to.",
  "create_item.empty_link": "Please enter a valid link.",
  "create_item.successful": "Material created!",
  "select_course.empty_state": "You have not created any courses yet.",
  "upgrade.feature_discovered.dialog_title": "Upgrade required",
  "upgrade.feature_discovered.title": "Get the full feature set",
  "upgrade.feature_discovered.description": "Subscribe to a license now and keep working without limits.",
  "upgrade.feature_discovered.cta": "Learn more",
  "upgrade.soft_paywall.grace_days_left": "{{days}} more days of free access.",
  "upgrade.soft_paywall.trial_days_left": "{{days}} more trial days.",
  "upgrade.feature.ai.title": "Access to AI support Thena",
  "upgrade.feature.ai.description": "Your AI assistant in teaching",
  "upgrade.feature.ai.description_2": "Thena is your personal and interactive AI assistant",
  "upgrade.feature.ai.perk.trained_for_schools.title": "developed specifically for schools",
  "upgrade.feature.ai.perk.personalised.title": "personalized results",
  "upgrade.feature.ai.perk.personalised.description": "Based on curriculum, planned lessons, and age of students",
  "upgrade.feature.ai.perk.high_quality.title": "high quality results",
  "upgrade.feature.ai.perk.high_quality.description": "Predefined prompts deliver high-quality results. Suggestions can also be customized via chat, and own requests can be made.",
  "upgrade.feature.ai.perk.pro": "Everything from the License for Teachers for 5 or more teachers",
  "upgrade.feature.ai.perk.collaboration": "Collaboration in subject groups, team teaching and substitutions",
  "upgrade.feature.overview.title": "Unlimited access to existing & new features",
  "upgrade.feature.overview.description": "Your AI assistant in teaching",
  "upgrade.feature.overview.description_2": "Thena is your personal and interactive AI assistant",
  "upgrade.feature.overview.perk.planning": "Annual planning & detailed planning",
  "upgrade.feature.overview.perk.webuntis": "Integrated in WebUntis schedule & class book",
  "upgrade.feature.overview.perk.library": "Personal library",
  "upgrade.feature.overview.perk.collaborate": "Share materials with colleagues & collaborate",
  "upgrade.feature.overview.perk.teamteaching": "Team teaching: Plan lessons together",
  "upgrade.feature.overview.perk.microsoft_integration": "Integration with OneNote, OneDrive & Microsoft Teams",
  "upgrade.feature.overview.perk.timetable": "Flexible schedule (holidays, substitutions, & private appointments)",
  "upgrade.feature.overview.perk.student_materials": "Materials for students (via a link)",
  "upgrade.feature.overview.perk.presentation_mode": "Presentation mode",
  "upgrade.feature.storage.title": "Unlimited storage",
  "upgrade.feature.storage.description": "Now all your documents find their place!",
  "upgrade.feature.storage.description_2": "With the License for Teachers you get <strong>unlimited storage.</strong>",
  "upgrade.feature.daily_changes.title": "Flexible schedule",
  "upgrade.feature.daily_changes.description": "Easily map holidays, substitutions, cancellations, and private appointments in Teachino.",
  "upgrade.feature.presentation.title": "Presentation mode",
  "upgrade.feature.presentation.description": "Present your materials in class on the digital board or through the projector.",
  "upgrade.feature.students.title": "Access for students",
  "upgrade.feature.students.description": "Share your planning and materials with students and guardians.",
  "upgrade.feature.student_evaluation.title": "Evaluation & feedback",
  "upgrade.feature.student_evaluation.description": "View results per student and per question, and give individual feedback on submissions.",
  "upgrade.feature.ipi.title": "Unlimited AI material creation",
  "upgrade.feature.ipi.description": "Generate interactive worksheets, assignments, and lesson ideas—with no limits.",
  "upgrade.feature.integration.title": "Integrated with your class book (WebUntis/Digital Register)",
  "upgrade.feature.integration.description": "Connect your timetable and class register and keep them up to date.",
  "upgrade.feature.collaboration.title": "Collaboration with colleagues",
  "upgrade.feature.collaboration.description": "Create, edit, and share materials with your colleagues. Collaborating has never been easier.",
  "upgrade.feature.school.perk.shareable": "Easy <strong>sharing</strong> of materials within the school",
  "upgrade.feature.school.perk.collaborative": "<strong>Collaborative</strong> lesson planning (e.g., within subject groups)",
  "upgrade.feature.school.perk.training": "Onboarding and staff training (free webinars, individual support on request)",
  "upgrade.feature.school.perk.student_accounts": "Personal accounts for students",
  "upgrade.feature.school.perk.cost_relief": "Cost relief for teachers",
  "upgrade.school.description": "The Teachino team is happy to (virtually) visit your school and present the benefits of the school license to your staff in detail.",
  "upgrade.school.cta": "Request an offer",
  "upgrade.buy.cta": "Get Pro license",
  "upgrade.buy.trainee.discount": "🌱 Trainees save on the <strong>License for Teachers</strong>",
  "upgrade.buy.trainee.cta_two_years": "50% off for 2 years",
  "upgrade.buy.trainee.cta_one_year": "25% off for 1 year",
  "upgrade.buy.payment_cycle.label": "Duration",
  "upgrade.buy.payment_cycle.option_multiple": "{{months}} months",
  "upgrade.buy.payment_cycle.option_one": "1 month",
  "upgrade.buy.payment_cycle.price": "{{price}} / month",
  "upgrade.buy.save_percent": "save {{percent}}%",
  "upgrade.buy.tag.loved": "Most popular",
  "upgrade.buy.tag.cheapest": "Save {{percent}}%",
  "upgrade.discover.title": "You've discovered a License for Teachers feature!",
  "upgrade.discover.description": "With Pro you get unlimited AI material, student access, and all advanced features. Buy yourself or request a school license.",
  "upgrade.discover.cta_buy": "Get License for Teachers",
  "katex.fractions": "Fractions",
  "katex.exponents": "Exponents",
  "katex.subscripts": "Subscripts",
  "katex.roots": "Roots",
  "katex.summation": "Summation",
  "katex.product": "Product",
  "katex.limit": "Limit",
  "katex.integral": "Integral",
  "katex.infinity": "Infinity",
  "katex.pi": "Pi",
  "katex.delta": "Delta",
  "katex.vector": "Vectors",
  "katex.equality": "Equal / Unequal",
  "katex.shortFraction": "Short fraction bar (inline)",
  "katex.scaledBrackets": "Auto-scaling brackets",
  "katex.arrows": "Arrows",
  "katex.sets": "Set symbols",
  "katex.emptysetNumbersets": "Empty set / Number sets",
  "katex.absoluteValue": "Absolute value bars",
  "katex.matrices": "Matrices",
  "katex.systemOfEquations": "Systems of equations",
  "katex.fractionInExponent": "Fraction in exponent",
  "katex.dots": "Dots (continuation)",
  "katex.overline": "Overline (mean)",
  "katex.binomial": "Binomial coefficient",
  "katex.logarithm": "Logarithm",
  "katex.trigonometric": "Trigonometric functions",
  "katex.derivative": "Derivative",
  "katex.partialDerivative": "Partial derivative",
  "katex.gradient": "Gradient",
  "katex.sumWithConditions": "Sum with conditions",
  "katex.textInMath": "Text in math",
  "katex.exponential": "Exponential function",
  "katex.bracketedFraction": "Fraction with brackets",
  "katex.approxIneq": "Approximately equal / Unequal",
  "katex.doubleArrows": "Double arrows (equivalence)",
  "katex.brackets": "Square / Curly brackets",
  "katex.spacing": "Spacing in math mode",
  "katex.enter_equation": "Enter equation (LaTeX)",
  "katex.preview": "Preview",
  "katex.preview.empty": "Once you enter an equation, a preview will appear here.",
  "katex.show_all_tips": "Show all tips",
  "katex.hide_all_tips": "Show fewer tips",
  "info": "Info",
  "error": "Error",
  "success": "Changes saved",
  "generic_created_at": "Created on {{date}}",
  "generic_error": "An error occurred. Please try again.",
  "generic_name": "Name",
  "generic_error_network": "Something went wrong. Please check your internet connection and try again.",
  "generic_slogan": "Annual planning. Weekly planning. Materials.\nOne app. Simple and clear.",
  "generic_back": "Back",
  "generic_confirm": "Confirm",
  "generic_and": "and",
  "generic_save": "Save",
  "generic_cancel": "Cancel",
  "generic_retry": "Retry",
  "generic_delete": "Delete",
  "generic_edit": "Edit",
  "generic_done": "Done",
  "generic_topic": "Folder",
  "generic_topics": "Folders",
  "generic_folder": "Folder",
  "generic_folders": "Folders",
  "generic_sub_folder": "Subfolder",
  "generic_sub_folders": "Subfolders",
  "generic_item": "Material",
  "generic_material": "Material",
  "generic_materials": "Materials",
  "generic_file_name": "File name",
  "generic_file_description": "File description",
  "generic_items": "Materials",
  "generic_title": "Title",
  "generic_continue": "Continue",
  "generic.copy_link": "Copy link",
  "generic_copy": "Copy",
  "generic_add": "Add",
  "generic_next": "Next",
  "generic_close": "Close",
  "generic_course": "Course",
  "generic_courses": "Courses",
  "generic_template": "Collection",
  "generic_duplicate": "Copy",
  "generic_move": "Move",
  "generic_preview": "Preview",
  "generic_form_error_required": "Field is required",
  "homepage_title": "Home",
  "generic_first_name": "First name",
  "generic_first_name_placeholder": "Maria",
  "generic_last_name": "Last name",
  "generic_last_name_placeholder": "Smith",
  "generic_email": "Email address",
  "generic_email_placeholder": "my@email.com",
  "generic_schoolyear": "School year",
  "generic_subject": "Subject",
  "generic_class": "Class",
  "generic_clear_date": "No date",
  "generic_duration": "Duration",
  "generic_duration_in_minutes": "Duration (in minutes)",
  "generic_vacation": "Vacation",
  "generic_choose": "Choose",
  "generic_search": "Search",
  "generic_options": "Options",
  "generic_new_badge": "New!",
  "generic_empty_state": "No data found",
  "generic_substitution": "Substitution",
  "generic_archived": "Deleted",
  "generic_text_copied_to_clipboard": "Text copied to clipboard",
  "generic_select_placeholder": "Choose an option…",
  "generic_upgrade": "Upgrade",
  "generic_class_level": "School level",
  "generic_form_error.not_a_number": "Please enter a number",
  "generic_add_image": "Add image",
  "generic_error_url_invalid": "Invalid URL",
  "generic_sus_long": "Students",
  "generic_n_years": "{{years}} years",
  "generic_create": "Create",
  "generic_beta": "Beta",
  "pro_feature_badge.tooltip": "Feature available during the trial phase or with a paid license",
  "generic_optional": "(optional)",
  "generic_sus_short": "Students",
  "generic_form_error.max_line_length": "Line too long (max. {{maxLength}} characters): \"{{line}}\"",
  "generic_drop_files_here": "Drop your file here",
  "teachino_ai": "Teachino-AI",
  "navigation.timetable": "Timetable",
  "navigation.agenda": "Agenda",
  "navigation.timetable_week": "Weekly timetable",
  "navigation.timetable_list": "List",
  "navigation.library": "Materials",
  "navigation.help": "Help & Feedback",
  "navigation.profile": "Profile",
  "navigation.log_out": "Log out",
  "navigation.imprint": "Legal notice",
  "navigation.terms": "Terms of use",
  "navigation.privacy": "Privacy policy",
  "navigation.courses": "Courses",
  "navigation.status": "Server status",
  "navigation.licenses": "License & upgrade",
  "navigation.ai": "AI",
  "navigation.new_course": "New course",
  "navigation.help_and_support": "Help & support",
  "navigation.feedback": "Feedback",
  "auth_password": "Password",
  "auth_button_login": "Log in",
  "auth_forgot_password": "Forgot password?",
  "auth_signup_tos": "Terms of use",
  "auth_verify_title": "Confirm email",
  "auth_verify_description_1": "Please enter the code we just sent to ",
  "auth_verify_description_2": ".",
  "auth_verify_typo": "Typo?",
  "auth_verify_spam": "Didn't receive code? Check your spam folder.",
  "auth_verify_resend": "Resend email",
  "auth_verify_resend_change": "Change email",
  "auth_verify_resend_save": "Save email",
  "auth_verify_change_error_duplicate": "This email is already registered with Teachino.",
  "auth_verify_change_login": "Log in with password",
  "auth_verify_code_error": "This code is invalid or expired.",
  "auth_verify_code_empty": "Please enter the code you received by email.",
  "auth_verify_code_error_expired": "This code is no longer valid.",
  "auth_verify_code_request_new_code": "Request new code",
  "auth_verify_limit_exceeded": "Too many emails requested in the last minutes. Please wait a moment before requesting more.",
  "auth_new_password": "Choose a password",
  "auth_password_requirement_letter": "a letter",
  "auth_password_requirement_number": "a number",
  "auth_password_requirement_length": "{{number}} characters",
  "auth_reset_code_title": "If {{email}} is registered with Teachino, we sent you a reset code.",
  "auth_reset_password_title": "Enter your email to reset your password.",
  "auth_reset_password_button": "Reset password",
  "auth_reset_password_new_password": "Please choose a new password.",
  "auth_reset_password_code": "Confirmation code",
  "auth_login.title": "Welcome back!",
  "auth.signup_v2.page_title": "Continue with Teachino",
  "auth.signup_v2.trust_privacy": "Data protection compliant",
  "auth.signup_v2.trust_ph_salzburg": "Developed with Salzburg University of Education",
  "auth.signup_v2.role_label": "Role",
  "auth.signup_v2.teacher_section": "I’m a teacher",
  "auth.signup_v2.student_section": "I’m a student",
  "auth.signup_v2.signup_title": "Create your free account",
  "auth.signup_v2.signup_description": "There is no Teachino account for {{email}} yet. Enter your name and choose a password.",
  "auth_login.send_login_link_instead": "Send a login link instead",
  "auth_login.password_required": "Please enter your password.",
  "auth_login.wrong_password": "That password is not correct. Try again or have a login link sent to you instead.",
  "auth.signup_v2.invalid_email": "Enter a valid email address.",
  "auth.signup_v2.name_required": "Enter your first and last name.",
  "auth.signup_v2.password_invalid": "Choose a password that meets all the requirements.",
  "auth.signup_v2.show_password": "Show password",
  "auth.signup_v2.hide_password": "Hide password",
  "auth.signup_v2.code_password_hint": "For your security, please enter your password again.",
  "auth.signup_v2.newsletter_opt_in": "I want to receive useful information about Teachino via email",
  "auth.signup_v2.luxembourg_title": "Are you from Luxembourg?",
  "auth.signup_v2.luxembourg_body": "Teachino is free for you. Log in with IAM to activate your license.",
  "auth.signup_v2.luxembourg_iam_login": "Log in with IAM",
  "auth.signup_v2.luxembourg_without_iam": "Continue without IAM",
  "auth.signup_v2.request_error": "We could not send the code. Please try again later.",
  "auth.signup_v2.or_continue_with": "or sign in through a portal",
  "auth.signup_v2.choose_page_title": "Try Teachino",
  "auth.signup_v2.intent_title": "What would you like to do with Teachino?",
  "auth.signup_v2.intent_description": "Pick everything that interests you.",
  "auth.signup_v2.intent_option_record_grades": "Record grades",
  "auth.signup_v2.intent_option_record_participation": "Record participation",
  "auth.signup_v2.intent_option_plan_lessons": "Plan individual lessons",
  "auth.signup_v2.intent_option_plan_school_year": "Annual planning",
  "auth.signup_v2.intent_option_organize_materials": "Organise materials",
  "auth.signup_v2.intent_option_create_materials": "Create materials",
  "auth.signup_v2.intent_option_use_ai_with_students": "Use AI with students",
  "auth.signup_v2.intent_option_share_with_colleagues": "Share materials with colleagues",
  "auth.signup_v2.intent_skip": "Skip",
  "auth.signup_v2.legal_prefix": "By signing in for the first time, you accept our",
  "auth.signup_v2.code_page_title": "Enter sign-in code",
  "auth.signup_v2.code_title": "Check your email",
  "auth.signup_v2.code_description": "We sent a six-digit code to {{email}}.",
  "auth.signup_v2.code_description_generic": "We sent you a six-digit code by email.",
  "auth.signup_v2.code_label": "Verification code",
  "auth.signup_v2.code_error_invalid": "This code is invalid. Check it and try again.",
  "auth.signup_v2.code_error_expired": "This code has expired. Request a new code.",
  "auth.signup_v2.code_error_network": "We could not verify the code. Please try again.",
  "profile.general.title": "Update personal data",
  "profile.email-subscription.title": "Email notifications",
  "profile.email-subscription.success_message": "Settings saved",
  "profile.email.title": "Update email",
  "profile.password.title": "Update password",
  "profile.password.old_password": "Current password",
  "profile.password.new_password": "New password",
  "profile.password.new_password_2": "Confirm new password",
  "profile.password.wrong_title": "Incorrect password",
  "profile.password.wrong_description": "Please check the current password. The new password was not saved.",
  "profile.password.success_title": "Password changed",
  "profile.password.success_description": "You can now log in with your new password.",
  "auth_login.pending_integration_hint": "Log in once with your e-mail address and password. You can then link {{displayName}} to your Teachino account, and next time signing in with {{displayName}} is enough.",
  "auth_login.code.sent_to": "We sent a login code to {{email}}. Enter it here or click the link in the e-mail.",
  "auth_login.code.sent_generic": "Enter the login code from your e-mail.",
  "profile.password.by_code_hint": "Signed up without a password or forgot your current one? Set a new password with a code we send to your e-mail address.",
  "profile.password.by_code_request": "Send code by e-mail",
  "profile.password.by_code_sent": "We sent a code to {{email}}.",
  "profile.password.by_code_save": "Save password",
  "profile.data.success_title": "Data saved",
  "profile.data.success_description": "Your personal data has been saved.",
  "profile.language": "Language",
  "profile.curriculum.title": "Country and school profile",
  "profile.curriculum.description": "These settings are used to tailor subjects, class levels, and AI results.",
  "profile.curriculum.success_title": "Profile updated",
  "profile.curriculum.success_description": "Country, region, and school type have been saved.",
  "profile.export_library_action": "Start export",
  "profile.export_library": "Export and download materials",
  "profile.export_library_description": "Use this feature to export all materials from your library and download them to your computer.",
  "profile.export_library_tech_details": "For large amounts of data, this export could take minutes or hours. Once ready, you'll receive an email. Export can only be started once every 12 hours.",
  "profile.export_library_success": "Export started! You will receive an email when your data is ready to download.",
  "profile.delete_account.title": "Delete account",
  "profile.delete_account.description": "Permanently delete your Teachino account. All integrations will be disconnected and your account data cannot be restored.",
  "profile.delete_account.action": "Delete account",
  "profile.delete_account.confirm_title": "Delete your account?",
  "profile.delete_account.confirm_description": "This action cannot be undone. Your integrations will be disconnected, you will be logged out and you will receive a confirmation email.",
  "profile.delete_account.confirm_pro_license": "Your individual Pro license will also be terminated when you delete your account.",
  "profile.delete_account.confirm_instruction": "To confirm, enter the email address shown below.",
  "profile.delete_account.email_mismatch": "The email address does not match.",
  "profile.delete_account.reason_question": "Why are you deleting your account?",
  "profile.delete_account.reason_hint": "Your answer is optional and helps us improve Teachino.",
  "profile.delete_account.reason.too_expensive": "Teachino is too expensive for me",
  "profile.delete_account.reason.missing_feature": "A feature I need is missing",
  "profile.delete_account.reason.too_complicated": "Teachino is too complicated for me",
  "profile.delete_account.reason.no_time_or_not_needed": "I don't have time for it or don't need it",
  "profile.delete_account.reason.switched_to_other_tool": "I switched to another tool",
  "profile.delete_account.reason.privacy_concerns": "I have privacy concerns",
  "profile.delete_account.reason.duplicate_account": "I already have another Teachino account",
  "profile.delete_account.reason.other": "Other",
  "profile.delete_account.reason_text_label": "Is there anything else you'd like to tell us?",
  "profile.delete_account.reason_text_placeholder": "Your feedback (optional)",
  "profile.checklist.show": "Show tips on the start page again",
  "profile.checklist.success": "The checklist will appear on the start page again",
  "course_name": "Name",
  "course_short_name": "Short name",
  "course_create_title": "Create new course",
  "course_create_success_title": "{{name}} created!",
  "course_create_color": "Choose color",
  "course_create_char_limit_error": "The course name cannot exceed {{limit}} characters",
  "course_create_short_name_char_limit_error": "Short name cannot exceed {{limit}} characters",
  "course_create_name_required": "Please enter a course name.",
  "course.plan": "Planning",
  "course.page.title": "Your courses",
  "course.page.description": "Create a course for each class and subject you teach. For example: \"8A Geography\".",
  "library.generic_materials": "General materials",
  "library.generic_materials.description": "All materials not assigned to a folder",
  "library.topics.description.title": "Organize materials in folders for better overview.",
  "library.topics.description.description_1": "Open a material and select the appropriate folder in details.",
  "library.topics.description.description_2": "Folders correspond to the school year's sections, e.g., a larger theme or chapter.",
  "library.create_course.title_course": "Create new course",
  "library.create_course.title_template": "Create new collection",
  "library.create_course.title_from_template": "Create course from collection",
  "library.create_course.placeholder_name_course": "e.g., 1A Math",
  "library.create_course.placeholder_short_name_course": "e.g., 1AM",
  "library.create_course.placeholder_name_template": "Geography Department Year 1",
  "library.create_course.button_course": "Create course",
  "library.create_course.button_template": "Create new collection",
  "library.new_items.empty_state.description": "Upload existing materials or create new ones directly in Teachino.",
  "library.items_selected_1": "1 Material",
  "library.items_selected_many": "{{number}} Materials",
  "library.topics_selected_1": "1 Folder",
  "library.topics_selected_many": "{{number}} Folders",
  "library.new_items.empty_state.cta": "Create material",
  "library.all_topics.empty_state.title": "No folders created yet.",
  "library.all_topics.empty_state.description": "Your materials are organized in folders in Teachino. Once you create a folder, it will appear here and can be reused every school year and in every parallel class.",
  "library.all_topics.empty_state.cta": "Create folder",
  "library.search.all_topics.no_results": "Sorry, no results match \"{{search}}\".",
  "library.my_topics": "All folders",
  "library.unsorted_topics": "Unsorted folders",
  "library.unsorted_topics.empty_state.title": "Nice and tidy! 🧹🧽",
  "library.unsorted_topics.empty_state.description_0": "You have no unsorted folders.",
  "library.unsorted_topics.empty_state.description_1": "We love staying organized—and clearly, so do you!",
  "library.topic_details.no_courses": "This folder is not assigned to any course.",
  "library.topic.cannot_bulk_delete.title": "Chapters could not be deleted",
  "library.topic.cannot_bulk_delete.description": "The folder \"{{topic}}\" cannot be deleted.",
  "library.topic.cannot_bulk_duplicate.title": "Chapters could not be duplicated",
  "library.topic.cannot_bulk_duplicate.description": "The folder \"{{topic}}\" cannot be duplicated.",
  "library.sort.default": "Custom order",
  "library.sort.created": "By creation date",
  "library.sort.date": "By date",
  "library.sort.alphabetically": "Alphabetically",
  "course_settings.all_settings": "All settings",
  "course_settings.tabs.general.title": "General settings",
  "course_settings.tabs.general.description": "Name, appearance, collaboration and course status",
  "course_settings.tabs.ai.title": "AI settings",
  "course_settings.tabs.ai.description": "Course context and additional AI instructions",
  "course_settings.tabs.students.description": "Students, access codes and student groups",
  "course_settings.tabs.students.section_description": "Manage students and their access codes",
  "course_settings.details.title": "Details",
  "course_settings.details.sub_title": "Name, short name, color, school year",
  "course_settings.close_title": "Delete course",
  "course_settings.close_description": "Course will no longer be available for planning. Materials can still be accessed via \"Deleted courses\" in the Library.",
  "course_settings.close_warning": "Delete \"{{courseName}}\"?",
  "course_settings.close_button": "Delete course",
  "course_settings.close.success_title": "Course deleted",
  "course_settings.close.success_description": "The course \"{{courseName}}\" has been deleted.",
  "course_settings.collaboration.title": "Collaborate",
  "course_settings.collaboration.sub_title": "Work with other teachers",
  "course_settings.collaboration.description_1": "Teaching is more fun together! Invite your colleagues to share materials and plan lessons together!",
  "course_settings.collaboration.invite.title": "Invite colleagues to {{courseName}}",
  "course_settings.collaboration.invite.cta": "Invite colleagues",
  "course_settings.collaboration.invite.description": "Choose the permissions your colleague should have.",
  "course_settings.collaboration.invite.access.read_only": "Read-only",
  "course_settings.collaboration.invite.access.read_only_description": "Can view the course and copy materials, but cannot edit them.",
  "course_settings.collaboration.invite.access.write": "Edit",
  "course_settings.collaboration.invite.access.write_description": "Can edit shared course materials and collaborate directly in the course.",
  "course_settings.collaboration.invite.role_title": "Invite {{roleName}} to {{courseName}}",
  "course_settings.collaboration.invite.link.title": "Send invitation link",
  "course_settings.collaboration.invite.link.description": "Copy the link and send it to colleagues you wish to collaborate with. The link stays valid for 7 days.",
  "course_settings.collaboration.invite.search.title": "Search colleague",
  "course_settings.collaboration.invite.search.description": "Teachers within the same school license can be invited directly.",
  "course_settings.collaboration.invite.search.cta": "Invite",
  "course_settings.collaboration.invite.search.placeholder": "Enter name to search",
  "course_settings.collaboration.invite.search.success": "Colleague added to course.",
  "course_settings.collaboration.leave.cta": "Leave collaboration",
  "course_settings.collaboration.role.owner": "Owner",
  "course_settings.collaboration.role.teacher": "Editor",
  "course_settings.collaboration.role.teacher_description": "Can edit materials of all members and copy them into their own library.",
  "course_settings.collaboration.role.co_teacher": "Co-editor",
  "course_settings.collaboration.role.co_teacher_description": "Can add and edit own materials. Can copy all folders and materials into their own library.",
  "course_settings.collaboration.role.guest": "Guest",
  "course_settings.collaboration.role.guest_description": "Can view folders and materials and copy them into their own library.",
  "course_settings.collaboration.role.sub_teacher": "Substitute",
  "course_settings.collaboration.remove_teacher": "Remove colleague",
  "course_settings.collaboration.remove_teacher_description": "{{collaboratorName}} will no longer have access to {{courseName}}.",
  "course_settings.collaboration.remove_myself": "Leave collaboration",
  "course_settings.collaboration.remove_myself_description": "You will lose access to {{courseName}} and the materials stored there.",
  "course_settings.collaboration.member_since": "Member since {{date}}",
  "course_invite.title": "{{courseOwner}} invites you to collaborate.",
  "course_invite.description": "With Teachino, you can gather your materials in one place and plan lessons together.",
  "course_invite.accept": "Accept invitation",
  "course_invite.signup_accept": "Create account & accept invitation",
  "course_invite.login_accept": "Log in & accept invitation",
  "course_invite.already_member": "Share the link to this page with your colleagues to plan lessons together.",
  "course_invite.open_course": "Open course",
  "course_invite.open_collection": "Open collection",
  "course_invite.expired": "This link has expired.",
  "course_invite.expired_call_to_action": "Please ask {{courseOwner}} for a new link.",
  "tenant_invite.title": "The teaching platform that thinks alongside you.",
  "tenant_invite.description": "Materials, planning, interactive learning and documentation in one place – connected by an AI assistant that thinks alongside you and supports you.",
  "tenant_invite.accept": "Accept invitation",
  "tenant_invite.signup_accept": "Create account & accept invitation",
  "tenant_invite.login_accept": "Log in & accept invitation",
  "tenant_invite.already_member": "You are already a member of this school.",
  "tenant_invite.continue": "Continue to Teachino",
  "tenant_invite.expired": "This invitation link has expired.",
  "tenant_invite.expired_call_to_action": "Please ask {{tenantName}} for a new link.",
  "course_plan.create_topic": "Create new folder",
  "course_plan.create_material_in_topic": "Create new material in {{topicName}}",
  "course_plan.add_topic": "Add folder",
  "course_plan.add_from_library": "Add folder from another course",
  "course_plan.unorganised_topic": "Materials without a folder",
  "create_item.confirm_delete_snippet": "Material will not be saved!",
  "course_plan.manage_content_button": "Open annual planning",
  "course_plan.empty_state_1": "Start planning",
  "course_plan.empty_state_2": "Choose materials from the course or create new ones.",
  "course_plan.primary_note.title": "Note for this lesson",
  "course_plan.primary_note.mobile.button_empty": "Tap here to note administrative details for this lesson only.",
  "course_plan.items.title": "Lesson materials",
  "course_plan.drag_drop_tutorial": "Drag materials here for the lesson",
  "course_create_topic_placeholder": "Type new folder",
  "topic.name": "Folder name",
  "topic.action.edit": "Edit folder",
  "topic.action.sort": "Sort folder",
  "topic.lesson_goals": "Learning objectives & competencies",
  "topic.lesson_goals.placeholder": "Write something…",
  "topic.delete": "Delete folder and materials",
  "topic.read_only": "🔒 You cannot edit this folder. You can copy materials to another course.",
  "course.settings": "Settings",
  "course.settings_ai": "AI settings",
  "topic_instance.create.create_topic": "Folder",
  "topic_instance.create.create_topic_save": "Create",
  "topic_instance.create.add_to_multiple_courses_closed": "Add to multiple courses",
  "topic_instance.create.add_to_course_0": "Add to a course",
  "topic_instance.create.add_to_course_1": "Add to a course",
  "topic_instance.create.add_to_course_many": "Add to {{number}} courses",
  "topic_instance.create.add_to_course_with_name": "Add to {{course}}",
  "topic_instance.create.add_to_course_disabled": "Add to course",
  "topic_instance.add_course_modal.title": "Add folder to course",
  "topic_instance.add_course_modal.description": "Choose the courses to add {{topic}}:",
  "topic_summary_item_0": "No materials",
  "topic_summary_item_1": "1 Material",
  "topic_summary_item_many": "{{number}} Materials",
  "item.tooltip.past_dates": "Taught on: {{dates}}",
  "item.tooltip.future_dates": "Planned for: {{dates}}",
  "item.menu.make_visible": "Show to students",
  "item.menu.make_not_visible": "Hide from students",
  "item.menu.hidden_for_class": "Hidden from students",
  "item.menu.visible_for_class": "Visible to students",
  "item.menu.item_made_visible": "Material is now visible to students",
  "item.menu.item_made_not_visible": "Material is no longer visible to students",
  "item.menu.edit_item": "Rename material",
  "item.name": "Name",
  "page_title_reset_password": "Reset password",
  "page_title_verify_password": "Verify password",
  "page_title_login": "Login",
  "page_title_logout": "Log out",
  "page_title_signup": "Register",
  "page_title_verify_email": "Verify email",
  "page_title_course_create": "Create course",
  "calendar_week": "CW",
  "edit_note_error": "Could not save note",
  "remove_note_error": "Could not remove note",
  "note_placeholder": "Enter note",
  "weekday_date_picker_reader_text": "Choose date",
  "weekday_move_to": "Move to {{date}}",
  "note_empty_error": "Please add some material to your note",
  "offline_mode": "Offline mode",
  "online_mode": "Online",
  "back_online": "You are back online!",
  "offline_text": "You are offline, functionality is limited.",
  "today": "Today",
  "view_menu_options": "Show menu options",
  "item_detail.duration_heading": "Duration",
  "item_detail.duration.error_le_0": "The minimum duration is one minute",
  "item_detail.add_duration": "Add duration",
  "item_detail.edit_duration": "Edit duration",
  "item_detail.minute_0": "Minutes",
  "item_detail.minute_1": "Minute",
  "item_detail.minute_many": "Minutes",
  "item_detail.confirm_delete_item_pre": "Delete",
  "item_detail.confirm_delete_item_post": "and all associated blocks?",
  "item_detail.force_delete_text_pre": "This material is planned in the following courses:",
  "item_detail.force_delete_text_post": "Do you still want to delete it?",
  "item_detail.file_unacceptable_type": "File type not accepted",
  "item_detail.file_too_large": "File too large",
  "item_detail.file_empty": "Empty files cannot be uploaded.",
  "item_detail.file_changed": "Drawings are not saved. Please use only for presentation!",
  "item_detail.file_start_edit_mode": "Draw",
  "item_detail.file_download": "Download file",
  "item_detail.add_to_lesson": "Add to lesson",
  "item_detail.remove_from_lesson": "Remove from lesson",
  "item_detail.presentation": "Present",
  "item_detail.edit_details": "Edit details",
  "delete_topic.delete_message_pre": "Do you want to",
  "delete_topic.delete_message_post": "remove from this course?",
  "delete_topic.delete_button": "Remove",
  "course_students.share_link": "Student view",
  "course_students.share_item.title": "Share material with students",
  "course_students.access_cards.print_filename_all_students": "All students",
  "course_students.accounts.title": "Students",
  "course_students.accounts.loading": "Loading students…",
  "course_students.accounts.empty": "No students added yet. Add students to give them access to the course.",
  "course_students.accounts.empty_connect_webuntis": "Please connect your course to WebUntis to import students.",
  "course_students.accounts.table.name": "Name",
  "course_students.accounts.table.last_active": "Last active",
  "course_students.privacy_banner.message": "Personal data of students may only be entered once a data processing agreement (DPA) has been signed. Until then, you can try things out with the test students 01-30.",
  "course_students.privacy_banner.austria_message": "To use students' data in Austria, sign in through the Bildungsportal (BIP). Alternatively, your school administration can sign the data processing agreement.",
  "course_students.privacy_banner.connect_bip": "Log in with BIP",
  "course_students.privacy_banner.sign": "Have the school administration sign the DPA",
  "course_students.privacy_banner.learn_more": "Learn more",
  "course_students.privacy_banner.read_more": "Read more",
  "course_students.accounts.table.no_activity": "No activity yet",
  "course_students.accounts.actions.print_code": "Print code",
  "course_students.accounts.actions.regenerate_code": "Regenerate code",
  "course_students.accounts.actions.delete": "Delete",
  "course_students.accounts.actions.print_all": "All students",
  "course_students.accounts.actions.add_students": "Add students",
  "course_students.accounts.actions.copy_access_link": "Copy access link",
  "course_students.accounts.actions.print_access_code": "Print access code",
  "course_students.accounts.actions.rename": "Rename student",
  "course_students.accounts.actions.print_codes": "Print access codes",
  "course_students.accounts.actions.manage_groups": "Manage student groups",
  "course_students.accounts.actions.assign_groups": "Assign",
  "course_students.accounts.import.title": "Synchronize with {{integration}}",
  "course_students.accounts.import.description": "Import students from {{course}}. Existing students remain unchanged.",
  "course_students.accounts.import.action": "Synchronize students",
  "course_students.accounts.import.created": "{{count}} new students imported from {{integration}}.",
  "course_students.accounts.import.no_new": "No new students were found in {{integration}}.",
  "course_students.accounts.import.provider_error": "Students could not be loaded from {{integration}}. Please try again.",
  "course_students.accounts.import.provider_error_eduplaces": "Students could not be loaded from {{integration}}. Please try again. Access to student data must be enabled by the school.",
  "course_students.accounts.import.error": "Students could not be synchronized with {{integration}}.",
  "course_students.accounts.import.source_tag": "From {{integration}}",
  "course_students.accounts.import.new_available": "{{count}} new students can be imported.",
  "course_students.accounts.import.auto_failed": "The course was connected, but the students could not be imported automatically. Retry the sync under \"Edit course\" > \"Manage students\".",
  "course_students.accounts.import.license_missing_title": "Student import not available",
  "course_students.accounts.import.license_missing_description": "Your school needs a Teachino school license that includes student accounts before students can be imported automatically from the connected integration. Contact your school administration or Teachino.",
  "course_students.accounts.import.license_missing_toast": "The course was connected. Students were not imported: your school needs a Teachino school license that includes student accounts.",
  "course_students.accounts.student_code.title": "Access for {{studentName}}",
  "course_students.accounts.add_students.description": "Enter the names of your students – write one name per line.",
  "course_students.accounts.add_students.name_too_long": "A student name may have at most {{maxLength}} characters.",
  "course_students.accounts.add_students.placeholder": "Anna\nBoris\nChris\n…",
  "course_students.accounts.add_students.test_students_intro": "These test accesses will be created:",
  "course_students.accounts.add_students.test_students_kept": "Existing students ({{count}}) stay as they are — their access codes and data do not change.",
  "course_students.accounts.add_students.create_count_one": "Create {{count}} access",
  "course_students.accounts.add_students.create_count_many": "Create {{count}} accesses",
  "course_students.accounts.delete_student.title": "Delete student",
  "course_students.accounts.delete_student.confirm": "Do you really want to delete \"{{studentName}}\"?",
  "course_students.accounts.data_footprint.answers_one": "{{count}} answer",
  "course_students.accounts.data_footprint.answers_many": "{{count}} answers",
  "course_students.accounts.data_footprint.grades_one": "{{count}} grade",
  "course_students.accounts.data_footprint.grades_many": "{{count}} grades",
  "course_students.accounts.data_footprint.notes_one": "{{count}} note",
  "course_students.accounts.data_footprint.notes_many": "{{count}} notes",
  "course_students.accounts.delete_student.data_intro": "This data will be deleted:",
  "course_students.accounts.delete_student.data_unknown": "All submissions, answers and grades will be deleted.",
  "course_students.accounts.delete_student.permanent_hint": "This cannot be undone. You can create the name again afterwards — that access will be empty and have a new code.",
  "course_students.accounts.delete_student.confirm_checkbox": "Yes, I understand that this data will be deleted.",
  "course_students.accounts.delete_student.deleted_toast": "“{{studentName}}” was deleted.",
  "course_students.accounts.preview.description": "This is how students see this material. You can try interactive assignments and chatbots here.",
  "course_students.accounts.visibility.all_students": "All students",
  "course_students.groups.title": "Student groups",
  "course_students.groups.create": "Create student group",
  "course_students.groups.edit": "Edit student group",
  "course_students.groups.delete": "Delete student group",
  "course_students.groups.assign": "Assign student groups",
  "course_students.groups.empty": "No student groups created yet",
  "course_students.groups.empty_in_group": "No students in this student group",
  "course_students.groups.new_group": "New student group",
  "course_students.groups.student_label": "Student",
  "course_students.groups.description": "Create groups for students with similar learning needs, support requirements, or strengths",
  "course_students.groups.create.description": "Create a student group and optionally select the first students right away.",
  "course_students.groups.edit.description": "Adjust the name and color of the student group and choose which students should be members.",
  "course_students.groups.assign.description": "Choose the student groups this student should belong to.",
  "course_students.groups.manage_members.title": "Manage students",
  "course_students.groups.manage_members.description": "Choose which students should be in this student group.",
  "course_students.groups.manage_members.empty": "No students in this course",
  "course_students.groups.assign.empty": "No student groups in this course",
  "course_students.groups.name_placeholder": "e.g. Student group A",
  "course_students.groups.name_placeholder_edit": "e.g. highly motivated, German as a second language",
  "course_students.groups.delete_confirm": "Do you really want to delete the student group \"{{groupName}}\"? The students will not be deleted.",
  "student_accounts.page_title": "Student login",
  "student_accounts.login.code_label": "Code",
  "student_accounts.login.code_placeholder": "XXXXX-XXXXX",
  "student_accounts.login.submit": "Log in",
  "student_accounts.login.heading": "Open materials in Teachino",
  "student_accounts.login.choose_method": "How would you like to continue?",
  "student_accounts.login.received_code": "I received a code from my teacher",
  "course_students.reusable_share.course_title": "Share course link",
  "course_students.reusable_share.course_description": "Share this link or QR code. Students sign in with their personal access code.",
  "course_students.reusable_share.material_title": "Share material link",
  "course_students.reusable_share.material_description": "Share this link or QR code to take students directly to this material after login.",
  "course_students.reusable_share.show_qr_code": "Show QR code",
  "course_students.reusable_share.copy_public_tooltip": "Students can register themselves using this link. They then receive a personal access code.",
  "course_students.reusable_share.copy_code_tooltip": "Students can open this link and sign in with their personal access code.",
  "course_students.reusable_share.qr_description": "This QR code links to the course.",
  "course_students.reusable_share.qr_code_description": "Students can use this QR code to sign in with their personal access code.",
  "course_students.reusable_share.qr_public_description": "Students can use this QR code to register themselves. They then receive a personal access code.",
  "course_students.reusable_share.student_codes": "Your students’ access codes",
  "course_students.reusable_share.material_disabled": "Make the material visible to at least one student before sharing it.",
  "course_students.self_registration.title": "Enable student self-registration",
  "course_students.self_registration.description": "Students open the link and enter their name or initials. They receive a code to access it again later.",
  "course_students.self_registration.toggle_label": "Allow self-registration",
  "course_students.self_registration.link_description": "Send this link to your students.",
  "course_students.self_registration.saved": "Setting saved",
  "course_students.self_registration.material_banner": "Students with this link can create their own account. They will receive an access code to access the course again later.",
  "student_accounts.self_registration.no_code": "I don't have a code yet",
  "student_accounts.self_registration.description": "Enter your name or initials.",
  "student_accounts.self_registration.name_label": "Your name",
  "student_accounts.self_registration.name_placeholder": "Enter your name",
  "student_accounts.self_registration.submit": "Create account",
  "student_accounts.self_registration.error": "The account could not be created. Please try again.",
  "student_accounts.self_registration.code_title": "This is your code",
  "student_accounts.self_registration.code_description": "Keep this code safe. You need it when you come back.",
  "student_accounts.self_registration.code_warning": "Write it down or ask an adult to help you save it.",
  "student_accounts.self_registration.code_teacher_note": "Your teacher can manage codes.",
  "student_accounts.self_registration.continue": "Next",
  "course_students.merge.action": "Merge this duplicate account",
  "course_students.merge.title": "Merge duplicate account",
  "course_students.merge.description": "{{sourceName}} ({{sourceCode}}) will be deleted. Choose the account that should keep the combined data.",
  "course_students.merge.target_label": "Account to keep",
  "course_students.merge.target_placeholder": "Choose the account to keep",
  "course_students.merge.newest_wins_hint": "All data is moved to the selected account. Its name and code stay the same. Where results conflict, the newest value is kept.",
  "course_students.merge.confirm": "Merge and delete duplicate",
  "course_students.merge.success": "{{sourceName}} was merged into {{targetName}}",
  "student_accounts.login.description": "Enter the code you received from your teacher.",
  "student_accounts.login.teacher_cta": "Are you a teacher? Log in here",
  "student_accounts.login.code_invalid": "The code is invalid. Please check it and try again.",
  "student_accounts.login.code_invalid_characters": "The code may only contain letters and numbers.",
  "student_accounts.login.code_length": "The code must be exactly 10 characters",
  "student_accounts.login.error_generic": "An error occurred while logging in. Please try again.",
  "student_accounts.logout.dialog_title": "Your access to Teachino",
  "student_accounts.logout.logged_in_as": "You are logged in as",
  "student_accounts.logout.switch_course_title": "Switch course or log out",
  "student_accounts.logout.switch_course_message": "If you want to access another course or someone else should continue on this device, click Log out. You can log in again later with your personal access code.",
  "student_accounts.access_card.website": "Website",
  "student_accounts.access_card.personal_code": "Personal access code",
  "student_accounts.access_card.code_copied": "Code copied",
  "material.student_visibility.title": "Visibility for students",
  "material.student_visibility.summary_all": "Material visible to all students",
  "material.student_visibility.summary_partial": "Material visible to {{visible}} of {{total}} students",
  "material.student_visibility.toggle_all_hint": "This switch makes the material visible to all students",
  "material.student_visibility.show_for_groups": "Show for students in student groups",
  "material.student_visibility.guest_readonly_hint": "As a guest, you can view visibility but not change it.",
  "course_settings.collaboration.empty": "No teachers invited yet",
  "link.copied.title": "Link copied",
  "link.copied.description": "You can now send the link",
  "emoji.name": "Icon",
  "emoji.title": "Choose icon",
  "emoji.search": "Search",
  "emoji.not_found": "No icon found",
  "emoji.category.search": "Search results",
  "emoji.category.recent": "Useful icons",
  "emoji.category.people": "Smileys & People",
  "emoji.category.nature": "Animals & Nature",
  "emoji.category.foods": "Food & Drink",
  "emoji.category.activity": "Activity",
  "emoji.category.places": "Places",
  "emoji.category.objects": "Objects",
  "emoji.category.symbols": "Symbols",
  "emoji.category.flags": "Flags",
  "emoji.category.custom": "More",
  "emoji.skin.choose": "Choose a default skin tone",
  "emoji.skin.1": "1",
  "emoji.skin.2": "2",
  "emoji.skin.3": "3",
  "emoji.skin.4": "4",
  "emoji.skin.5": "5",
  "emoji.skin.6": "6",
  "emoji.remove": "Remove symbol",
  "action": "Actions",
  "error_page.title": "Something went wrong",
  "error_page.title_404": "Page not found",
  "error_page.button": "Back to homepage",
  "public.empty_material.student": "This material is empty. You'll see content once added by your teacher.",
  "public.hidden_material.student.title": "This material has not been shared with you yet.",
  "public.hidden_material.student.description": "Once your teacher shares it, it will appear in the course overview.",
  "public.logged_in_as": "You are editing the material as {{studentNickname}}. Not you? Click here to log out.",
  "public.recently_shared": "Recently shared",
  "student_course.empty.title": "No materials yet",
  "student_course.empty.description": "Your teacher has not shared anything with you yet. Come back later.",
  "library.empty": "No materials in your library yet.",
  "library.topic_count_0": "No folders",
  "library.topic_details.empty_state": "Fill the folder with materials",
  "library.topic.move_to_folder": "Move to folder",
  "library.topic.move_to_folder.modal.move_one_description": "Move \"{{topic}}\"",
  "library.topic.move_to_folder.modal.move_many_description": "Move {{number}} folders",
  "library.topic.move_to_folder.modal.confirm": "Move to \"{{folder}}\"",
  "library.topic.move_to_folder.toast.success": "Folder moved successfully",
  "library.topic.copy_to_folder": "Copy to folder",
  "library.topic.copy_to_folder.modal.move_one_description": "Copy \"{{topic}}\"",
  "library.topic.copy_to_folder.modal.move_many_description": "Copy {{number}} folders",
  "library.topic.copy_to_folder.modal.confirm": "Copy to \"{{folder}}\"",
  "library.topic.copy_to_folder.toast.success": "Folder copied successfully",
  "library.topic.rename.toast.success": "Folder renamed",
  "library.folder.rename.toast.success": "Folder renamed",
  "library.folder.feature_description": "Organize folders with nested folders",
  "library.topic.goals_updated.toast.success": "Learning objectives saved",
  "library.topic.goals.empty_button": "Enter learning objectives",
  "library.topic.add_to_course": "Add to course",
  "library.topics.add_to_courses.bulk.description": "{{count}} folders will be added to the courses you select.",
  "library.topics.add_to_courses.toast.success": "Folders added to courses",
  "library.topic.courses_school_year_filter": "School year {{schoolYear}}",
  "library.topic.create_with_name": "Create new folder {{name}}",
  "library.topic.create.title": "Create new folder",
  "library.topic.create.label": "Folder name",
  "library.topic.create.button": "Create folder",
  "library.topic.create.error": "Please enter a name for the folder.",
  "library.topic.create.description": "Folders are thematic units, like chapters in a textbook.<br />Next, you can add materials to the folder.",
  "library.topic.create.examples": "<strong>Examples:</strong> \"Pythagorean Theorem\", \"Climate Change\", \"Simple Past\"",
  "library.create_topic.empty_state.title": "Start your first folder now! 📚📝",
  "library.create_topic.empty_state.description": "In Teachino, you organize your materials into folders. Folders serve as overarching themes, e.g., textbook chapters.",
  "library.create_topic.empty_state.input_placeholder": "e.g., \"Formation of Glaciers\" or \"Introduction to the Pythagorean Theorem\"",
  "library.show_archived_courses": "Show deleted courses",
  "library.hide_archived_courses": "Hide deleted courses",
  "library.add_from_library": "Add folder from another course",
  "library.add_from_library_closed_courses": "Deleted courses",
  "library.add_from_library_closed_courses_empty": "Courses from past school years will appear here.",
  "library.add_from_library.header": "{{number}} folders found",
  "library.add_from_library.show_all": "All folders",
  "library.add_from_library.empty_title": "No folders found",
  "library.add_from_library.empty_description": "No suitable folder found in the library. You can create a new one instead.",
  "library.duplicate_item.title": "Copy material",
  "library.move_item.title": "Move material",
  "library.move_item.warning_title": "Warning: Data may be lost!",
  "library.move_item.warning_description": "If this material is already planned in a course, the association with the course and periods is lost!",
  "library.move_item.warning_description_many": "If materials are already planned in a course, the association with the course and periods is lost!",
  "library.duplicate_item.new_name": "New name",
  "library.duplicate_item.new_topic": "New folder",
  "library.duplicate_item.new_name_prefix": "Copy of",
  "library.duplicate_item.success": "Material copied",
  "library.duplicate_topic.title": "Copy folder",
  "library.duplicate_topic.course": "New course / New collection",
  "library.duplicate_topic.success": "Folder copied.",
  "library.template.create_from_template.tooltip": "A new course will be created containing all folders, materials, and settings of this collection.",
  "library.folder_tree.empty_state.description": "Folders provide an additional layer of organization to manage your folders.",
  "library.folder_tree.empty_state.cta": "Create folder",
  "library.folder.empty_state.title": "Empty folder",
  "library.folder.empty_state.description": "\"{{folder}}\" contains no folders yet. Create a new one or move an existing folder into this folder.",
  "library.folder.create": "Create folder",
  "library.folder.name.label": "Folder name",
  "library.folder.delete": "Delete folder",
  "library.folder.delete.folder_not_empty": "Only empty folders can be deleted.",
  "library.folder.delete.please_delete_subfolders": "Please remove all subfolders and folders from \"{{folder}}\"",
  "library.folder.delete.are_you_sure": "Really delete \"{{folder}}\"? This action cannot be undone.",
  "library.folder.rename": "Rename folder",
  "library.folder.convert_to_template": "Convert to collection",
  "library.folder.add_to_course": "Add to course",
  "library.folder.add_to_courses.description": "All folders and materials in \"{{folder}}\", including subfolders ({{count}} folders), will be added to the courses you select.",
  "library.folder.convert_to_template.description": "This creates a new collection containing a copy of all folders and materials in this folder.",
  "library.folder.convert_to_template.name.label": "Collection name",
  "library.folder.convert_to_template.cta": "Create collection",
  "library.folder.convert_to_template.toast.success": "Collection created",
  "library.collection.create_from_topics.button": "Create collection",
  "library.collection.create_from_topics.title": "Create collection",
  "library.collection.create_from_topics.description": "{{count}} units will be copied as separate folders in one collection. Nested library folders are not preserved.",
  "library.collection.create_from_topics.name.label": "Collection name",
  "library.collection.create_from_topics.cta": "Create collection",
  "library.collection.create_from_topics.toast.success": "Collection created",
  "library.collection.create_from_topics.no_eligible_topics": "Select at least one unit. Generic materials cannot be added to a collection.",
  "collection.add_content_menu.import_material": "Add from course",
  "collection.edit": "Edit collection",
  "collection.rename": "Rename collection",
  "collection.name_description": "What should the collection be called?",
  "collection.archive": "Delete collection",
  "collection.archive_description": "The collection will be deleted and all members lose access. Folders & materials used in courses remain available.",
  "collection.archived_toast": "Collection deleted. The collection \"{{collectionName}}\" has been deleted.",
  "navigation.collections": "Collections",
  "collections.my_title": "My collections",
  "collections.shared_title": "Shared with me",
  "collections.create": "Create collection",
  "collections.my.empty_title": "No collections yet",
  "collections.my.empty_description": "Create your first collection to share folders and materials with colleagues and reuse them in courses.",
  "collections.shared.empty_title": "No shared collections",
  "collections.shared.empty_description": "Collections that colleagues invite you to will appear here.",
  "collections.owner_you": "You",
  "collection.name_and_gradient": "Name and appearance",
  "collection.gradient.regenerate": "Regenerate",
  "template.sync.success": "Synced successfully!",
  "template.sync.error": "Synchronization failed.",
  "library.file_upload.choose_files": "Choose files",
  "library.file_upload.drag_here": "Drag files here or",
  "library.file_upload.error": "The file could not be uploaded.",
  "features.timetable.page_timetable": "Timetable",
  "features.timetable.failed_save": "The timetable is incorrect.",
  "timetable.week_not_loaded": "The timetable for this week could not be loaded. Please try again or choose another week.",
  "timetable.integration_not_available_title": "WebUntis unavailable - timetable view limited",
  "timetable.integration_not_available_desc1": "Already planned lessons still appear in the list",
  "timetable.integration_not_available_desc2": "Lessons not planned in Teachino are not shown",
  "timetable.integration_not_available_desc3": "The complete timetable will be automatically displayed once WebUntis is available again",
  "timetable.integration_not_available_desc4": "All materials can always be accessed via \"Courses\" and \"Library\"",
  "timetable_edit.add_period": "Appointment",
  "timetable_edit.create_period_title": "Create appointment",
  "timetable_edit.edit_period_title": "Edit appointment",
  "timetable_edit.period_label": "Description",
  "timetable_edit.period_label_placeholder": "e.g., Meeting, …",
  "timetable_edit.period_label_error": "Enter description",
  "timetable_edit.period_date": "Date",
  "timetable_edit.period_date_time": "Date and time",
  "timetable_edit.period_date_time_error": "Check date and time",
  "timetable_edit.period_date_error": "Please select a date.",
  "timetable_edit.period_time": "Time",
  "timetable_edit.period_note_loading": "Loading note…",
  "timetable_edit.period_note_placeholder": "Note for this course day",
  "timetable_edit.cancel": "Canceled",
  "timetable_edit.cancel_warning_title": "Confirm cancellation",
  "timetable_edit.cancel_warning_description": "Confirm that this period will not take place.",
  "timetable_edit.cancel_warning_confirm": "Cancel period",
  "timetable_edit.uncancel": "Uncancel period",
  "timetable_edit.uncancel_warning_title": "Restore cancelled period",
  "timetable_edit.uncancel_warning_description": "Restore this period to the timetable?",
  "timetable_edit.remove_warning_title": "Delete entry",
  "timetable_edit.remove_warning_description": "Confirm this entry shall be deleted.",
  "timetable_edit.remove_warning_confirm": "Delete entry",
  "timetable.empty_state_header": "Timetable and appointments",
  "timetable.empty_state_description": "Keep an overview of your week and prepare your lessons.",
  "timetable.empty_state_button": "Enter timetable",
  "timetable.edit": "Edit timetable",
  "timetable.edit.choose": "Select a course for this lesson",
  "timetable.edit.choose_create": "Create new course",
  "agenda.empty.description": "No appointments for this course in the selected period. Please create a timetable or single lesson.",
  "agenda.empty.date_range": "Period:",
  "todo_title": "To-dos",
  "todo_item_placeholder": "Enter a to-do",
  "todo_move_to_another_date": "Pick another date",
  "todo_change_course": "Change course",
  "todo_no_course": "No course",
  "todo_page_overdue": "Overdue to-dos",
  "todo_add_date": "Add date",
  "todo_error_fetch": "Error: Could not retrieve to-dos from the server",
  "todo_error_edit": "Error: Could not edit to-do",
  "todo_error_delete": "Error: Could not delete to-do",
  "todo_success_change_date_header": "Date changed",
  "todo_success_change_date_description": "Date set to {{date}}.",
  "course_plan.todo_header": "To-dos for {{date}}",
  "course_plan.note_saved": "Planning saved!",
  "integration.connect_title": "Connect profiles",
  "integration.settings_title": "Integrations",
  "integration.settings_remove": "Disconnect",
  "integration.settings_remove_title": "Disconnect",
  "integration.settings_remove_description": "This disconnects your courses and timetable. Single sign-on will no longer be available. If you haven't set a password, reset it using your email address.",
  "integration.settings_connect": "Connect",
  "integration.settings_coming_soon_cta": "Learn more",
  "integration.disconnected_notice.title": "Connection to {{displayName}} removed",
  "integration.disconnected_notice.description": "{{displayName}} no longer grants Teachino access to your account – either your school switched the integration off or your access was removed. We therefore removed the connection. Your courses and materials in Teachino are kept. As soon as you have access again, you can set the connection up anew.",
  "integration.disconnected_notice.open_settings": "Open integrations",
  "integration.disconnected_notice.dismiss": "Got it",
  "integration.authenticate.header": "Connect {{displayName}} with Teachino",
  "integration.authenticate.integration_profile": "{{displayName}} Profile",
  "integration.authenticate.teachino_profile": "Teachino Profile",
  "integration.authenticate.error_generic": "Error logging in. Open Teachino via app.teachino.io or contact us at hello@teachino.io",
  "integration.authenticate.student_creation_failed": "Your student access could not be created. Please open Teachino from WebUntis again or contact your teacher.",
  "integration.authenticate.redirect_triggered": "Redirecting shortly.",
  "integration.authenticate.not_possible_title": "Already linked to another Teachino account",
  "integration.authenticate.not_possible_description": "This {{displayName}} account is already linked to another Teachino account and cannot be linked to your current account. You can sign out and continue with the linked account, or stay in your current account.",
  "integration.authenticate.login_conflict_title": "You are signed in to a different Teachino account",
  "integration.authenticate.login_conflict_description": "This {{displayName}} account is linked to a different Teachino account than the one you are currently using. To sign in through this integration, sign out of your current Teachino account first.",
  "integration.authenticate.current_account": "Currently signed in: {{email}}",
  "integration.authenticate.sign_out_and_continue": "Sign out and continue with {{displayName}}",
  "integration.authenticate.not_possible_back_link": "Stay in my current account",
  "integration.authenticate.cannot_signup": "You seem to have a Teachino profile. Choose \"I am already using Teachino\" and sign in. Then, link the profile.",
  "integration.authenticate.signup_conflict_description": "You already have a Teachino account. Log in to link it to this integration.",
  "integration.authenticate.create_account": "Create new account",
  "integration.authenticate.help": "For help, contact hello@teachino.io",
  "integration.authenticate.sign_up": "I'm new to Teachino",
  "integration.authenticate.log_in": "I'm already using Teachino",
  "integration.authenticate.successful": "{{displayName}} and Teachino linked!",
  "integration.authenticate.open_teachino_hint": "Please open Teachino at app.teachino.io and log in with your e-mail address and password.",
  "integration.authenticate.open_teachino": "Open Teachino",
  "integration.admininfo.title": "The Teachino integration is active! 👏",
  "integration.admininfo.description": "Teachers now see Teachino in WebUntis and can work with Teachino.",
  "integration.admininfo.explore_title": "1. Get to know Teachino 👀",
  "integration.admininfo.open_website": "Open website",
  "integration.admininfo.try_title": "Try it yourself?",
  "integration.admininfo.try_description": "Log in to WebUntis with a user that has the teacher role and click Teachino. Instead of this page you will then see the lesson planning.",
  "integration.admininfo.inform_title": "2. Inform your colleagues 📣",
  "integration.admininfo.inform_description": "Text template to send by e-mail or messenger",
  "integration.admininfo.mail_text": "Dear colleagues,\nI have just activated the WebUntis integration with Teachino. Teachino uses artificial intelligence to help create materials and gives students AI feedback. You can try Teachino now. More information and a short guide are available at https://help.teachino.io/\nBest regards",
  "integration.admininfo.copy_text": "Copy text and send it",
  "integration.admininfo.copied_title": "Text copied",
  "integration.admininfo.copied_description": "You can now paste the text into your e-mail program and send it.",
  "integration.admininfo.meeting_title": "3. Arrange a video call with Teachino 📆",
  "integration.admininfo.meeting_description": "We are happy to present Teachino in a video call and answer all your questions.",
  "integration.admininfo.schedule": "Choose an appointment",
  "integration.admininfo.contact": "Contact the Teachino team",
  "integration.not_ready.title": "Activate the Teachino integration 🚀",
  "integration.not_ready.description": "Please fill in this form. We will then arrange a short video call to explain the most important features of Teachino and set up the trial with you.",
  "integration.not_ready_student.title": "Teachino is not activated for your school yet.",
  "integration.not_ready_student.description": "As soon as your teacher activates Teachino, you will see lesson materials and much more here.",
  "integration.authenticate_untis.description": "Prepare your lessons based on your WebUntis timetable and transfer your planning to the class register using Teachino.",
  "integration.authenticate_digreg.description": "Prepare lessons based on your timetable from the Digital Register and transfer planning into the class register with Teachino.",
  "integration.authenticate_microsoft.description": "Link files from OneDrive and pages from OneNote with Teachino.",
  "integration.authenticate_bip.description": "Connecting Teachino and the education portal enables auto-login to Teachino.",
  "integration.authenticate_cgie.description": "Connecting Teachino and CGIE allows auto-login and a free license.",
  "integration.settings_connected_with": "Connected with: {{displayName}}",
  "integration.ical.description": "Import timetable entries from an iCal feed and map calendar entry names to Teachino courses on this page.",
  "integration.ical.connect_title": "Connect iCal feed",
  "integration.ical.edit_title": "Edit iCal feed",
  "integration.ical.edit_feed": "Edit link",
  "integration.ical.save_feed": "Save iCal feed",
  "integration.ical.modal_description": "Paste the iCal subscription URL for the calendar you want to show in the timetable.",
  "integration.ical.url_label": "iCal URL",
  "integration.ical.url_placeholder": "https://example.com/calendar.ics",
  "integration.ical.url_required": "Please enter an iCal URL.",
  "integration.ical.mapping_hint": "Use exactly the same calendar entry name for all entries of the same course so the course mapping works correctly.",
  "integration.ical.invalid_feed_url": "Could not connect this feed. Please make sure you pasted the iCal subscription URL, not the calendar page link.",
  "integration.ical.connected_courses.description": "Link Teachino courses with the calendar entries from your calendar.",
  "integration.untis.description": "Link Teachino with WebUntis to sync your timetable and class register. Your school must activate the WebUntis integration. Then open WebUntis and select Teachino.",
  "integration.edupage.description": "Connect Teachino with EduPage to import your timetable and link EduPage subjects to your Teachino courses.",
  "integration.edupage.connect_title": "Connect EduPage timetable",
  "integration.edupage.edit_title": "Edit EduPage timetable",
  "integration.edupage.edit_feed": "Edit EduPage connection",
  "integration.edupage.save_feed": "Save EduPage timetable",
  "integration.edupage.tutorial_step_1": "In EduPage, open \"Teaching\" → \"Events\".",
  "integration.edupage.tutorial_step_2": "Under \"Events\", select \"Timetable\".",
  "integration.edupage.tutorial_step_3": "Select \"Export\", then \"Enable Webcal\".",
  "integration.edupage.tutorial_step_4": "The Webcal URL is now displayed. Copy it and paste it below.",
  "integration.edupage.tutorial_image_alt": "EduPage dialog for enabling Webcal for the timetable",
  "integration.edupage.url_label": "EduPage Webcal URL",
  "integration.edupage.url_placeholder": "https://your-school.edupage.org/webcal?pwd=...",
  "integration.edupage.url_required": "Please enter your EduPage Webcal URL.",
  "integration.edupage.invalid_feed_url": "Could not connect this EduPage timetable. Please check that you pasted the Webcal URL from EduPage.",
  "integration.edupage.connected_courses.description": "Link your Teachino courses with the subjects from your EduPage timetable.",
  "integration.edupage.external_course": "Subject in EduPage",
  "integration.bip.description": "For teachers in Austria: Link Teachino with the education portal.",
  "integration.cgie.description": "For teachers in Luxembourg: Use CGIE's IAM login to use Teachino for free.",
  "integration.digreg.description": "For teachers in South Tyrol: Link Teachino with the Digital Register to sync timetable and class register. Your school needs to activate the integration in the Digital Register.",
  "integration.microsoft.description": "Link your Microsoft profile with Teachino to access your OneNote notebook. Connect specific teams to Teachino courses to access class notebooks.",
  "integration.ical.external_course": "Calendar entry name",
  "integration.teachino.external_course": "Course in Teachino",
  "integration.untis.external_course": "Lesson in WebUntis",
  "integration.digreg.external_course": "Designation in Digital Register",
  "integration.microsoft.external_course": "Team in Microsoft Teams",
  "integration.cgie.connect.title": "Register with Teachino using IAM",
  "integration.cgie.connect.description": "As part of the AI compass, Teachino is available for free to teachers in Luxembourg.",
  "integration.cgie.connect.start": "Start with Teachino",
  "integration.cgie.connect.login": "I'm already using Teachino",
  "integration.cgie.connect.terms_prefix": "Teachino’s",
  "integration.cgie.connect.terms_suffix": "apply as part of the cooperation between Teachino and the SCRIPT. Data is deleted after 24 months of inactivity.",
  "integration.connect_course.title": "Link lesson with Teachino",
  "integration.connect_course.description": "Which Teachino course should \"{{externalCourseName}}\" be linked to?",
  "integration.connect_course.ignore": "Do not show {{courseName}} anymore",
  "integration.connect_course.ignore_confirm": "The lessons of {{courseName}} will also disappear from your timetable. You can undo this at any time under “Edit timetable”.",
  "integration.connect_course.select": "Choose course",
  "integration.connect_course.successful_connect": "Course linked!",
  "integration.connect_course.successful_ignore": "Course hidden!",
  "integration.connect_course.ignore_title": "The course is hidden.",
  "integration.connect_course.ignore_restore": "Show {{courseName}} again",
  "integration.course_connected.description": "{{externalCourseName}} is linked with {{internalCourseName}} in Teachino.",
  "integration.connect_course.create": "Create {{courseName}}",
  "integration.connect_course.header": "How should {{courseName}} appear in Teachino?",
  "integration.connect_course.new": "As a new course",
  "integration.connect_course.connect": "or link with an existing course",
  "integration.settings.connected_courses.description": "Link your Teachino courses for data synchronization.",
  "integration.settings.course_ignored": "Hidden",
  "integration.settings.remove_course_title": "Remove link",
  "integration.settings.course_not_connected": "Not linked",
  "integration.settings.course_connect": "Link course",
  "integration.export_classregister.title": "Write teaching content to the class register",
  "integration.export_classregister.send_to_classregister": "Write to class register",
  "integration.export_classregister.send_to_classregister_successfull": "Class register filled",
  "integration.export_classregister": "Class register",
  "integration.export_classregister.copy": "Copy text",
  "integration.export_classregister.copy_success_title": "Text copied to clipboard",
  "onboarding_tutorial.enter_courses_description_1": "Please create a course for each subject and class you teach. If you teach two subjects in a class, create two courses.",
  "onboarding_tutorial.enter_courses_more_lines": "Add another course",
  "onboarding_tutorial.enter_courses_button": "Start with Teachino",
  "onboarding_tutorial.enter_courses_extra_note": "You can create more courses and change colors later.",
  "onboarding_tutorial.enter_courses_placeholder_1": "Geography",
  "onboarding_tutorial.enter_courses_placeholder_2": "History",
  "onboarding_tutorial.enter_courses_placeholder_3": "History",
  "feature_course.onboarding.subject.other_lesson_language_label": "Lesson language",
  "feature_course.onboarding.subject.other_lesson_language_placeholder": "Enter lesson language",
  "feature_course.onboarding.subject.default_course_language": "English",
  "feature_course.onboarding.integration.action.import_courses": "Import courses",
  "feature_course.onboarding.integration.connecting.title": "Importing your courses …",
  "feature_course.onboarding.integration.connecting.progress": "{{done}} of {{total}} courses processed",
  "feature_course.onboarding.integration.partial_error": "Some courses could not be connected automatically. You can connect them from the courses page at any time.",
  "item_detail.teachino_ai_questions": "Questions",
  "item_detail.teachino_ai_questions.reproduction.title": "Reproduction",
  "item_detail.teachino_ai_questions.reproduction.description": "Reproduction of facts",
  "item_detail.teachino_ai_questions.reorganisation.title": "Reorganization",
  "item_detail.teachino_ai_questions.reorganisation.description": "Self-explaining, editing, and organizing",
  "item_detail.teachino_ai_questions.reflection.title": "Reflection",
  "item_detail.teachino_ai_questions.reflection.description": "Interpreting and evaluating, recognizing connections, solving problems",
  "ai_setting.language": "In which language should the AI generate results?",
  "ai_setting.description": "These settings influence the suggestions from Teachino-AI. The AI considers these settings and the materials used.",
  "ai_setting.curriculum_other": "Enter custom curriculum",
  "ai_setting.age": "How old are the students for whom the AI results are intended approximately?",
  "ai_settings.age_placeholder": "Age of students in years",
  "ai_setting.subject": "Specify the subject as accurately as possible",
  "ai_setting.curriculum": "Syllabus / curriculum",
  "ai_setting.curriculum_country": "Country",
  "ai_setting.curriculum_state": "Region",
  "ai_setting.curriculum_name": "School type",
  "ai_setting.curriculum_description": "Copy the syllabus, core curriculum, or school curriculum into the text field. The Teachino-AI can reference this. This text can be up to 18,000 characters long and should only contain relevant areas for the grade/subject.",
  "ai_setting.curriculum_placeholder": "You can paste the entire text unformatted here",
  "ai_setting.curriculum_maxlength": "The syllabus / curriculum must not exceed {{max_length}} characters. Longer text will be truncated.",
  "ai_setting.curriculum.school_type": "School type",
  "ai_setting.curriculum.subject": "Subject",
  "ai_setting.curriculum.class_level": "Class level / Grade",
  "ai_setting.curriculum.disclaimer": "<strong>Your syllabus isn't listed?</strong> No problem! Just choose <strong>\"enter custom curriculum\"</strong>, copy your syllabus, and input it in the designated text field. <strong>Need help or have questions?</strong> Visit our <a class=\"underline text-primary-500\" href=\"https://www.teachino.io/help#faq\" target=\"_blank\">help page</a>.",
  "ai_setting.checkmarks.age": "Students' age",
  "ai_setting.checkmarks.subject": "Subject",
  "ai_setting.checkmarks.language": "Language of instruction",
  "ai_setting.checkmarks.curriculum_available": "Curriculum available",
  "ai_setting.cta_settings.description": "No AI settings entered for this course yet. Enter age, subject, curriculum,… to improve results.",
  "ai_setting.cta_settings.button": "Enter data",
  "ai_setting.cta_curriculum.description": "For even better results, upload your curriculum.",
  "ai_setting.cta_curriculum.button": "Enter curriculum",
  "ai.error.cta": "Restart",
  "ai.name": "Thena – Your personal AI assistant",
  "ai.assistant.title": "AI assistant",
  "material.ai.create.quick_actions_label": "Generate with AI:",
  "ai.assistant.new_chat": "New chat",
  "ai.assistant.open": "Open chat",
  "ai.assistant.launcher.tooltip": "Open AI assistant",
  "ai.assistant.period_context.date_only": "Teacher is viewing the lesson on {{formattedDate}}. New materials created here should be planned for {{planningTargetDate}}.",
  "ai.assistant.period_context.pill_date_only": "{{formattedDate}}",
  "ai.assistant.composer.remove_period_context": "Remove lesson context",
  "ai.assistant.generated_material.open_conversation": "Open in assistant",
  "ai.assistant.generated_material.open_when_ready": "The material is currently being generated by AI. Once it is ready, you can open the material.",
  "ai.assistant.generated_material.created_in_folder": "Created in folder {{folderName}}",
  "ai.assistant.generated_material.target_folder_label": "Folder: {{folderName}}",
  "ai.assistant.generated_material.prompt_label": "Generation prompt used",
  "ai.material.approval.tag_create": "Review material",
  "ai.material.approval.tag_rework": "Rework needs review",
  "ai.material.approval.banner_create_title": "AI created this material",
  "ai.material.approval.banner_create_description": "Review the content and approve the change, or edit the material.",
  "ai.material.approval.banner_rework_title": "AI updated this material",
  "ai.material.approval.banner_rework_description": "Review the changes and approve them, or edit the material.",
  "ai.material.approval.approve_button": "Reviewed",
  "ai.assistant.close": "Close",
  "ai.assistant.back_to_start": "Back to start",
  "ai.assistant.back_to_chat": "Back to chat",
  "ai.assistant.mode_fullscreen": "Fullscreen",
  "ai.assistant.mode_sidebar": "Sidebar",
  "ai.assistant.mode_floating": "Floating",
  "ai.assistant.display_mode": "Chat display",
  "ai.assistant.expand": "Expand",
  "ai.assistant.collapse": "Collapse",
  "ai.assistant.history.title": "Chat history",
  "ai.assistant.history.recent": "Recent conversations",
  "ai.assistant.history.conversation": "Conversation",
  "ai.assistant.history.delete": "Delete conversation",
  "ai.assistant.history.show": "Show all",
  "ai.assistant.history.load_more": "Show more",
  "ai.assistant.history.loading_recent": "Loading recent conversations…",
  "ai.assistant.history.just_now": "Just now",
  "ai.assistant.history.minutes_ago": "{{count}} min ago",
  "ai.assistant.history.hours_ago": "{{count}}h ago",
  "ai.assistant.history.days_ago": "{{count}}d ago",
  "ai.assistant.history.needs_confirmation": "Needs confirmation",
  "ai.assistant.history.running": "Response in progress",
  "ai.assistant.history.unread": "New unread messages",
  "ai.assistant.suggestions.title": "Suggestions",
  "ai.assistant.suggestion.lesson.title": "Plan a lesson",
  "ai.assistant.suggestion.lesson.prompt": "Help me plan my next lesson for this course.",
  "ai.assistant.suggestion.material.title": "Create material",
  "ai.assistant.suggestion.material.prompt": "Create a differentiated worksheet for my next lesson on the topic: ",
  "ai.assistant.suggestion.material.question": "What should the material be about?",
  "ai.assistant.suggestion.material.suggest_prompt": "Create a differentiated worksheet for my next lesson.",
  "ai.assistant.suggestion.support.title": "Support students",
  "ai.assistant.suggestion.support.prompt": "Suggest ways to support students who are struggling.",
  "ai.assistant.suggestion.reflect.title": "Reflect on class",
  "ai.assistant.suggestion.reflect.prompt": "Help me reflect on today's class and plan next steps.",
  "ai.assistant.messages.load_earlier": "Load earlier messages",
  "ai.assistant.message.copy": "Copy",
  "ai.assistant.message.helpful": "Helpful",
  "ai.assistant.message.not_helpful": "Not helpful",
  "ai.assistant.message.feedback_received": "Thanks for your feedback.",
  "ai.assistant.message.sending": "Sending",
  "ai.assistant.message.failed": "Not sent. Your text has been restored.",
  "ai.assistant.message.show_more": "Show more",
  "ai.assistant.message.show_less": "Show less",
  "ai.assistant.message.link_redirect_limit": "We couldn’t open this link because it redirects too many times. Try the final page URL or upload the document.",
  "ai.assistant.attachment.unreadable": "File could not be read",
  "ai.assistant.attachment.unreadable_hint": "The content of this file could not be extracted, so the AI assistant cannot use it. Paste the text directly or upload the file again as a PDF or image.",
  "ai.assistant.composer.add_source": "Add source",
  "ai.assistant.composer.attachment_limit": "You can add up to {{count}} sources per message.",
  "ai.assistant.composer.remove_material_context": "Remove material context",
  "ai.assistant.composer.placeholder": "Ask the AI assistant…",
  "ai.assistant.course_selection.section_title": "Courses this school year",
  "ai.assistant.course_selection.loading": "Loading courses…",
  "ai.assistant.course_selection.error": "Could not load courses",
  "ai.assistant.course_selection.empty": "No courses available",
  "ai.assistant.course_selection.select_course": "Select a course",
  "ai.assistant.course_selection.continue": "Select a course to continue",
  "ai.assistant.course_selection.setup_required": "Setup required",
  "ai.assistant.course_selection.owner_setup_required": "The course owner must complete the course settings",
  "ai.assistant.course_setup.banner.description": "Add subject and class for better results",
  "ai.assistant.course_setup.banner.action": "Complete AI settings",
  "ai.assistant.course_selection.selected": "Course selected",
  "ai.assistant.user_selection.other": "Something else",
  "ai.assistant.user_selection.selected": "Selected",
  "ai.assistant.user_selection.other_placeholder": "Enter your own answer…",
  "ai.assistant.user_selection.submit": "Send answer",
  "ai.assistant.topic_question.suggest": "Show suggestions",
  "ai.assistant.topic_question.subject_label": "My subject",
  "ai.assistant.topic_question.subject_placeholder": "Enter a subject…",
  "ai.assistant.topic_question.submit": "Send subject",
  "ai.assistant.composer.send": "Send message",
  "ai.assistant.run.stop": "Stop response",
  "ai.assistant.stream.connecting": "Connecting",
  "ai.assistant.stream.reconnecting": "Reconnecting",
  "ai.assistant.tool.working": "Working…",
  "ai.assistant.tool.search_images": "Searching for suitable images…",
  "ai.assistant.tool.read_product_guidance": "Checking available app actions…",
  "ai.assistant.tool.search_help_center": "Searching the help center…",
  "ai.assistant.tool.read_help_article": "Reading help article…",
  "ai.assistant.tool.search_web": "Searching the web…",
  "ai.assistant.tool.search_wikipedia": "Searching Wikipedia…",
  "ai.assistant.tool.search_youtube": "Searching YouTube…",
  "ai.assistant.tool.load_youtube_transcript": "Reading video transcript…",
  "ai.assistant.tool.load_webpage": "Reading webpage…",
  "ai.assistant.tool.list_courses": "Loading courses…",
  "ai.assistant.tool.list_course_content": "Reading course content…",
  "ai.assistant.tool.search_course_materials": "Searching course materials…",
  "ai.assistant.tool.load_materials": "Loading materials…",
  "ai.assistant.tool.read_course_timetable": "Checking timetable…",
  "ai.assistant.tool.read_course_planning": "Checking lesson planning…",
  "ai.assistant.tool.read_students": "Loading students…",
  "ai.assistant.tool.read_student_documentation": "Reading student documentation…",
  "ai.assistant.tool.create_course_materials": "Creating materials…",
  "ai.assistant.tool.edit_course_material": "Editing material…",
  "ai.assistant.tool.convert_worksheet": "Converting worksheet…",
  "ai.assistant.tool.create_course_folders": "Creating folders…",
  "ai.assistant.tool.create_todo": "Creating todo…",
  "ai.assistant.tool.mark_todos_done": "Completing todos…",
  "ai.assistant.tool.add_lesson_note": "Adding lesson note…",
  "ai.assistant.tool.add_period_tags": "Adding period tags…",
  "ai.assistant.tool.create_student_documentation": "Creating student documentation…",
  "ai.assistant.tool.set_material_visibility": "Updating material visibility…",
  "ai.assistant.tool.plan_materials_for_date": "Planning materials…",
  "ai.assistant.tool.remove_materials_from_date": "Removing materials from date…",
  "ai.assistant.tool.move_course_content": "Moving course content…",
  "ai.assistant.tool.copy_course_content": "Copying course content…",
  "ai.assistant.tool.request_user_selection": "Preparing options…",
  "ai.assistant.tool.request_course_selection": "Preparing course selection…",
  "ai.assistant.action.default_title": "Action",
  "ai.assistant.action.discarded": "Discarded",
  "ai.assistant.error.response": "Something went wrong. Please try again.",
  "ai.assistant.context.current_course": "Current course",
  "ai.assistant.context.current_folder": "Current folder",
  "ai.assistant.context.current_material": "Current material",
  "ai.assistant.context.course": "Course",
  "ai.assistant.context.material": "Material",
  "ai.assistant.job.cancel": "Cancel generation",
  "ai.assistant.job.cancel_all": "Cancel all",
  "ai.assistant.job.review": "Review",
  "ai.assistant.job.stage.create.planning": "Checking and planning your request",
  "ai.assistant.job.stage.create.creating": "Writing the content",
  "ai.assistant.job.stage.create.preparing": "Creating images and preparing the material",
  "ai.assistant.job.stage.rework.planning": "Checking and planning the revision",
  "ai.assistant.job.stage.rework.creating": "Revising the material",
  "ai.assistant.job.stage.rework.preparing": "Working in and preparing the changes",
  "ai.assistant.job.stage.conversion.planning": "Reading the worksheet",
  "ai.assistant.job.stage.conversion.creating": "Converting the tasks",
  "ai.assistant.job.stage.conversion.preparing": "Preparing the material",
  "ai.assistant.job.stage.saving": "Saving the material",
  "ai.assistant.job.progress.queued": "In the queue",
  "ai.assistant.job.progress.step": "Step {{step}} of {{stepCount}} · {{stage}}",
  "ai.assistant.job.progress.elapsed": "running for {{duration}}",
  "ai.assistant.job.progress.patience_hint": "This usually takes 1–2 minutes. Keep working if you like – we'll let you know as soon as the material is ready.",
  "ai.assistant.job.ready.image_omissions": "Ready – image notice",
  "ai.assistant.job.image_omissions": "An image could not be included. The material is available.",
  "ai.assistant.job.image_required_missing": "At least one requested image is missing. The material is available.",
  "ai.assistant.job.image_optional_details": "Additional image omitted – image search details",
  "ai.assistant.job.image_details": "Why is the image missing?",
  "ai.assistant.job.image_reason.no_suitable_candidate": "The image search did not yield a suitable, verified candidate.",
  "ai.assistant.job.image_reason.search_unavailable": "The image service was unavailable during this search.",
  "ai.assistant.job.image_reason.verification_unavailable": "The image's suitability could not be reliably verified.",
  "ai.assistant.job.image_reason.generation_failed": "The image could not be successfully created or saved.",
  "ai.assistant.job.image_reason.omitted_from_output": "An intended image was not included in the finished material.",
  "ai.assistant.job.image_reason.not_attempted": "Generation finished without the requested image; no image attempt was recorded.",
  "ai.assistant.job.ready.title": "Ready to open",
  "ai.assistant.job.failed.title": "Generation failed",
  "ai.assistant.job.ready.toast": "“{{title}}” is ready",
  "ai.assistant.job.ready.toast_many": "{{count}} materials are ready",
  "ai.assistant.job.ready.badge_aria_zero": "No finished materials in the AI assistant",
  "ai.assistant.job.ready.badge_aria_one": "1 finished material in the AI assistant",
  "ai.assistant.job.ready.badge_aria_many": "{{number}} finished materials in the AI assistant",
  "ai.assistant.job.open_material": "Open material",
  "ai.assistant.job.open_preview": "Open material preview",
  "ai.personification": "Thena – Your AI Assistant",
  "ai.you": "You",
  "ai.prompt.placeholder": "How can I assist you today?",
  "ai.prompt.continue": "Type your reply…",
  "ai.prompt.hint.1": "Translate the result",
  "ai.prompt.hint.1_prompt": "Translate the result to ",
  "ai.prompt.hint.2": "Shorten the result",
  "ai.prompt.hint.2_prompt": "Shorten the result",
  "ai.prompt.hint.3": "Lengthen the result",
  "ai.prompt.hint.3_prompt": "Lengthen the result",
  "ai.prompt.hint.4": "Simplify the result",
  "ai.prompt.hint.4_prompt": "Simplify the result to A2 level",
  "ai.prompt.hint.5": "What else could I do?",
  "ai.prompt.hint.5_prompt": "Give me five short AI prompt suggestions for further text result processing.",
  "ai.tasks.show_more": "Show more",
  "ai.tasks.show_less": "Show less",
  "ai.disclaimer": "AI can make mistakes. Do not enter personal data.",
  "ai.disclaimer_students": "This chat is AI-driven. Responses are AI-generated and might be inaccurate. Maintain a critical view and verify as needed. Avoid sharing personal info. Enjoy chatting!",
  "ai.area_youtube_error.description": "Thena couldn’t read the subtitles. Please copy them into the text box below for Thena to generate materials.",
  "ai.area_youtube.title": "AI for videos",
  "ai.area_youtube.description": "Thena reads video subtitles and generates corresponding materials. Just input the video link. Thena can't read videos without subtitles yet.",
  "ai.area_youtube.label": "YouTube video link",
  "ai.area_youtube.error": "Please provide a valid YouTube video link.",
  "ai.area_youtube.iframe_error": "Error displaying the video",
  "ai.area_docs.title": "AI for documents",
  "ai.area_docs.description": "Thena reads texts in documents and creates related materials.",
  "ai.area_docs.types": "Supported files:",
  "ai.area_websites.title": "AI for websites",
  "ai.area_websites.description": "Thena reads text on a webpage and generates related materials.",
  "ai.area_text.title": "AI for texts",
  "ai.area_text.description": "Thena reads the entered text and creates related materials. You can also upload video subtitles as text.",
  "ai.area_images.title": "AI for images",
  "ai.area_images.description": "Thena recognizes and reads text in photos and generates corresponding materials.",
  "ai.course_settings_age_missing.before": "(Tip: Enter your students' age in the",
  "ai.course_settings_age_missing.label": "course settings",
  "ai.course_settings_age_missing.after": ", to save it for future chats. The more I know about your course, the better my answers will be.) ",
  "onboarding_tutorial.enter_courses_header": "Final step: Create courses",
  "library.title": "Materials & folders",
  "library.new_items": "New materials",
  "library.search_hint": "Enter at least 3 characters",
  "library.add_dates": "Start and end dates",
  "library.add_dates_placeholder": "Select start and end dates",
  "library.remove_dates": "Delete period",
  "library.remove_topic": "Delete \"{{topic}}\"?",
  "library.remove_course_topic": "Remove \"{{topic}}\" from course?",
  "library.remove_item": "Delete \"{{item}}\"?",
  "library.remove_topics": "Delete {{number}} folders?",
  "library.remove_course_topics": "Remove {{number}} folders from course?",
  "library.remove_items": "Delete {{number}} materials?",
  "library.remove_topic.confirm": "Delete {{topic}}",
  "library.remove_course_topic.confirm": "Remove {{topic}} from course",
  "library.remove_topics.confirm": "Delete folder",
  "library.remove_course_topics.confirm": "Remove folder from course",
  "library.remove_item.confirm": "Delete {{item}}",
  "library.remove_items.confirm": "Delete {{number}} materials",
  "library.remove_topic_pre": "Do you want to",
  "library.remove_course_topic_pre": "Do you want to",
  "library.remove_topic_post": "delete permanently? This will permanently delete the folder and all contained materials.",
  "library.remove_course_topic_post": "remove from the course? All planning data will be lost. The topic remains in the library.",
  "library.remove_item_pre": "Do you want to",
  "library.remove_item_post": "delete permanently? The materials will be permanently deleted.",
  "library.remove_topics.description": "Do you wish to permanently delete {{number}} folders? This will permanently delete the folders and all contained materials.",
  "library.remove_course_topics.description": "Do you want to remove {{number}} folders from the course?",
  "library.remove_items.description": "Do you wish to permanently delete {{number}} materials? The materials will be permanently deleted.",
  "library.remove_topic_force_pre": "The folder ",
  "library.remove_item_force_pre": "The material ",
  "library.remove_topic_force_post": "is used in the (open) courses ",
  "library.remove_item_force_post": "is used in the (open) courses ",
  "library.remove_topic_force_end": ". Do you want to delete it and all its materials and remove all associated past and future planning?",
  "library.remove_item_force_end": ". Do you want to delete the material and remove all associated past and future planning?",
  "library.remove_topics_force_pre": "The folders are used in the (open) courses ",
  "library.remove_items_force_pre": "The materials are used in the (open) courses ",
  "library.remove_topics_force_end": ". Do you want to delete them and all their materials and remove all associated past and future planning?",
  "library.remove_items_force_end": ". Do you want to delete the materials and remove all associated past and future planning?",
  "library.remove_item.success_one": "Material deleted",
  "library.remove_item.success_many": "Materials deleted",
  "upgrade.discover.cta_school": "Request school license",
  "upgrade.discover.cta_school_extend": "Extend school license",
  "upgrade.license_page.title_0": "Your current licenses",
  "upgrade.license_page.title_1": "Your current license",
  "upgrade.license_page.title_many": "Your current licenses",
  "upgrade.license_page.upgrade.personal_licenses": "Personal License",
  "upgrade.license_page.upgrade.tenant_licenses": "School License",
  "upgrade.license_page.license_started_at": "Started on:",
  "upgrade.license_page.license_renews_at": "Renews on:",
  "upgrade.license_page.license_expires_at": "Expires on:",
  "upgrade.license_page.license_expired_at": "Expired on:",
  "upgrade.license_page.license_id": "License Number:",
  "upgrade.license_page.pro_offer_title": "License for Teachers",
  "upgrade.license_page.pro_offer_subtitle": "Everything you need for your teaching – without limits, from planning to feedback.",
  "upgrade.license_page.features": "Included Features",
  "upgrade.license_page.manage": "Manage",
  "upgrade.license_page.upgrade_school.title": "License for Schools",
  "upgrade.license_page.upgrade_school.subtitle": "One shared system for digital teaching across your entire school",
  "upgrade.license_page.free_license_label": "Free license",
  "upgrade.license_page.dpa_signed": "DPA signed",
  "upgrade.license_page.student_data_can_be_managed": "Students' data can be managed",
  "upgrade.license_page.trainee_discount": "🌱 Trainees save on <strong>License for Teachers</strong>",
  "upgrade.license_page.legal_billing": "Your subscription automatically renews for the selected term. Cancel up to 24 hours in advance, effective at the end of the term. <a href=\"/legal/terms\" target=\"_blank\" class=\"underline\">Details in the terms of use</a>",
  "upgrade.license_page.school_perk_pro": "Everything from the License for Teachers for 5 or more teachers",
  "upgrade.feature.files_unlimited": "Unlimited storage (up to 50 MB per file)",
  "upgrade.feature.files_restricted": "250 MB storage space",
  "upgrade.feature.daily_changes": "Daily timetable changes (cancellations, substitutions, holidays, personal appointments, …)",
  "upgrade.feature.collaboration_teamteaching": "Team teaching in courses",
  "upgrade.feature.collaboration_course_templates": "Collaborate and create collections",
  "upgrade.feature.collaboration_substitutions": "Share materials & plans with substitutes",
  "upgrade.feature.student_access": "Access for students",
  "upgrade.feature.ai_basic": "Simple AI suggestions",
  "upgrade.feature.ai_advanced": "Advanced AI suggestions referencing materials and curriculum",
  "upgrade.feature.integration_timetable": "Integration with timetable & class register",
  "upgrade.feature.presentation": "Presentation mode",
  "upgrade.feature.ai_curriculum_title": "More accurate results with curriculum reference",
  "upgrade.feature.ai_curriculum_description": "With a Pro license or a school license, you can upload a school curriculum or choose from predefined curricula. This makes AI results more accurate and high-quality.",
  "upgrade.plan.teacher_pro": "Teacher Pro",
  "upgrade.plan.teachino_school": "License for Schools",
  "upgrade.plan.cgie_pro": "License under the AI-Compass by Script.",
  "upgrade.plan.teacher_free": "Free",
  "upgrade.plan.teacher_free_light": "Free",
  "upgrade.plan.school_dpa_only": "DPA signed",
  "upgrade.plan.type.friends": "Teachino Friends & Family",
  "upgrade.plan.teachino_school_complete": "License for Schools incl. AI Package",
  "upgrade.plan.teachino_school_trial": "License for Schools - Trial License",
  "upgrade.plan.teachino_school_expired": "License for Schools - License Expired",
  "upgrade.plan.teachino_school_suedtirol": "Teachino School South Tyrol",
  "upgrade.plan.teachino_pro_ai": "Teacher Pro incl. AI Package",
  "upgrade.plan.teachino_school_complete_trial": "License for Schools incl. AI Package",
  "upgrade.plan.teacher_pro_trial": "License for Teachers",
  "upgrade.plan.teacher_pro_beta": "Teachino Friends & Family",
  "upgrade.plan.type.paid": "Paid",
  "upgrade.plan.type.free": "Free",
  "upgrade.plan.type.trial": "Free Trial",
  "upgrade.plan.type.expired": "License Expired",
  "upgrade.upgrade_required.title": "Upgrade Required!",
  "upgrade.upgrade_required.description": "This feature is only available with the License for Teachers.",
  "upgrade.upgrade_required.description_2": "Upgrade now and enjoy full functionality!",
  "upgrade.page.pricing_heading": "Choose your billing period",
  "upgrade.usp.3": "Personal appointments, to-dos & vacations",
  "upgrade.feature.personal_planning.description": "Manage personal appointments, to-dos, and vacations in your planning.",
  "upgrade.page.feature.storage.description": "Unlimited storage for all your teaching materials.",
  "upgrade.page.feature.student_share.description": "Share access to Teachino with students via link or QR code.",
  "upgrade.page.feature.class_register.description": "Transfer planned teaching content directly to your class register (WebUntis/Digital Register).",
  "upgrade.usp.4": "Integration with WebUntis",
  "upgrade.plan.cta": "Upgrade now",
  "difusion.teacher_dashboard.title": "Teacher Dashboard",
  "difusion.teacher_dashboard.select_class": "Select a class",
  "difusion.teacher_dashboard.students": "Students",
  "difusion.teacher_dashboard.reload": "Reload",
  "difusion.teacher_dashboard.export_csv": "Export CSV",
  "difusion.teacher_dashboard.try_leo": "Try LEO",
  "difusion.teacher_dashboard.loading_classes": "Loading classes…",
  "difusion.teacher_dashboard.loading_students": "Loading students…",
  "difusion.teacher_dashboard.error": "Error",
  "difusion.teacher_dashboard.invalid_session": "Invalid session. Please log in again.",
  "difusion.teacher_dashboard.load_students_error": "Error loading students",
  "difusion.teacher_dashboard.no_classes": "No classes available",
  "difusion.teacher_dashboard.no_students": "No students found for this class",
  "difusion.teacher_dashboard.surname": "SURNAME",
  "difusion.teacher_dashboard.name": "NAME",
  "difusion.teacher_dashboard.status": "STATUS",
  "difusion.teacher_dashboard.completed_conversations": "COMPLETED CONVERSATIONS",
  "difusion.teacher_dashboard.last_activity": "LAST ACTIVITY",
  "difusion.teacher_dashboard.chat_history": "CHAT HISTORY",
  "difusion.teacher_dashboard.class_id": "Class ID",
  "difusion.teacher_dashboard.status.not_started": "Not started",
  "difusion.teacher_dashboard.status.in_progress": "In progress",
  "difusion.teacher_dashboard.status.completed": "Completed",
  "difusion.teacher_dashboard.class_fallback": "Class {{number}}",
  "embed.error.no_auth": "Login failed",
  "embed.error.no_account": "Please access Teachino via the main menu (left) to start. Once registered, you'll see the planned materials for the lesson here.",
  "embed.error.no_course_mapping": "The materials for this lesson are only visible to teachers teaching or substituting this lesson.",
  "embed.error.no_course_found": "No materials have been shared for this course in Teachino.",
  "embed.error.no_course_found_description": "Teachers can prepare digital lessons and provide materials with Teachino.",
  "embed.student.course_list.title": "Select your course",
  "embed.student.course_list.description": "You have access to these courses in Teachino.",
  "embed.student.course_list.change_course": "Change course",
  "embed.student.session_expired.title": "Your login has expired",
  "embed.student.session_expired.description": "Please sign in again through the Digitales Register. Afterwards you will get straight back to your courses.",
  "embed.student.session_expired.action": "Sign in via the Digitales Register",
  "embed.student.session_expired.description_eduplaces": "Please sign in again through Eduplaces. Afterwards you will get straight back to your courses.",
  "embed.student.session_expired.action_eduplaces": "Sign in via Eduplaces",
  "embed.student.session_expired.description_untis": "Please sign in again through WebUntis. Afterwards you will get straight back to your courses.",
  "embed.student.session_expired.action_untis": "Sign in via WebUntis",
  "embed.course.day_empty": "No materials have been shared for this date.",
  "embed.error_generic.title": "The connection to WebUntis was not established.",
  "embed.error_generic.help": "You can always access your library. If the timetable from WebUntis doesn't load, you can disconnect in Profile > Integration and manually enter the timetable to continue lesson planning.",
  "embed.error.continue": "Continue to Teachino",
  "period.item_context.remove": "Remove material from the day",
  "period.open_period": "Open lesson",
  "period.start_presentation": "Start presentation",
  "template.tag.topic": "This folder is in a collection.",
  "template.tag.item": "This material is in a collection.",
  "template.topic.updates_available": "Updates are available for this folder.",
  "template.topic.sync_topic_info.title": "Update folder",
  "template.topic.sync_topic_info.description": "Update the folder (name, goals, etc.). No new materials added.",
  "template.topic.sync_new_items.title": "Add new materials",
  "template.topic.sync_new_items.description": "Add new materials from the collection. Additionally created personal materials are not changed.",
  "template.item.updates_available": "Updates are available for this material.",
  "template.item.sync_item_info.title": "Update material",
  "template.item.sync_item_info.description": "Update the material (name, etc.).",
  "template.item.sync_new_snippets.title": "Add or update materials",
  "template.item.sync_new_snippets.description": "Add new materials and update existing ones from the collection. Additionally created personal materials are not changed.",
  "collaboration.cannot_edit_item": "Editing not allowed.",
  "collaboration.use_topic.button": "Copy folder",
  "collaboration.use_topic.button_short": "Copy folder",
  "collaboration.use_item.button": "Copy material",
  "collaboration.use_topic.choose_course": "Choose course",
  "collection.material_banner.title": "This material is part of a collection.",
  "collection.material_banner.description": "Copy it to a course to use it there.",
  "collection.material_banner.copy_to_course": "Copy to course",
  "collection.copy_multiple_folders.dialog_description": "Choose folders from “{{collection}}” to copy into a course.",
  "collection.origin_notice.folder_from": "Folder from {{collectionName}}",
  "collection.origin_notice.material_from": "Material from {{collectionName}}",
  "collection.origin_notice.open_folder": "Open folder in collection",
  "collection.origin_notice.edit_material": "Edit material in collection",
  "collection.origin_notice.new_version_available": "New version available",
  "material_card.also_used_in_course": "Also used in {{courseName}}",
  "collaboration.add_from_library.successfull": "Folder copied",
  "collaboration.add_from_library.successfull_text": "The folder and materials have been duplicated and added to the collection.",
  "collaboration.join_external_course.title": "Team Teaching",
  "collaboration.join_external_course.title_substitution": "Substitution hour",
  "collaboration.join_external_course.description": "{{ownerName}} is already planning {{courseName}} with Teachino.",
  "collaboration.join_external_course.cta": "Join Team Teaching for {{courseName}}",
  "collaboration.join_external_course.cta_substitution": "Take over substitution for {{courseName}}",
  "collaboration.join_external_course.not_join": "I want to plan the course alone",
  "courses.empty_title": "No courses yet",
  "courses.empty_description": "Courses represent your classes and subjects for the current school year. For example \"10A Geography\". Create a course to start planning.",
  "video.modal.close": "Close video",
  "video.modal.title": "Video explanation",
  "pathfindr.pdfsplitter.choose_pages": "Choose pages",
  "pathfindr.pdfsplitter.select_max_pages": "Select up to Y pages.",
  "pathfindr.pdfsplitter.x_of_y_pages_selected": "X of Y pages selected",
  "iframe.open_teachino": "Open Teachino",
  "iframe.redirecting": "Opening Teachino…",
  "iframe.open_teachino_hint": "Teachino opens in a new tab.",
  "iframe.not_activated_hint": "The WebUntis integration is not activated for your school yet. You can still use Teachino, but your account will only be connected to WebUntis once the integration is activated.",
  "download.webview_not_possible": "Downloading is not possible inside this app. Please open Teachino in your browser.",
  "link.webview_not_possible": "Opening links is not possible inside this app. Please open Teachino in your browser.",
  "ai_powered_by_teachino": "AI chat by",
  "student_ai.home_view.empty_state.title": "No AI exercises available yet",
  "student_ai.home_view.empty_state.description": "As soon as you create an AI exercise or get one assigned, it will appear here.",
  "student_ai.home_view.title": "Teachino Student AI",
  "student_ai.assignment_view.title": "Teachino Student AI Exercise",
  "student_ai.assignments": "AI Exercises",
  "student_ai.banner.title": "AI exercises: Use AI with your students ✨",
  "student_ai.banner.description": "Teach them thematic knowledge and AI competencies in a secure, privacy-compliant environment with new AI exercises.",
  "student_ai.banner.cta": "To AI for students",
  "student_ai.assignments.create_assignment": "Create AI Exercise",
  "student_ai.assignments.share_assignment": "QR code & link",
  "student_ai.assignments.start": "Start",
  "student_ai.assignments.stop": "Stop",
  "student_ai.assignments.start_hint": "Click to start the AI exercise",
  "student_ai.assignments.stop_hint": "AI exercise is running. Click to stop",
  "student_ai.assignments.hint_assignment_inactive_before_cta": "This exercise is not started.",
  "student_ai.assignments.hint_assignment_inactive_cta": "Start the exercise",
  "student_ai.assignments.hint_assignment_inactive_after_cta": "so the students can chat with the AI.",
  "student_ai.assignments.hint_assignment_active": "Your students can now chat with the AI. They can scan the QR code or use the link.",
  "student_ai.create_assignment.title": "Create AI Exercise",
  "student_ai.edit_assignment.title": "Edit AI Exercise",
  "student_ai.duplicate_assignment.title": "Copy AI exercise",
  "student_ai.create_assignment.title.placeholder": "AI Exercise from {{date}}",
  "student_ai.create_assignment.description": "Task for students",
  "student_ai.create_assignment.system_prompt": "AI behavior (system prompt)",
  "student_ai.delete_assignment.title": "Delete AI Exercise",
  "student_ai.delete_assignment.description": "Are you sure you want to delete the AI Exercise \"{{assignment}}\"? This action cannot be undone",
  "student_ai.share_assignment.scan_code": "Scan the code to start the AI exercise",
  "student_ai.template.import": "Use with my students",
  "student_ai.template.created_by_teachino": "Created by Teachino",
  "student_ai.template.import_from_teachino": "Discover all AI exercises",
  "student_ai.create.edit_system_prompt": "Edit prompt",
  "editor.image_selector.upload": "Upload image",
  "editor.image_selector.search": "Search image",
  "editor.image_selector.generate": "Generate image with AI",
  "editor.image_selector.ai.prompt_label": "Enter an image description",
  "editor.image_selector.ai.prompt_placeholder": "Type the prompt for the AI-generated image here",
  "editor.image_selector.ai.style": "Style",
  "editor.image_selector.ai.style.realistic": "Realistic",
  "editor.image_selector.ai.style.artistic": "Artistic",
  "editor.image_selector.ai.style.cartoon": "Cartoon",
  "editor.image_selector.ai.style.sketch": "Sketch",
  "editor.image_selector.ai.style.watercolor": "Watercolor",
  "editor.image_selector.ai.style.minimalist": "Minimalist",
  "editor.image_selector.ai.author_name": "AI-generated",
  "editor.image_selector.ai.cta": "Generate image",
  "editor.image_selector.search.label": "Search term",
  "editor.image_selector.libraries.empty": "No image libraries available",
  "editor.image_selector.libraries.recent": "Recently used",
  "editor.image_selector.libraries.all": "All libraries",
  "editor.image_selector.ai.results": "Generated images",
  "editor.image_selector.tab.upload": "Upload image",
  "editor.image_selector.tab.search": "Search image",
  "editor.image_selector.tab.ai": "Generate with AI",
  "editor.image_selector.ai.paywall.title": "Generate images with AI for your materials",
  "editor.image_selector.ai.paywall.description": "Describe what you need and create custom images directly here in the material editor. Subscribe to a license to unlock AI image generation.",
  "editor.image_selector.tab.loading": "The image is being saved",
  "editor.tools.list.bulleted_list.name": "Bulleted list",
  "editor.tools.list.ordered_list.name": "Numbered list",
  "editor.tools.details.name": "Dropdown list",
  "editor.tools.callout.name": "Key takeaway",
  "editor.tools.callout.color": "Color",
  "editor.tools.table.name": "Table",
  "editor.tools.table.add_row_below": "Add row below",
  "editor.tools.table.add_row_above": "Add row above",
  "editor.tools.table.add_header_row": "Header row",
  "editor.tools.table.add_column_left": "Add column left",
  "editor.tools.table.add_column_right": "Add column right",
  "editor.tools.table.add_header_column": "Header column",
  "editor.tools.table.delete_row": "Delete row",
  "editor.tools.table.delete_column": "Delete column",
  "editor.tools.table.delete": "Delete table",
  "editor.tools.text_color.name": "Text color",
  "editor.tools.text_color_background.name": "Color and background",
  "editor.tools.highlight.name": "Highlight",
  "editor.tools.align_left.name": "Align left",
  "editor.tools.align_center.name": "Centered",
  "editor.tools.align_right.name": "Align right",
  "editor.tools.align_justify.name": "Justify",
  "editor.tools.mathematics.name": "Formula",
  "editor.tools.bold.name": "Bold",
  "editor.tools.italic.name": "Italic",
  "editor.tools.underline.name": "Underline",
  "editor.tools.strike.name": "Strike through",
  "editor.tools.code.name": "Code",
  "editor.tools.clear_format.name": "Remove formatting",
  "editor.tools.image": "Image",
  "editor.tools.image.caption.label": "Image caption",
  "editor.tools.image.caption.placeholder": "Describe the image",
  "editor.tools.image.source": "[Source]",
  "editor.tools.file": "File",
  "editor.tools.link": "Link",
  "editor.tools.heading.name": "Heading",
  "editor.tools.heading.prose": "Prose",
  "editor.tools.heading.heading_1": "Heading 1",
  "editor.tools.heading.heading_2": "Heading 2",
  "editor.tools.heading.heading_3": "Heading 3",
  "keyboard.modifier.windows": "Ctrl",
  "keyboard.modifier.mac": "Command",
  "keyboard.shift": "Shift",
  "student_ai.upgrade_banner_before": "With the free license for teachers, you can try out the student AI in this preview. Do you like the student AI? Then ",
  "student_ai.upgrade_banner_cta": "get the Pro license now",
  "student_ai.upgrade_banner_after": "🏅 to easily share exercises with your students.",
  "material.default_name": "Untitled material",
  "material.ai": "AI",
  "material.ai_edit.suggestion_3_question": "Which language do you want the material translated into?",
  "material.ai_edit.suggestion_3_other": "Another language",
  "material.ai_edit.suggestion_3_placeholder": "Enter a language…",
  "material.ai.create.suggestion_1_question": "What should the worksheet be about?",
  "material.ai.create.suggestion_1_no_topic": "Create a worksheet.",
  "material.ai.create.suggestion_2_question": "What should the lesson outline be about?",
  "material.ai.create.suggestion_2_no_topic": "Create a lesson outline.",
  "material.ai.create.suggestion_3_question": "What should the interactive exercise be about?",
  "material.ai.create.suggestion_3_no_topic": "Create an interactive exercise.",
  "material.ai.create.suggestion_4_question": "What should the lesson opener be about?",
  "material.ai.create.suggestion_4_no_topic": "Create a motivating, student-oriented lesson opener.",
  "material.ai_state.reworking": "AI is reworking the material…",
  "material.details": "Details",
  "material.empty_state": "Bring your idea to life: just start typing, ask AI, or add blocks.",
  "material.create": "Create material",
  "material.edit_details.title": "Material details",
  "material.details_dialog.duration_placeholder": "e.g. 30",
  "material.details_dialog.duration_invalid": "Enter a whole number between 1 and {{max}} minutes, or leave the field empty.",
  "material.edit_details.topic_description": "Each material belongs to a folder, making it easily findable later and giving AI more context.",
  "material.edit_details.duration_description": "How many minutes does this material require in class?",
  "material.edit_details.more": "More actions",
  "material.edit_details.material_duplicate": "Copy material",
  "material.edit_details.material_delete": "Delete material",
  "material.share.courses_with_material": "Courses with this material",
  "material.share.add_to_more_courses": "Add material to more courses",
  "material.share.empty.no_courses_available.title": "Create a course to share the material with students.",
  "material.share.empty.no_courses_available.description": "Courses align with your classes and subjects. For example: 8A Geography.",
  "material.share.empty.courses_available_empty.title": "Add the material to an existing course or create a new one.",
  "material.share.new_course": "Create course and share material",
  "material.share.added_to_course": "Material added to course",
  "material.editor.teacher_note.title": "Teacher note",
  "material.editor.teacher_note.placeholder": "Notes are only visible to you. You can also store solution sheets here.",
  "material.editor.teacher_note.convert_to_teacher_note": "Only show to me",
  "material.editor.teacher_note.remove_from_teacher_note": "Show to all",
  "material.editor.activity.ai_feedback": "With AI-feedback",
  "material.editor.assignment_open_question.title": "Question",
  "material.editor.assignment_open_question.assignment_tag": "Task",
  "material.editor.assignment_open_question.your_answer": "Your answer",
  "material.editor.assignment_open_question.check": "Submit",
  "material.editor.assignment_open_question.redo": "Revise answer",
  "material.editor.assignment_open_question.get_hint": "Get hint",
  "material.editor.assignment_open_question.hint": "Hint",
  "material.editor.assignment_open_question.confirm": "Submit",
  "material.editor.assignment_open_question.guidance": "Criteria for content-related AI-feedback",
  "material.editor.assignment_open_question.generate_guidance": "Generate with AI",
  "material.editor.assignment_open_question.generate_guidance_empty": "Type a question with at least 10 characters to generate suitable feedback criteria.",
  "material.editor.assignment_open_question.generate_guidance_disabled": "Add a question first",
  "material.editor.assignment_open_question.generate_guidance_error": "Could not generate feedback criteria. Please try again.",
  "material.editor.assignment_open_question.guidance_placeholder": "The student mentions …",
  "material.editor.assignment_open_question.guidance_example": "Define criteria for format, length, and content, and optionally add a model answer. The AI uses them for assessment, feedback, and feedforward.",
  "material.assignment_open_question.answer_placeholder": "Type your answer",
  "material.assignment_open_question.answer_reset": "Undo",
  "material.assignment_open_question.get_feedback": "Get feedback",
  "material.assignment_open_question.feedback": "AI-feedback",
  "material.assignment_open_question.feedback.empty_state": "No feedback available",
  "material.assignment_open_question.status.not_answered": "Not answered",
  "material.assignment_open_question.status.incorrect": "Not answered correctly",
  "material.assignment_open_question.status.partially": "Partially answered correctly",
  "material.assignment_open_question.status.correct": "Completely correct",
  "material.assignment_open_question.status.started": "In progress",
  "material.assignment_open_question.status.not_started": "Not started yet",
  "material.assignment_open_question.summary.started": "In progress",
  "material.assignment_open_question.summary.correct": "Completely correct",
  "material.assignment_open_question.summary.partially": "Partially correct",
  "material.assignment_open_question.summary.incorrect": "Not correct",
  "material.assignment_open_question.loading": "The AI is reading the answer and will provide feedback shortly.",
  "material.assignment_open_question.ai_disclaimer": "The feedback is generated by AI. AI can make mistakes.\nDo not enter personal data.",
  "material.assignment_open_question.question_placeholder": "Type a question or task",
  "material.assignment_open_question.attempt": "Attempt",
  "material.assignment_open_question.answer.empty_state": "No answer",
  "material.assignment_open_question.answer_paste_block": "Please type your answer instead of copying it.",
  "material.assignment_open_question.answer_paste_block_teacher": "Students can only type their answer. Copy and paste is only available to teachers.",
  "speech_to_text.microphone": "Microphone",
  "speech_to_text.default_microphone": "Default microphone",
  "speech_to_text.start_recording": "Record answer",
  "speech_to_text.stop_recording": "Stop recording",
  "speech_to_text.transcribing": "Transcribing…",
  "speech_to_text.microphone_denied": "Microphone access was denied. Please allow microphone access in your browser settings.",
  "speech_to_text.transcription_error": "Voice transcription failed. Please try again or type your answer.",
  "image_to_text.upload_image": "Upload image (extract text)",
  "image_to_text.extraction_error": "Text extraction from image failed. Please try again or type your answer.",
  "image_to_text.file_too_large": "Image is too large (max. 5 MB). Please use a smaller image.",
  "material.student.your_are_logged_in_as": "You are logged in as {{name}}",
  "material.student.click_logout_description": "Click on \"Log out\" to log out. This will delete your answers from this computer. Your teacher will still be able to access them.",
  "material.editor.image.set_size_small": "Make smaller",
  "material.editor.image.set_size_large": "Make larger",
  "material.editor.image.size_small": "Small",
  "material.editor.image.size_medium": "Medium",
  "material.editor.image.size_large": "Large",
  "material.editor.image.replace": "Replace image",
  "material.editor.image.replace_preview": "Under \"Edit\" you can choose an alternative image, upload one, or generate with AI.",
  "material.change_topic": "Change folder",
  "library.material.courses.title": "Courses",
  "library.material.courses.loading": "Loading courses…",
  "library.material.courses.empty": "This material is not assigned to any course",
  "material.rename.success": "Material renamed!",
  "material.icon_change.success": "New icon saved!",
  "material.download": "Download",
  "material.editor.image.expand": "Enlarge image",
  "material.preview": "Preview",
  "material.open_link": "Open link",
  "material.copy_link": "Copy link",
  "material.editor.link.save": "Save link",
  "material.editor.link.label": "Link",
  "material.editor.link.title": "Link title",
  "material.editor.link.title_placeholder": "Add title",
  "material.editor.link.description": "Link description",
  "material.editor.link.description_placeholder": "Add description",
  "material.editor.link.add": "Insert link",
  "material.editor.link.edit_url": "Edit link",
  "material.editor.link.convert_to_preview": "Convert to preview",
  "material.editor.link.reload_preview": "Reload preview",
  "material.editor.link.convert_to_url": "Convert to URL",
  "material.bulk.cta": "Upload files",
  "material.bulk_create.title": "Upload files",
  "material.bulk_create.files": "Files",
  "material.bulk_create.hint_1": "💡 Tip: Use {{cmdAll}} to select all files in a folder.",
  "material.bulk_create.hint_2": "To click multiple files, hold {{cmdMultiSelect}}.",
  "material.bulk_create.success": "Materials created!",
  "material.bulk_create.pending_uploads": "{{count}} pending",
  "material.bulk_create.cancel_uploads.title": "Cancel uploads?",
  "material.bulk_create.cancel_uploads.message": "Closing this dialog will cancel all ongoing uploads. Do you want to continue?",
  "material.bulk_create.cancel_uploads.confirm": "Yes, cancel",
  "material.bulk_create.cancel_uploads.keep_uploading": "No, keep uploading",
  "material.external_content.header": "Select document",
  "material.external_content.empty": "No documents found",
  "material.external_content.recent": "Recently used documents",
  "material.share.cta": "Share",
  "material.share.cta_long": "Share material with students",
  "material.share_with_teachers.menu_label": "Share with teachers",
  "material.share_with_teachers.title": "Share material with teachers",
  "material.share_with_teachers.description": "Anyone with this link can view the material and copy it into their own courses.",
  "material.share_with_teachers.hint": "The link is publicly accessible. Students' answers and data are not shared.",
  "material.share_with_teachers.deactivate": "Deactivate link",
  "material.share_with_teachers.deactivated_title": "Link deactivated",
  "material.share_with_teachers.deactivated_description": "The previous link no longer works. Nobody can view or copy the material through it anymore. Materials that were already copied are not affected.",
  "material.share_with_teachers.create_new_link": "Create new link",
  "shared_material.title": "Shared material",
  "shared_material.subtitle": "A teacher shared this material with you",
  "shared_material.use_material": "Use material",
  "shared_material.use_material_hint": "Copy the material into one of your courses to edit and use it.",
  "shared_material.no_courses": "You don't have a course to copy the material into yet. Create a course first.",
  "shared_material.not_available.title": "Material not available",
  "shared_material.not_available.description": "The link is invalid or has been deactivated.",
  "material.rename_dialog.title": "Material name",
  "material.rename_dialog.description": "Please give your material a meaningful name so AI has enough context.",
  "material.rename_dialog.placeholder": "Enter name",
  "material.rename_dialog.error": "Please enter a longer name.",
  "material.chat.send": "Send",
  "material.chat.age_select.label": "Age of students",
  "material.chat.language_select.label": "Language of students",
  "interactive_assignment.overview.title": "Evaluation for {{courseName}}",
  "interactive_assignment.overview.table.name": "Name",
  "interactive_assignment.number_of_students_one": "One student",
  "interactive_assignment.number_of_students_many": "{{number}} students",
  "interactive_assignment.overview.legend": "Legend",
  "interactive_assignment.overview.legend.incorrect": "Not correct",
  "interactive_assignment.overview.legend.partially_correct": "Partially correct",
  "interactive_assignment.overview.legend.correct": "Correct",
  "interactive_assignment.overview.legend.started": "In progress",
  "interactive_assignment.overview.legend.attempts_and_hints": "1st number: Attempts &middot; 2nd number: Hints used",
  "interactive_assignment.overview.show_hints_and_attempts": "Show attempts and hints",
  "interactive_assignment.overview.one_attempt": "One attempt.",
  "interactive_assignment.overview.many_attempts": "Attempts",
  "interactive_assignment.overview.user_interview.title": "You use interactive assignments with AI-feedback—thank you!",
  "interactive_assignment.overview.user_interview.description": "You already have answers from several students. Join a short user interview and tell us what works well and what we should improve.",
  "interactive_assignment.overview.user_interview.cta": "Join interview",
  "interactive_assignment.no_courses.title": "Click \"Share\" to share this material with your students.",
  "interactive_assignment.no_courses_description": "Once your students work with the material, you will see the evaluation per student and per question here.",
  "editor.file.description.placeholder": "Add description",
  "pathfindr.annotation_tool.welcome_modal.title": "Hello",
  "pathfindr.annotation_tool.welcome_modal.text": "Here you can view documents and draw on them.",
  "pathfindr.annotation_tool.welcome_modal.button": "Next",
  "pathfindr.annotation_tool.permission_modal.title": "Permission needed",
  "pathfindr.annotation_tool.permission_modal.text": "You need to allow camera and screen access to record your session.",
  "pathfindr.annotation_tool.permission_modal.button_permission": "Grant permission",
  "pathfindr.annotation_tool.permission_modal.button_no_permission": "Continue without recording",
  "pathfindr.annotation_tool.permission_modal.no_browser_support_title": "No browser support",
  "pathfindr.annotation_tool.permission_modal.no_browser_support_text": "Your browser does not support screen recording. This is often due to missing security settings, outdated browser, or lack of support on smartphones.",
  "pathfindr.annotation_tool.uploading_modal.title": "Uploading…",
  "pathfindr.annotation_tool.success_modal.title": "Hooray!",
  "pathfindr.annotation_tool.success_modal.text": "Your files have been uploaded",
  "pathfindr.annotation_tool.error_modal.title": "Error",
  "pathfindr.annotation_tool.error_modal.text": "The file cannot be displayed right now. Please download the file with the download button to open it.",
  "pathfindr.annotation_tool.error_modal.button_download_video": "Download video",
  "pathfindr.annotation_tool.error_modal.button_download_pdf": "Download PDF",
  "pathfindr.annotation_tool.error_modal.button_retry": "Retry",
  "pathfindr.annotation_tool.navbar.button_done": "Done",
  "pathfindr.annotation_tool.navbar.uploading_text": "Uploading…",
  "pathfindr.annotation_tool.navbar.button_cancel": "Cancel",
  "pathfindr.annotation_tool.navbar.helper_text_not_ready": "Record a session or edit the document",
  "pathfindr.annotation_tool.navbar.helper_text_ready": "Ready to upload",
  "pathfindr.annotation_tool.access_token_unvalid": "This is a trial version, only for tests and demos!",
  "language.de": "German",
  "language.en": "English",
  "language.it": "Italian",
  "language.es": "Spanish",
  "language.fr": "French",
  "language.pt": "Portuguese",
  "language.tr": "Turkish",
  "language.po": "Polish",
  "language.nl": "Dutch",
  "language.se": "Swedish",
  "language.ru": "Russian",
  "language.sl": "Slovenian",
  "language.cs": "Czech",
  "language.lb": "Luxembourgish",
  "language.ro": "Romanian",
  "language.rs": "Serbian",
  "language.hr": "Croatian",
  "language.ur": "Urdu",
  "language.hi": "Hindi",
  "language.sq": "Albanian",
  "language.ar": "Arabic",
  "ipi.title": "Describe a topic and get matching material",
  "ipi.paywall.description": "Generate lesson materials with AI: interactive worksheets, assignments, and ideas.",
  "ipi.usage.upgrade_cta": "Upgrade now",
  "ipi.prompt.too_short": "Please enter a longer prompt.",
  "ipi.prompt.placeholder": "Type a topic and desired details (focus, learning goal, prior knowledge, …) here",
  "ipi.prompt.cta": "Generate material",
  "ipi.material.done": "Material created!",
  "ipi.hints": "Examples",
  "ipi.hint": "Example:",
  "ipi.hints.1.title": "Interactive Worksheet Climate Change",
  "ipi.hints.1.prompt": "Create a worksheet on the effects of climate change focusing on extreme weather events.",
  "ipi.hints.3.title": "Lesson Introduction Steam Engine",
  "ipi.hints.3.prompt": "Create a lesson introduction on how steam engines work.",
  "ipi.hints.4.title": "Info Text with Comprehension Questions Tourism South Tyrol",
  "ipi.hints.4.prompt": "Write an information text on the impact of tourism on a location using South Tyrol as an example in Geography. Add three open questions afterwards.",
  "ipi.loading.title": "Your material is being created",
  "ipi.loading.subtitle": "This takes about a minute",
  "ipi.loading.1": "The structure of your material is being created",
  "ipi.loading.2": "Texts, tasks, and images are being assembled",
  "ipi.loading.3": "Generating interactive assignments",
  "ipi.loading.4": "You can edit and supplement the finished material as desired.",
  "ipi.loading.5": "Then you can print it or share it with your students via a link.",
  "ipi.loading.6": "The material is saved in a folder in the course.",
  "ipi.loading.material_ready": "Your material is ready.",
  "ipi.loading.view_material": "View material",
  "ipi.convert_worksheet.title": "Digitize worksheet",
  "ipi.convert_worksheet.convert_button": "Convert",
  "ipi.convert_worksheet.description": "Upload a worksheet (PDF, image, or document) and the AI will convert it into an interactive Teachino material.",
  "ipi.convert_worksheet.ai_prompt": "Convert this uploaded worksheet into an interactive Teachino material.",
  "ipi.progress.validating": "Validating your input…",
  "ipi.progress.generating": "Generating material with {{images}} images…",
  "ipi.progress.integrating": "Adding {{questions}} interactive assignments…",
  "ipi.progress.finalizing": "Finalizing your material…",
  "ipi.topic_select.title": "Choose a folder for the AI",
  "ipi.material.name_placeholder": "New material",
  "ipi.add_source": "Source",
  "ipi.add_source.loading": "Uploading…",
  "ipi.add_source.upload_file": "Upload file",
  "ipi.add_source.add_link": "Enter link",
  "ipi.add_source_description": "Choose a link, video, file, or folder as a source for the AI.",
  "ipi.longer_prompt.hint": "Enter at least 6 characters to start the AI. Use examples for inspiration.",
  "ipi.disclaimer": "The AI creates the material based on your inputs (text, source, folder). Do not enter personal data. AI can make mistakes.",
  "ai_assistant.rework_pending_review": "An existing revision for this material is still waiting for review or being applied. Review or discard it before starting another revision.",
  "image_generation.disclaimer": "The description is processed by AI. Please do not enter personal data.",
  "course.current_course": "Current course",
  "course.current_collection": "Current collection",
  "course.all_courses": "All courses",
  "course.all_materials": "All materials",
  "course.materials.empty.title": "Create your first material!",
  "course.materials.empty.description": "Choose an AI suggestion, or click New to get started yourself.",
  "course.materials.empty.manual_description": "Click New to create your first material.",
  "course.materials.empty.ai_primary_cta": "Get started with AI assistant",
  "course.materials.empty.ai_primary_prompt": "Create suitable material for my course.",
  "course.materials.empty.ai_cta_description": "Describe what you need – the AI assistant creates material tailored to your course.",
  "course.materials.empty.ai_cta_action": "Open assistant",
  "course.materials.empty.convert_description": "Upload a worksheet and turn it into interactive material.",
  "course.materials.empty.convert_action": "Upload worksheet",
  "course.materials.empty.manual_hint": "You can also create, import, or upload materials manually using New.",
  "course.materials.empty.guest.title": "No materials yet",
  "course.materials.empty.guest.description": "No materials have been created in this course yet.",
  "course.materials.empty.guest.collection_description": "No materials have been created in this collection yet.",
  "course.materials.used_in_courses_label": "Used in courses:",
  "course.add_content_menu.create_material": "Create material",
  "course.add_content_menu.create_folder": "Create folder",
  "course.add_content_menu.reuse_section": "Reuse",
  "course.add_content_menu.add_from_course_or_collection": "Add material from another course / collection",
  "course.add_existing_empty_title": "No other courses available",
  "course.add_existing_empty_description": "Create or restore another course to preview existing materials here.",
  "course.add_existing_empty_materials_title": "No materials in this folder",
  "course.add_existing_empty_materials_description": "Select another folder to preview its materials.",
  "course.all_folders_copied": "All folders copied",
  "course.copy_all_folders.button": "Copy all folders",
  "course.copy_all_folders.confirm_title": "Copy all folders?",
  "course.copy_all_folders.confirm_message": "{{count}} folders will be copied into this course.",
  "course.copy_all_folders.partial_success": "Copied {{copied}} of {{total}} folders",
  "course.copy_all_folders.success": "All folders copied",
  "course.copy_multiple_folders.button": "Copy folders…",
  "course.copy_multiple_folders.confirm": "Copy {{count}} folders to course",
  "course.copy_multiple_folders.select_course": "Select course…",
  "course.copy_multiple_folders.dialog_description": "Choose folders from “{{course}}” to copy into “{{destinationCourse}}”.",
  "course.copy_multiple_folders.dialog_title": "Copy to course",
  "course.copy_multiple_folders.material_count": "{{count}} materials",
  "course.copy_multiple_folders.partial_success": "Copied {{copied}} of {{total}} folders",
  "course.copy_multiple_folders.select_all": "Select all",
  "course.copy_multiple_folders.selection_count": "{{selected}} of {{total}} selected",
  "course.copy_multiple_folders.success": "Copied {{count}} folders",
  "course.archived_courses": "Deleted courses",
  "course.recently_updated_materials": "Recent",
  "course.export.date": "Date",
  "course.export.materials_and_notes": "Materials and notes",
  "course.export.class_register": "Class register",
  "course.export.year_plan": "Export annual planning",
  "course.export.calendar_days": "Export periods and content",
  "course.export.dialog.title": "Print and export",
  "course.export.dialog.student_codes.title": "Access codes for students",
  "course.export.dialog.student_codes.description": "Print access cards with names and personal codes for all students in this course.",
  "course.export.dialog.student_codes.unavailable": "This export is available once students have been added to the course.",
  "course.export.dialog.year_plan.title": "Annual planning",
  "course.export.dialog.year_plan.description": "Export the folders and their planned time periods as a CSV file.",
  "course.export.dialog.year_plan.unavailable": "This export is available once folders and materials have been added to the course.",
  "course.export.dialog.calendar.title": "Periods and content (class register)",
  "course.export.dialog.calendar.description": "Export planned periods, materials, notes, and class register entries as a CSV file.",
  "course.export.dialog.calendar.unavailable": "This export is available once periods have been scheduled.",
  "course.export.dialog.grading.title": "Grading overview",
  "course.export.dialog.grading.description": "Export the grading overview for all students as a CSV file.",
  "course.export.dialog.grading.unavailable": "This export is available once students have been added to the course.",
  "course.export.grading_overview": "Export grading overview",
  "course.export.from": "From",
  "course.export.to": "To",
  "course.edit_course": "Edit course",
  "course.archive_course": "Delete course",
  "course.archive_course_message": "Delete \"{{courseName}}\"?",
  "course.archived_toast": "Course deleted. The course \"{{courseName}}\" has been deleted.",
  "course.import_material_from_course": "Material from course or collection",
  "course.import_material_from_course_dialog": "Add material from course or collection",
  "course.import_material_from_x": "Add material from \"{{course}}\"",
  "course.import_from_course.destination_hint": "Materials will be copied into “{{courseName}}”, folder “{{folderName}}”.",
  "chatbot.chatbots": "Chatbots",
  "chatbot.custom_chatbots": "Custom chatbots",
  "chatbot.custom_chatbot": "Custom chatbot",
  "chatbot.create_new": "Create new chatbot",
  "chatbot.rename": "Rename chatbot",
  "chatbot.edit": "Edit chatbot",
  "chatbot.delete": "Delete chatbot",
  "chatbot.delete_confirm": "Do you really want to delete \"{{title}}\"?",
  "chatbot.customizable": "Individually customizable",
  "chatbot.name_label": "Chatbot name",
  "chatbot.how_should_answer": "How should the chatbot respond?",
  "chatbot.purpose": "What is this chatbot for?",
  "chatbot.start_without_template": "Start without a template",
  "chatbot.start_chat": "Start AI chat",
  "chatbot.ai_instructions": "Basic AI settings",
  "chatbot.additional_info": "Additional information for the AI",
  "chatbot.internal_notes": "Internal usage notes",
  "chatbot.no_info": "No information provided",
  "chatbot.no_ai_settings": "No AI settings yet",
  "chatbot.enter_message": "Enter message…",
  "chatbot.legacy.title": "Existing AI chats",
  "chatbot.legacy.description": "Select an existing chat to pre-fill the fields. Please copy old AI chats to your courses before 30.07.2026.",
  "chatbot.context.description": "Content the chatbot should have access to.",
  "chatbot.context.no_sources": "No sources added",
  "chatbot.context.no_sources_hint": "Add files or links the AI should have access to.",
  "chatbot.context.add_file": "File",
  "chatbot.context.add_link": "Link",
  "chatbot.description.student_hint": "Shown to students before they start the chat.",
  "chatbot.prompt.teacher_only_hint": "Only you see this instruction – it controls the behavior of the AI.",
  "chatbot.title.student_visible_hint": "The name of the chatbot that students see.",
  "chatbot.context.sources_label": "Sources and materials",
  "chatbot.hello_message": "Hello! How can I help you today?",
  "chatbot.explain_simple": "Can you explain the topic to me in simple terms?",
  "chatbot.step_by_step": "Sure. Let's go through the topic step by step.",
  "chatbot.no_custom_chatbots_empty_state": "No custom chatbots yet. Create a new chatbot via \"New…\".",
  "folder.folder_copied": "Folder copied",
  "folder.delete_folder": "Delete folder",
  "folder.delete_folder_confirm": "Do you really want to delete the folder?",
  "folder.remove_from_course": "Remove from course",
  "folder.remove_from_course_confirm": "Do you really want to remove the folder from this course?",
  "folder.folder_removed_from_course": "Folder removed from course",
  "folder.select_course_for_copy": "Select the course to copy the folder to.",
  "material.no_materials_found": "No materials found",
  "material.material_copied": "Material copied",
  "material.material_moved": "Material moved",
  "material.delete_material_confirm": "Do you really want to delete this material?",
  "material.copy_destination": "Where should the material be copied to?",
  "material.move_destination": "Where should the material be moved to?",
  "material.visible_for_sus": "Visible to students",
  "material.not_visible_for_sus": "Material not visible to students",
  "generic.ok": "Ok",
  "generic.new": "New…",
  "generic.new_short": "New",
  "generic.rename": "Rename",
  "generic.help": "Help",
  "generic.website": "Website",
  "generic.webinar": "Webinar",
  "generic.image": "Image",
  "generic.europathek": "EUROPATHEK",
  "generic.no_images_found": "No images found",
  "generic.scan_qr_code": "Scan QR code",
  "generic.add_source": "Add source",
  "generic.try_different_search": "Try a different search term",
  "generic.name_and_color": "Name and color",
  "generic.change_name_color": "Change name & color",
  "ipi.describe_what_to_create": "Describe what the AI should create…",
  "ipi.placeholder.example_photosynthesis": "A worksheet on photosynthesis with images and open questions",
  "ipi.placeholder.example_faust": "An AI exercise on Goethe's Faust",
  "ipi.placeholder.example_past_simple": "An interactive gap-fill text on Past Simple",
  "ipi.ideas_for_you": "Ideas for you",
  "ipi.generate_ideas": "Generate ideas",
  "ipi.generate_new_ideas": "New ideas",
  "ipi.choose_idea": "Use prompt",
  "ipi.ideas_generating": "Ideas for you are being generated",
  "ipi.ai_assistance": "AI assistance",
  "ipi.enter_details": "Enter details",
  "ipi.context_files": "Context files",
  "ipi.description_students": "Description for students",
  "ipi.description_teacher": "Description for the teacher",
  "ipi.llm_instructions": "Description for the chatbot",
  "ipi.loading": "Loading",
  "feature_flags.title": "Feature Flags 🧪",
  "course.ai_instructions_description": "The AI uses this information to adapt the materials to your teaching.",
  "course.additional_info_description": "e.g. whether the AI should use formal or informal address with students, as well as information that should be considered for every material",
  "course.display_question": "How should the course be displayed?",
  "course.archive_description": "Delete course. Materials will be retained for future school years.",
  "course.archive_info": "The course will no longer be displayed for planning. Materials can still be accessed via the \"Deleted courses\" menu item in the library.",
  "course_list.loading": "Loading course list data…",
  "course_list.error.load_failed": "Failed to load course list data.",
  "course_list.error.reorder": "Could not reorder course.",
  "course_list.error.update_school_year": "Could not update school year.",
  "course_list.error.create_course": "Could not create course.",
  "course_list.error.connect_course": "Could not connect course.",
  "course_list.error.hide_course": "Could not hide course.",
  "course_list.error.failed_create_school_year": "Failed to create school year.",
  "course_list.error.failed_update_school_year": "Could not update school year.",
  "course_list.error.school_year_overlap": "This school year overlaps with an existing one. Please adjust the dates and save again.",
  "course_list.new_school_year": "New school year",
  "course_list.create_school_year": "Create school year",
  "course_list.edit_school_year": "Edit school year",
  "course_list.delete_school_year": "Delete school year",
  "course_list.delete_school_year.title": "Delete school year",
  "course_list.delete_school_year.message": "Delete \"{{schoolYearName}}\"?",
  "course_list.delete_school_year.success": "School year deleted. \"{{schoolYearName}}\" has been deleted.",
  "course_list.delete_school_year_blocked.info_title": "School year contains courses",
  "course_list.delete_school_year_blocked.info_message": "Please delete all courses in this school year first. Then you can delete the school year.",
  "course_list.hide_course": "Hide course",
  "course_list.connect_course": "Link course",
  "course_list.add_course": "Create course",
  "course_list.empty_school_year.title": "No courses",
  "course_list.empty_school_year.description": "There are no courses in this school year.",
  "course_list.empty.description": "Create a course to get started.",
  "course_list.connect_dialog.description": "Choose the Teachino course to connect with this external course.",
  "course_list.external_course": "External course",
  "course_list.external_course_from": "from {{integrationName}}",
  "course_list.teachino_course": "Teachino course",
  "course_list.select_course": "Select a course",
  "course_list.connect_existing": "Connect with existing course",
  "course_list.statistics.students": "students",
  "course_list.statistics.folders": "folders",
  "course_list.statistics.materials": "materials",
  "course_list.menu.open": "Open",
  "course_list.open_course_aria": "Open course",
  "course_list.school_year.description": "Choose the school year this course belongs to.",
  "course_list.select_school_year": "Select a school year",
  "course_list.school_year.start_date": "Start date",
  "course_list.school_year.end_date": "End date",
  "course_list.school_year.end_date_after_start": "End date must be after start date",
  "course_list.school_year.name_placeholder": "e.g. {{startYear}}/{{endYear}}",
  "course_list.school_year.course_count_zero": "{{number}} courses",
  "course_list.school_year.course_count_one": "{{number}} course",
  "course_list.school_year.course_count_many": "{{number}} courses",
  "course_list.school_year.drag_blocked": "Courses cannot be dragged into another school year. Change the school year in the course settings.",
  "course_list.school_year.change_hint": "Changing the school year deletes this course's timetable.",
  "course_list.school_year.change_title": "Move course to {{schoolYear}}?",
  "course_list.school_year.change_message": "This deletes the timetable of \"{{courseName}}\" – lessons, substitutions and extra lessons, including for colleagues who plan the course with you. It cannot be undone. Materials, topics, grades and students are kept.",
  "course_list.school_year.change_action": "Change school year",
  "material.version_history.title": "Version history",
  "material.version_history.current": "Current",
  "material.version_history.current_version": "Current version",
  "material.version_history.version": "Version",
  "material.version_history.reason.created": "Created",
  "material.version_history.reason.created_with_ai": "Created with AI",
  "material.version_history.reason.saved_edit": "Saved edit",
  "material.version_history.reason.ai_rework": "AI rework",
  "material.version_history.reason.restored": "Restored",
  "material.version_history.reason.saved_version": "Saved version",
  "material.version_history.by": "By",
  "material.version_history.no_versions_available": "No versions available",
  "material.version_history.restore_selected_version": "Restore selected version?",
  "material.version_history.restore_description": "The current material will be saved first, then this version becomes the new current version.",
  "material.version_history.cancel_restore": "Cancel restore",
  "material.version_history.confirm_restore": "Confirm restore",
  "material.version_history.restore_this_version": "Restore this version",
  "material.version_history.failed_to_load": "Failed to load version content",
  "material.version_history.restore_failed": "Restore failed",
  "generic.file": "File",
  "generic.upload_file": "Upload file",
  "generic.save_link": "Save link",
  "generic.enter_link": "Enter link",
  "generic.copy_item": "Copy \"{{item}}\"",
  "chatbot.template.socratic_tutor.title": "Socratic Tutor",
  "chatbot.template.socratic_tutor.description_teacher": "Supports students while working with the material.",
  "chatbot.template.socratic_tutor.description_student": "Ask questions about the material and receive helpful explanations and hints.",
  "chatbot.template.socratic_tutor.prompt": "You are a supportive and empathetic Socratic tutor for students.\nYou guide students through this material and support their understanding. Speak in simple language.\nWhen students ask for solutions to a task, NEVER simply give the solution. Never retell or summarise entire sections of the material. Instead, guide students back to the material (e.g. refer to the parts of the material where the answer can be found, e.g.: \"Look at M2\").",
  "chatbot.template.exam_coach.title": "Exam Coach",
  "chatbot.template.exam_coach.description_teacher": "Tests students' knowledge in preparation.",
  "chatbot.template.exam_coach.description_student": "Practice with AI support to prepare for tests, assignments and exams, and get topics explained.",
  "chatbot.template.exam_coach.prompt": "You are a learning coach for students and help them prepare for tests, assignments, exams and other assessments. Explain content clearly and in small steps.\nHelp with structuring the learning material and give motivating feedback.\nDo not provide complete model solutions, but guide students towards the correct approach.",
  "chatbot.template.discussion.title": "Discussion",
  "chatbot.template.discussion.description_teacher": "Students engage in a pro-and-con discussion on controversial topics from the material.",
  "chatbot.template.discussion.description_student": "Engage in a pro-and-con discussion on a controversial topic. The AI takes the opposing side – convince it with strong arguments!",
  "chatbot.template.discussion.prompt": "Lead a pro-and-con discussion on the controversial topic \"{{topic}}\" from this material. You hold this opinion: {{opinion}}. Take the opposing position to the students and challenge them to justify their arguments coherently. Keep your answers short.",
  "chatbot.copy": "Copy",
  "chatbot.initial_message": "Hello",
  "chatbot.ai_disclaimer": "You are chatting with AI. AI can make mistakes. Do not enter personal data.",
  "chatbot.template.persuasion_talk.title": "Persuasion Challenge",
  "chatbot.template.persuasion_talk.description_teacher": "Students persuade the AI of their opinion or intention.",
  "chatbot.template.persuasion_talk.description_student": "Convince the AI of your opinion",
  "chatbot.template.persuasion_talk.prompt": "Lead a discussion on the topic \"{{topic}}\" and raise counterarguments. Only once the student has convincingly refuted three of your arguments do you concede.",
  "chatbot.template.chat_with_person.title": "Chat with a Person",
  "chatbot.template.chat_with_person.description_teacher": "Students have a conversation with a chosen character.",
  "chatbot.template.chat_with_person.description_student": "Chat with \"{{person}}\" to learn more about a topic and ask targeted questions.",
  "chatbot.template.chat_with_person.prompt": "You take on the role of: {{person}}.\nThe student wants to talk to you about the following topic: {{topic}}.\n\nSpeak in a way that fits your character and your time. Keep your answers brief.\n\nAlways stay fully in character. Never break out of this role.\n\nHold a natural dialogue. Do not ask a follow-up question after every answer.\nIf the student brings up a different topic, gently steer the conversation back to the topic.\n\nDo not ask for any personal information about the student.\nIf something does not fit your character or your time period, say so honestly from within your role.\n\nStart the chat by briefly introducing yourself.",
  "chatbot.template.vocabulary_trainer.title": "Vocabulary Training",
  "chatbot.template.vocabulary_trainer.description_teacher": "Let your students practice their current vocabulary.",
  "chatbot.template.vocabulary_trainer.description_student": "Practice vocabulary with the help of AI by translating words or forming sentences. The AI will give you the words.",
  "chatbot.template.vocabulary_trainer.prompt": "You are a vocabulary trainer for students.\nPractice vocabulary with the student.\nSelect the vocabulary in random order.\n\nVary the way you quiz:\n– sometimes the learner should translate\n– sometimes they should form an example sentence using the word.\n\nAlways ask about one word at a time.\nPay close attention to spelling and grammar.\nGive feedback, but never simply give away the answer.\nAt the end, repeat all vocabulary that has not yet been mastered confidently.\nOnly end the training once all vocabulary has been answered correctly.\nSay goodbye at the end with words of praise.\nUse the vocabulary from the material.",
  "chatbot.template.grammar_trainer.title": "Grammar Training",
  "chatbot.template.grammar_trainer.description_teacher": "Students practice grammar in a targeted way.",
  "chatbot.template.grammar_trainer.description_student": "Practice grammar with AI support by converting sentences into the required tense. The AI will give you feedback.",
  "chatbot.template.grammar_trainer.prompt": "You are a patient but very precise grammar trainer for learners.\nPractice the following topic with the student: {{topic}}.\nAlways give only one task at a time.\nAfter each answer, give feedback, but NEVER simply give away the solution.\nDo not let any mistakes go uncorrected.\nIncrease the difficulty once several tasks have been solved correctly.\n\nExample flow:\n\"Change the following sentence from the Simple Present into the Simple Past: 'She walks to school.'\"\nWait for the answer and then give feedback.",
  "chatbot.template.conversation_simulation.title": "Conversation Simulation",
  "chatbot.template.conversation_simulation.description_teacher": "Students practice a realistic conversation situation.",
  "chatbot.template.conversation_simulation.description_student": "Practice this type of conversation with the AI in this simulation: \"{{conversation}}\". Prepare yourself for a real conversation this way.",
  "chatbot.template.conversation_simulation.prompt": "You are \"{{person}}\" and you are conducting the following type of conversation: \"{{conversation}}\".\nAsk targeted questions.\nIf the type of conversation has a goal, such as a job interview, give feedback at the end of the conversation depending on how satisfied you are (e.g. congratulate them on the job or give constructive feedback).",
  "chatbot.mock_answer": "Mock response: Thank you for your message. This is where the AI would respond.",
  "chatbot.create": "Chatbot",
  "chatbot.create_custom": "Create custom chatbot",
  "chatbot.edit_settings": "Edit settings",
  "chatbot.start_new_chat": "Restart chat",
  "chatbot.ready_to_chat": "Ready to chat",
  "chatbot.history.conversation": "Conversation",
  "chatbot.history.one_message": "1 message",
  "chatbot.history.many_messages": "{{count}} messages",
  "chatbot.messages_count": "Messages: {{count}}",
  "chatbot.column_type.chatbot": "Chatbot",
  "chatbot.column_type.question": "Question",
  "chatbot.apply_template": "Apply template",
  "chatbot.template.discussion.configure": "Configure discussion",
  "chatbot.template.discussion.topic_label": "Controversial topic",
  "chatbot.template.discussion.topic_description": "The topic that the AI discusses with the students.",
  "chatbot.template.discussion.topic_placeholder": "e.g. Social media in school",
  "chatbot.template.discussion.opinion_label": "AI opinion",
  "chatbot.template.discussion.opinion_description": "The position that the AI takes in the discussion.",
  "chatbot.template.discussion.opinion_placeholder": "e.g. Social media should be banned in school",
  "chatbot.template.persuasion_talk.configure": "Configure persuasion talk",
  "chatbot.template.persuasion_talk.topic_label": "Topic",
  "chatbot.template.persuasion_talk.topic_description": "The topic that the AI should be persuaded of.",
  "chatbot.template.persuasion_talk.topic_placeholder": "e.g. Homework should be abolished",
  "chatbot.template.conversation_simulation.configure": "Configure conversation simulation",
  "chatbot.template.conversation_simulation.person_label": "AI role",
  "chatbot.template.conversation_simulation.person_description": "The person or role that the AI plays in the simulation.",
  "chatbot.template.conversation_simulation.person_placeholder": "e.g. HR manager",
  "chatbot.template.conversation_simulation.conversation_label": "Type of conversation",
  "chatbot.template.conversation_simulation.conversation_description": "The type of conversation that the students should practice.",
  "chatbot.template.conversation_simulation.conversation_placeholder": "e.g. Job interview",
  "chatbot.template.chat_with_person.configure": "Configure chat with a person",
  "chatbot.template.chat_with_person.person_label": "Person",
  "chatbot.template.chat_with_person.person_description": "The person or character whose role the AI takes on.",
  "chatbot.template.chat_with_person.person_placeholder": "e.g. Albert Einstein",
  "chatbot.template.chat_with_person.topic_label": "Conversation topic",
  "chatbot.template.chat_with_person.topic_description": "The topic that the students talk about with the person.",
  "chatbot.template.chat_with_person.topic_placeholder": "e.g. The theory of relativity",
  "chatbot.template.grammar_trainer.configure": "Configure grammar training",
  "chatbot.template.grammar_trainer.topic_label": "Grammar topic",
  "chatbot.template.grammar_trainer.topic_description": "The grammar topic that the students should practice.",
  "chatbot.template.grammar_trainer.topic_placeholder": "e.g. Simple Past",
  "material.block_menu.file_upload": "File upload",
  "material.editor.file_upload.badge": "File upload",
  "material.editor.file_upload.question_placeholder": "Type the task here, e.g. \"Upload a photo of your solution.\"",
  "material.editor.file_upload.no_question": "No task",
  "material.editor.file_upload.settings.allow_file": "Upload file",
  "material.editor.file_upload.settings.allow_audio": "Record audio",
  "material.editor.file_upload.settings.allow_camera": "Camera (photo/video)",
  "material.editor.file_upload.settings.allow_link": "Link",
  "material.editor.file_upload.settings.answer_type": "Answer type",
  "material.editor.file_upload.settings.max_files_hint": "Each student can upload up to {{count}} files.",
  "material.editor.file_upload.student_action.file": "Upload file",
  "material.editor.file_upload.student_action.audio": "Record audio",
  "material.editor.file_upload.student_action.camera": "Take photo or video",
  "material.editor.file_upload.student_action.link": "Add link",
  "material.editor.file_upload.drop_here": "Drop files here",
  "material.editor.file_upload.record_again": "Record again",
  "material.editor.file_upload.already_submitted": "The file was sent to your teacher.",
  "material.editor.file_upload.already_submitted_many": "The files were sent to your teacher.",
  "material.editor.file_upload.new_try": "New try",
  "material.editor.file_upload.record_audio": "Record audio",
  "material.editor.file_upload.stop_recording": "Stop recording",
  "material.editor.file_upload.take_photo": "Take photo",
  "material.editor.file_upload.take_video": "Take video",
  "material.editor.file_upload.link_placeholder": "https://…",
  "material.editor.file_upload.link_invalid": "Please enter a valid URL.",
  "material.editor.file_upload.max_files_reached": "Maximum number of attachments reached ({{count}}).",
  "material.editor.file_upload.attachments_count": "{{count}} of max. {{max}}",
  "material.editor.file_upload.upload_error": "Upload failed.",
  "material.editor.file_upload.media_permission_denied": "Cannot access microphone or camera.",
  "material.editor.file_upload.submit": "Submit",
  "material.editor.file_upload.discard_title": "Close without submitting?",
  "material.editor.file_upload.discard_message": "Your uploads and recordings will be lost if you close this window.",
  "material.editor.file_upload.discard_confirm": "Discard",
  "material.editor.file_upload.discard_keep": "Keep editing",
  "material.editor.file_upload.evaluation.version": "Version {{number}}",
  "material.editor.file_upload.evaluation.download": "Download",
  "material.editor.file_upload.open": "Open",
  "evaluation.attempt_of_total": "Attempt {{current}} of {{total}}",
  "evaluation.conversation_of_total": "Conversation {{current}} of {{total}}",
  "evaluation.previous_conversation": "Previous attempt",
  "evaluation.previous_attempt": "Previous attempt",
  "evaluation.next_conversation": "Next attempt",
  "evaluation.next_attempt": "Next attempt",
  "evaluation.feedback": "Feedback",
  "evaluation.feedback_placeholder": "Type or speak your feedback for {{name}} here",
  "evaluation.save_feedback": "Save feedback",
  "evaluation.clear_feedback": "Clear feedback",
  "evaluation.dashboard.give_feedback": "Add feedback",
  "evaluation.dashboard.show_feedback": "Show feedback",
  "evaluation.dashboard.next_update_in": "Next update in",
  "evaluation.dashboard.reload_now": "Reload now",
  "evaluation.dashboard.legend.submitted": "Submitted",
  "evaluation.overview.edit_schedule": "Edit release settings",
  "evaluation.overview.reuse_last_schedule": "Reuse last setting",
  "evaluation.overview.schedule_save_failed": "Could not save release settings.",
  "evaluation.overview.make_visible": "Make visible",
  "evaluation.overview.set_visible_date": "Set visible date",
  "evaluation.overview.set_due_date": "Set due date",
  "evaluation.overview.reuse_last_schedule_with_dates": "Visible from: {{from}} · Editable until: {{until}}",
  "evaluation.overview.edit_visibility_all": "Edit release settings for everyone",
  "evaluation.overview.hide_material_all": "Hide for everyone",
  "evaluation.overview.visibility_all_description": "Shared dates apply to students without individual settings.",
  "evaluation.overview.title": "Learning progress",
  "evaluation.overview.subtitle": "Your students' progress across all course materials",
  "evaluation.onboarding.empty_title": "No students in this course yet",
  "evaluation.onboarding.empty_description": "Add students to make materials available to individual students here and see their progress in real time. The sample data then disappears.",
  "evaluation.onboarding.empty_description_readonly": "As soon as students are in the course, you see their progress here in real time.",
  "evaluation.onboarding.sample_material_1": "Warm-up quiz",
  "evaluation.onboarding.sample_material_2": "Worksheet",
  "evaluation.onboarding.sample_material_3": "Review",
  "evaluation.onboarding.sample_material_4": "Video",
  "evaluation.onboarding.sample_material_5": "Gap-fill",
  "evaluation.onboarding.sample_material_6": "Short quiz",
  "evaluation.onboarding.sample_material_7": "Reading text",
  "evaluation.onboarding.sample_material_8": "Matching",
  "evaluation.onboarding.sample_material_9": "Homework",
  "evaluation.onboarding.sample_material_10": "Puzzle",
  "evaluation.onboarding.sample_material_11": "Project",
  "evaluation.onboarding.sample_material_12": "Self-check",
  "evaluation.onboarding.sample_material_13": "Mind map",
  "evaluation.onboarding.sample_material_14": "Final test",
  "evaluation.overview.no_materials": "This course has no materials yet.",
  "evaluation.overview.no_materials_in_folder": "This folder has no materials.",
  "evaluation.overview.no_materials_matching_filter": "No materials match this filter.",
  "evaluation.overview.load_error": "Could not load the learning progress.",
  "evaluation.overview.all_folders": "All folders",
  "evaluation.overview.unsorted_folder": "Unsorted",
  "evaluation.overview.filter_interactive": "Has interactive assignments",
  "evaluation.overview.filter_shared": "Shared with students",
  "evaluation.overview.legend.hidden": "Hidden for student",
  "evaluation.overview.legend.hidden_with_submissions": "Hidden, but answers exist",
  "evaluation.overview.legend.time_since_last_answer": "Time since last answer",
  "evaluation.overview.legend.time_example": "20m",
  "evaluation.overview.live_now": "Now",
  "evaluation.overview.live_tooltip": "Active on this material within the last three minutes",
  "evaluation.overview.last_answer": "Last answer",
  "evaluation.overview.needs_help_tooltip": "Needs help: at least three incorrect or partially correct answers in a row",
  "evaluation.overview.show_material": "Show material for student",
  "evaluation.overview.hide_material": "Hide material for student",
  "evaluation.overview.open_feedback": "Open feedback for this material",
  "evaluation.overview.feedback_given": "Feedback or note added for this material",
  "evaluation.overview.new_answers": "New answers since the last feedback",
  "evaluation.overview.non_interactive_material": "This material has no interactive assignments",
  "teacher_feedback.label": "Feedback from teacher",
  "teacher_feedback.show_more": "Show more",
  "teacher_feedback.show_less": "Show less",
  "evaluation.mobile.show_feedback": "Show feedback",
  "evaluation.mobile.hide_feedback": "Hide feedback",
  "evaluation.dialog.static_material_title": "Static material",
  "evaluation.dialog.static_material_hint": "This material has no interactive assignments, so there are no answers here. You can still add a note or grade for {{name}}.",
  "evaluation.dialog.not_submitted_yet": "{{name}} has not worked on this task yet.",
  "evaluation.dialog.task_title": "Task",
  "evaluation.file_upload.submission": "Submission",
  "evaluation.file_upload.many_submissions": "Submissions",
  "evaluation.file_upload.submissions_count": "Submissions: {{count}}",
  "material_card.view_feedback": "View feedback",
  "grades.grade_column": "Grade",
  "grades.enable_grades": "Choose grading scheme",
  "grades.notes_only": "Notes only",
  "grades.note_for_student": "Note for {{name}}",
  "grades.save_for_student_one": "Save for {{count}} student",
  "grades.save_for_student_many": "Save for {{count}} students",
  "grades.quick_note_placeholder": "Note…",
  "grades.documentation_title_placeholder": "e.g. Group work",
  "grades.tags_for_student": "Tags for {{name}}",
  "grades.worksheet_keyboard_hint": "Enter: next student · Shift + Enter: new line",
  "grades.tag_for_student": "{{tag}} for {{name}}",
  "grades.tag": "Tag",
  "grades.start_empty": "Start empty",
  "grades.edit_documentation": "Edit documentation",
  "grades.tab_title": "Documentation",
  "grades.grade_categories": "Grade categories",
  "grades.tags": "Tags",
  "grades.student": "Student",
  "grades.students": "Students",
  "grades.manage_students": "Manage students",
  "grades.filter": "Filter",
  "grades.reset_filters": "Reset",
  "grades.add_note": "Add note",
  "grades.add_grade": "Add grade",
  "grades.add_documentation": "Record documentation",
  "grades.add_students_before_documentation": "Add students first to record documentation.",
  "grades.add_entries": "Add entries",
  "grades.delete_documentation_confirm": "Do you really want to delete this documentation? This action cannot be undone.",
  "grades.discard_note_title": "Close without saving?",
  "grades.discard_note_message": "Your unsaved changes will be lost.",
  "grades.discard_note_confirm": "Discard",
  "grades.discard_note_keep": "Keep editing",
  "grades.edit_grade": "Edit grade",
  "grades.edit_note": "Edit note",
  "grades.overview_settings": "Configure view",
  "grades.overview_subtitle": "Grades and documentation for all students at a glance",
  "grades.overview_settings_description": "Choose which grade categories, averages, and tags appear in the overview. Drag items to change their order.",
  "grades.shown_in_overview": "Show in overview",
  "grades.date": "Date",
  "grades.entry_date": "Entry date",
  "grades.title_placeholder": "Add a title…",
  "grades.bulk_title_placeholder": "Add a title for all grades…",
  "grades.grade_category": "Grade category",
  "grades.choose_grade_category": "Choose a grade category",
  "grades.change_grade_category": "Change grade category",
  "grades.choose_grade_category_hint": "Choose a grade category to continue.",
  "grades.grade": "Grade",
  "grades.choose_grade": "Choose a grade",
  "grades.note": "Note",
  "grades.observations": "Notes",
  "grades.note_placeholder": "Add a note…",
  "grades.grade_and_note": "Grade and note",
  "grades.documentation": "Documentation",
  "grades.grade_for_student": "Grade for {{name}}",
  "grades.no_matching_grades": "No matching grades",
  "grades.no_students": "Once you add students to this course, you can record grades and documentation here.",
  "grades.no_students_title": "No students available",
  "grades.no_students_course_settings": "Add students under course settings to record grades and notes.",
  "grades.add_documentation_archived": "This course has been deleted. Documentation can no longer be recorded.",
  "grades.onboarding.empty_title": "No students in this course yet",
  "grades.onboarding.empty_description": "Add students to record grades and notes. The sample data then disappears, and “Record documentation” becomes active.",
  "grades.onboarding.empty_description_readonly": "As soon as students are in the course, their grades and notes appear here.",
  "grades.onboarding.settings_hint": "Under {{settings}} you can adjust grade categories, averages and tags.",
  "grades.onboarding.settings_hint_no_categories": "This course has no grade categories yet. Set them up under {{settings}}.",
  "grades.onboarding.sample_category_mark": "Written test",
  "grades.onboarding.sample_category_participation": "Participation",
  "grades.onboarding.sample_tag_homework": "Homework missing",
  "grades.onboarding.sample_tag_positive": "Positive contribution",
  "grades.saved_grade_title": "Grade saved",
  "grades.saved_note_title": "Note saved",
  "grades.saved_entries_one": "Entry created for {{count}} student",
  "grades.saved_entries_many": "Entries created for {{count}} students",
  "grades.load_error": "Grades could not be loaded.",
  "grades.move_up": "Move up",
  "grades.move_down": "Move down",
  "grades.new_grade_category": "New grade category",
  "grades.grade_category_name_required": "Enter a name for the grade category.",
  "grades.grade_visualization": "Grade visualization",
  "grades.no_grade_categories": "No grade categories yet.",
  "grades.import_grading_structure": "Take over categories, averages, and tags from another course",
  "grades.import_grading_structure_description": "Choose the course whose categories, averages, and tags you want to use.",
  "grades.import_grading_structure_select_course": "Course",
  "grades.import_grading_structure_confirm": "Apply",
  "grades.import_grading_structure_success": "Categories, averages, and tags have been applied.",
  "grades.import_grading_structure_no_other_courses": "You have no other courses to import from.",
  "grades.import_grading_structure_list_categories_one": "{{count}} category",
  "grades.import_grading_structure_list_categories_other": "{{count}} categories",
  "grades.import_grading_structure_list_averages_one": "{{count}} average",
  "grades.import_grading_structure_list_averages_other": "{{count}} averages",
  "grades.import_grading_structure_list_tags_one": "{{count}} tag",
  "grades.import_grading_structure_list_tags_other": "{{count}} tags",
  "grades.import_grading_structure_list_failed": "Not loaded",
  "grades.import_grading_structure_warning": "Grade entries already recorded in “{{courseName}}” will be lost.",
  "grades.average": "Average",
  "grades.averages": "Averages",
  "grades.new_average": "New average",
  "grades.no_averages": "No averages configured.",
  "grades.category_average": "Category average",
  "grades.export_csv.grade_column": "{{category}} ({{index}})",
  "grades.export_csv.category_average_column": "{{category}} ({{averageSymbol}})",
  "grades.export_csv.duplicate_column": "{{name}} ({{index}})",
  "grades.class_average": "Class average",
  "grades.timeframe": "Timeframe",
  "grades.whole_school_year": "Whole school year",
  "grades.custom_timeframe": "Custom date range",
  "grades.weighting": "Weighting",
  "grades.equal_weighting": "Equal weighting",
  "grades.custom_weighting": "Custom weighting",
  "grades.total_weight": "Total weight",
  "grades.total_weight_validation": "The total weight must equal 100% before you can save.",
  "grades.category_weight_validation": "Each selected category must have a weight greater than 0%.",
  "grades.distribute_equally": "Distribute equally",
  "grades.grade_invalid_level_removed": "This grade no longer matches a level in the current scheme. The level may have been removed or changed.",
  "grades.grade_invalid_scheme_changed": "This grade uses an older grading scheme than the category. Choose a grade again.",
  "grades.grade_invalid_scheme_unavailable": "The grading scheme for this grade is no longer available. Open the entry and choose a grade again.",
  "grades.new_tag": "New tag",
  "grades.tag_color": "Tag color",
  "grades.grading_scheme_group": "Schema group",
  "grades.grading_scheme_group_generic": "Generic types",
  "grades.grading_scheme_group_other": "Other",
  "grades.grading_scheme_name_thumbs_three_level": "Thumbs",
  "grades.grading_scheme_name_not_fulfilled_fulfilled": "Not met / met",
  "grades.grading_scheme_name_one_to_five_detailed": "1–5 detailed",
  "grades.grading_scheme_name_one_to_ten_detailed": "1–10 detailed",
  "grades.grading_scheme_name_us": "US letter grades",
  "grades.grading_scheme_name_plant_growth": "Competence flower",
  "grades.import_grading_structure_unavailable_schemes": "This course uses grading schemes that are unavailable here: {{schemeNames}}. Choose another course or replace these schemes in the source course.",
  "grades.add_grading_scheme": "New scheme",
  "grades.edit_grading_scheme": "Edit grading scheme",
  "grades.delete_grading_scheme_title": "Delete grading scheme?",
  "grades.delete_grading_scheme_message": "Delete “{{name}}”? Existing grades keep their values; the scheme will no longer appear in the picker.",
  "grades.custom_scheme_name_required": "Enter a name for the grading scheme.",
  "grades.custom_scheme_name_too_long": "The grading scheme name may have at most {{maxLength}} characters.",
  "grades.custom_scheme_label_mode": "Level labels",
  "grades.custom_scheme_label_text": "Text",
  "grades.custom_scheme_label_emoji": "Emoji",
  "grades.custom_scheme_supports_average": "Counts toward average calculation",
  "grades.custom_scheme_label_too_long": "A level label may have at most {{maxLength}} characters.",
  "grades.custom_scheme_levels": "Levels",
  "grades.custom_scheme_level_label": "Label",
  "grades.custom_scheme_default_level_low": "Low",
  "grades.custom_scheme_default_level_mid": "Medium",
  "grades.custom_scheme_default_level_high": "High",
  "grades.custom_scheme_level_value": "Value",
  "grades.custom_scheme_level_grade_value": "Grade value",
  "grades.custom_scheme_add_level": "Add level",
  "grades.custom_scheme_duplicate_label": "Each level needs a unique label.",
  "grades.custom_scheme_duplicate_emoji": "Each level needs a unique emoji.",
  "grades.custom_scheme_duplicate_value": "Each numeric value must be unique.",
  "grades.custom_scheme_label_required": "Enter a label for each level.",
  "grades.custom_scheme_value_required": "Enter a valid number between 0 and 100 for each level.",
  "grades.no_tags": "No tags yet.",
  "grades.no_matching_documentation": "No documentation matches the selected filters.",
  "grades.no_documentation_yet": "There is no documentation for this student yet.",
  "grades.ai_generated_pending": "AI generated · Awaiting approval",
  "grades.ai_generated_approved": "AI generated · Approved",
  "grades.approve_ai_entry": "Approve",
  "grades.documentation_count": "Entries: {{count}}",
  "grades.export_student_csv": "Export all entries as CSV",
  "grades.select_tag_for_all_students": "Select “{{tag}}” for all students",
  "grades.clear_tag_for_all_students": "Clear “{{tag}}” for all students",
  "grades.view_details": "View details",
  "grades.colors.grey": "Grey",
  "grades.colors.amber": "Amber",
  "grades.colors.green": "Green",
  "grades.colors.red": "Red",
  "grades.colors.blue": "Blue",
  "grades.colors.violet": "Violet",
  "sample_preview.row_tag": "Sample",
  "sample_preview.hide": "Hide sample data",
  "sample_preview.show": "Show sample data",
  "sample_preview.student_1": "Anna Smith",
  "sample_preview.student_2": "Ben Taylor",
  "sample_preview.student_3": "Lea Brown",
  "generic_print": "Print",
  "timetable.empty_state_manual_title": "Create manually",
  "timetable.empty_state_manual_description": "Create and maintain your timetable directly in Teachino.",
  "timetable.empty_state_integration_title": "Connect an existing timetable",
  "timetable.empty_state_integration_description": "Synchronize your lessons with your school's timetable system.",
  "timetable.empty_state_integration_action": "Connect timetable",
  "timetable.empty_state_integration_dialog_title": "Connect an existing timetable",
  "timetable.no_lessons_in_week_title": "No lessons in this week",
  "timetable.no_lessons_in_week_description": "Your timetable is set up. Your next lesson is on {{date}}.",
  "timetable.no_lessons_in_week_none_upcoming": "Your timetable is set up, but no further lessons are planned.",
  "timetable.no_lessons_in_week_action": "Jump to that week",
  "timetable.breadcrumb.courses": "Courses",
  "timetable.tabs.vacations": "Add vacations",
  "timetable.tabs.timetables": "Create timetables",
  "timetable.tabs.weeks": "Assign school weeks",
  "timetable.continue.timetables": "Continue to timetables",
  "timetable.continue.weeks": "Continue to week assignment",
  "timetable.saving": "Saving …",
  "timetable.external_integration.title": "Your timetable stays in sync automatically",
  "timetable.external_integration.description": "{{source}} manages your timetable, so it can’t be edited here. You can still match imported courses with your Teachino courses below.",
  "timetable.profile_prefill.title": "Add country / state to prefill",
  "timetable.profile_prefill.description": "Add your school location and school type in profile settings to prefill official vacations.",
  "timetable.profile_prefill.action": "Add country / state",
  "timetable.mode.title": "How does your timetable change during the year?",
  "timetable.mode.description": "Choose the setup that matches your school year. You can still add more timetables later.",
  "timetable.mode.single_title": "Same timetable for the entire year",
  "timetable.mode.single_description": "Start with one timetable and use it for every teaching week.",
  "timetable.mode.multiple_title": "Changing timetables",
  "timetable.mode.multiple_description": "Start with Week A and Week B, ready to assign across the year.",
  "timetable.vacations.title": "Vacations",
  "timetable.vacations.description": "Vacation weeks will be skipped when timetables are assigned.",
  "timetable.vacations.add": "Add vacation",
  "timetable.vacations.edit": "Edit vacation",
  "timetable.vacations.remove": "Remove vacation",
  "timetable.vacations.empty_title": "No vacations added",
  "timetable.vacations.empty_description": "Add vacations that should be skipped when timetables are assigned.",
  "timetable.vacations.empty_action": "Add your first vacation",
  "timetable.vacations.dialog_add_title": "Add vacation",
  "timetable.vacations.dialog_edit_title": "Edit vacation",
  "timetable.vacations.start_date": "Start date",
  "timetable.vacations.end_date": "End date",
  "timetable.vacations.invalid_dates": "The end date must be on or after the start date.",
  "timetable.pattern.title": "Timetables",
  "timetable.pattern.description": "Create once, assign to any week.",
  "timetable.pattern.add": "Add timetable",
  "timetable.pattern.new": "New timetable",
  "timetable.pattern.week_a": "Week A",
  "timetable.pattern.week_b": "Week B",
  "timetable.pattern.new_numbered": "New timetable {{number}}",
  "timetable.pattern.school_year_name": "Timetable {{schoolYear}}",
  "timetable.pattern.copy": "{{name}} copy",
  "timetable.pattern.empty": "Empty timetable",
  "timetable.pattern.lesson_count_one": "{{count}} period",
  "timetable.pattern.lesson_count_many": "{{count}} periods",
  "timetable.pattern.name": "Timetable name",
  "timetable.pattern.cell_hint": "Click any cell to choose or change its course.",
  "timetable.pattern.add_more": "Add more timetables",
  "timetable.pattern.minimum_one": "You need at least one timetable",
  "timetable.pattern.duplicate": "Copy",
  "timetable.pattern.period": "Period",
  "timetable.pattern.no_course": "No course",
  "timetable.pattern.empty_cells": "Empty cells mean you have no lesson in that period.",
  "timetable.periods.title": "Edit time grid",
  "timetable.periods.description": "Adjust all period times at once. Timetables using these periods update immediately.",
  "timetable.periods.start": "Start",
  "timetable.periods.end": "End",
  "timetable.periods.invalid": "Every period needs an end time after its start time.",
  "timetable.periods.save": "Save period times",
  "timetable.delete.title": "Delete timetable?",
  "timetable.delete.message": "Delete “{{name}}”? Weeks using it will need a new timetable.",
  "timetable.delete.planned_lessons_explainer": "Periods that have already been planned will only be available again after a new timetable is added for the same time period.",
  "timetable.delete.action": "Delete timetable",
  "timetable.weeks.description": "Assign a reusable timetable to each teaching week.",
  "timetable.weeks.calendar_week": "CW",
  "timetable.weeks.vacation": "Vacation",
  "timetable.weeks.vacation_starts_midweek": "starts on {{date}}",
  "timetable.weeks.vacation_ends_midweek": "ends on {{date}}",
  "timetable.weeks.vacation_within_week": "starts on {{startDate}} and ends on {{endDate}}",
  "timetable.weeks.choose": "Choose timetable…",
  "timetable.weeks.apply_prompt": "Use this timetable for every following teaching week? Vacation weeks will be skipped.",
  "timetable.weeks.not_now": "Not now",
  "timetable.weeks.apply_every_second": "Apply to every second week",
  "timetable.weeks.apply_all_future": "Apply to all future weeks",
  "timetable.weeks.all_assigned": "All weeks assigned",
  "timetable.weeks.needs_attention_one": "{{count}} week needs attention",
  "timetable.weeks.needs_attention_many": "{{count}} weeks need attention",
  "timetable.weekday.monday": "Monday",
  "timetable.weekday.tuesday": "Tuesday",
  "timetable.weekday.wednesday": "Wednesday",
  "timetable.weekday.thursday": "Thursday",
  "timetable.weekday.friday": "Friday",
  "timetable.period.number": "Period {{number}}",
  "timetable.period.1": "Period 1",
  "timetable.period.2": "Period 2",
  "timetable.period.3": "Period 3",
  "timetable.period.4": "Period 4",
  "timetable.period.5": "Period 5",
  "timetable.period.6": "Period 6",
  "planning.title": "Planning",
  "planning.heading": "Plan lessons",
  "planning.open_full_planning": "Open full planning view",
  "planning.add_lesson_short": "Lesson",
  "planning.add_additional_lesson": "Add additional lesson",
  "planning.description": "Materials, notes and to-dos across all lesson dates.",
  "planning.read_only_description": "Saved materials, notes and to-dos across all dates in this school year.",
  "planning.vacation": "Vacation",
  "planning.cancelled_lesson": "Cancelled",
  "planning.no_scheduled_lesson": "No scheduled lesson",
  "planning.period_tags": "Period tags",
  "planning.other_teacher_lesson": "Lesson taught by {{teacher}}",
  "planning.shared_teacher_lesson": "Lesson with {{teacher}}",
  "planning.enlarge_note": "Enlarge note",
  "planning.note_autosaved": "Changes are saved automatically.",
  "planning.class_register_needs_review": "Review class register entry",
  "planning.class_register_needs_review_description": "Review the saved entry and update it from the current plan if needed.",
  "planning.update_class_register_from_plan": "Update from current plan",
  "planning.notes": "Notes",
  "planning.materials": "Materials",
  "planning.todos": "To-dos",
  "planning.note": "Note",
  "planning.material": "Material",
  "planning.todo": "To-do",
  "planning.add_note": "Add note",
  "planning.add_material": "Add material",
  "planning.collection_material_planned": "Planned",
  "planning.collection_material_exists.title": "Material already in course",
  "planning.collection_material_exists.description": "\"{{materialName}}\" is already in this course in the folder \"{{folderName}}\". Do you want to plan the existing material or create another copy and plan it?",
  "planning.collection_material_exists.intro": "This material is already in your course.",
  "planning.collection_material_exists.choose_action": "How would you like to continue?",
  "planning.collection_material_exists.plan_existing": "Plan existing",
  "planning.collection_material_exists.plan_existing_title": "Plan existing material",
  "planning.collection_material_exists.plan_existing_hint": "Add the copy in your course to this lesson without duplicating it again.",
  "planning.collection_material_exists.copy_again": "Copy again and plan",
  "planning.collection_material_exists.copy_again_title": "Create a copy and plan",
  "planning.collection_material_exists.copy_again_hint": "Add another copy to the course and plan it for this lesson.",
  "planning.import_folder_and_plan.button_short": "Copy folder and plan",
  "planning.import_folder_and_plan.planned_success": "Added {{count}} materials to this lesson.",
  "planning.import_folder_and_plan.none_planned": "The folder was copied, but no materials could be added to this lesson.",
  "planning.import_folder_copy.success": "Folder copied to your course.",
  "planning.import_external_material.not_in_course_tag": "Not in course",
  "planning.import_external_material.title": "Material not in course yet",
  "planning.import_external_material.intro": "This material is not in your course yet. Choose how you want to add it before planning.",
  "planning.import_external_material.choose_action": "How would you like to proceed?",
  "planning.import_external_material.copy_material_title": "Copy only this material",
  "planning.import_external_material.copy_material_hint": "Choose a folder in your course, then plan this material.",
  "planning.import_external_material.copy_folder_title": "Copy the whole folder",
  "planning.import_external_material.copy_folder_hint": "Copy “{{folderName}}” into your course, then plan this material.",
  "planning.import_destination_folder.title": "Choose destination folder",
  "planning.import_destination_folder.intro": "Where should “{{materialName}}” be copied in this course?",
  "planning.import_destination_folder.existing_title": "Existing folder",
  "planning.import_destination_folder.existing_hint": "Add the material to a folder that is already in this course.",
  "planning.import_destination_folder.new_title": "New folder",
  "planning.import_destination_folder.new_hint": "Create a new folder in this course for the material.",
  "planning.import_destination_folder.no_writable_folder": "You cannot add materials to any existing folder. Create a new folder instead.",
  "planning.import_destination_folder.no_destination_available": "You cannot add materials to this course because no folder is available and you cannot create one.",
  "planning.import_destination_folder.confirm": "Continue",
  "planning.import_destination_folder.back_to_existing": "Choose existing folder",
  "planning.import_destination_folder.folder_created_success": "Folder “{{folderName}}” was created.",
  "planning.folder_exists.title": "Folder already in course",
  "planning.folder_exists.intro": "This folder is already in your course.",
  "planning.folder_exists.plan_existing_title": "Plan existing folder",
  "planning.folder_exists.plan_existing_hint": "Add materials from the existing folder to this lesson without copying again.",
  "planning.folder_exists.copy_again_title": "Copy folder again and plan",
  "planning.folder_exists.copy_again_hint": "Create another folder in the course and add all materials to this lesson.",
  "planning.folder_exists.copy_only_prompt": "You can copy this folder into your course again.",
  "planning.folder_exists.copy_again_title_copy_only": "Copy folder again",
  "planning.folder_exists.copy_again_hint_copy_only": "Create another copy of this folder in your course.",
  "planning.add_todo": "Add to-do …",
  "planning.add_event": "Add tag",
  "planning.choose_start_date": "Choose start date",
  "planning.today": "Today",
  "planning.retry": "Try again",
  "planning.load_failed": "Planning could not be loaded",
  "planning.no_upcoming_lessons": "No upcoming lessons",
  "planning.no_upcoming_lessons_description": "There are no more dates for this course.",
  "planning.vacation_only_title": "Only vacations planned",
  "planning.vacation_only_description": "This course doesn't have a timetable yet. Add one to start planning lessons.",
  "planning.no_saved_content": "No saved planning content",
  "planning.no_saved_content_description": "There are no materials, notes or to-dos saved for this school year.",
  "planning.move_material": "Move material",
  "planning.remove_material": "Remove material",
  "planning.remove_tag": "Remove {{tag}}",
  "planning.shift": "Move planning to later lessons",
  "planning.shift_question": "Move planning to later lessons?",
  "planning.shift_all": "Move planning from here to later lessons",
  "planning.shift_success": "Planning was moved to later lessons.",
  "planning.shift_failed": "Planning could not be shifted.",
  "planning.shift_no_next": "There is no next period.",
  "planning.shift_blocked": "There are not enough remaining lesson dates to shift {{content}}. Remove or move this content first.",
  "planning.shift_description": "All selected content from {{date}} will be moved to the next period.",
  "planning.class_register": "Class register",
  "planning.current_period": "Now: {{title}} from {{from}} to {{to}}",
  "planning.class_register_draft": "Class register draft",
  "planning.class_register_completed": "Class register sent",
  "planning.class_register_saved_locally": "Teaching content saved",
  "planning.saved": "Saved",
  "planning.not_saved": "Not saved",
  "planning.note_placeholder": "Type a note",
  "planning.delete": "Delete",
  "planning.toggle_todo": "Toggle to-do completion",
  "planning.edit_todo": "Edit to-do",
  "planning.move_todo_date": "Move to another date",
  "planning.close": "Close",
  "planning.cancel": "Cancel",
  "planning.material_load_failed": "Course materials could not be loaded.",
  "planning.manage_tags": "Manage tags",
  "planning.create_tag": "Create tag",
  "planning.delete_tag": "Delete tag",
  "planning.save_draft": "Save as draft",
  "planning.send_class_register": "Send to class register",
  "planning.copy_class_register": "Copy class register",
  "planning.class_register_content": "Class register entry",
  "planning.previous": "Previous",
  "planning.next": "Next",
  "planning.todos_for_date": "To-dos for {{date}}",
  "planning.move_note": "Move note",
  "todo_more": "+{{count}} more",
  "generic_yes": "Yes",
  "generic_no": "No",
  "dpa.eyebrow": "Data processing agreement",
  "dpa.title": "DPA for your school",
  "dpa.legal_explanation": "The data processing agreement supports your school in meeting its obligations under the GDPR and EU AI Act when using Teachino. See our privacy information for further legal details.",
  "dpa.download": "Download the current DPA",
  "dpa.document.description": "Download the current DPA as a PDF",
  "dpa.document.last_changed": "Last updated",
  "dpa.privacy_link": "Privacy information",
  "dpa.privacy.description": "Learn more about how Teachino handles personal data and AI",
  "dpa.privacy.info_label": "For information only",
  "dpa.existing.question": "Start signing process",
  "dpa.existing.explanation": "In the next step, you can sign the DPA or send it to your school leadership. If your school has already entered into a DPA with Teachino, no new agreement is needed. Enter the school details and we will match the existing DPA.",
  "dpa.existing.answer_yes": "My school has already signed a DPA",
  "dpa.existing.answer_no": "Sign a new DPA",
  "dpa.school.title": "School details",
  "dpa.school.name": "School name",
  "dpa.school.address": "Full address",
  "dpa.leadership.question": "Are you a member of the school leadership?",
  "dpa.no_cost": "Signing the DPA does not create any costs for the school.",
  "dpa.direct.title": "Review and sign the DPA",
  "dpa.signer.name": "Full name",
  "dpa.signer.email": "Email address",
  "dpa.signer.email_help": "We will send a six-digit verification code to this address. Please use your school email address.",
  "dpa.accept": "I have read the DPA, am authorised to sign for the school, and accept the agreement.",
  "dpa.send_code": "Send verification code",
  "dpa.code.title": "Verify your email",
  "dpa.code.help": "We sent a six-digit code by email. It is valid for 30 minutes.",
  "dpa.code.label": "Verification code",
  "dpa.verify": "Sign the DPA",
  "dpa.resend": "Resend code",
  "dpa.handoff.title": "Send to school leadership",
  "dpa.handoff.help": "The link is valid for 30 days. Copy either the link or the complete prepared email.",
  "dpa.handoff.link_label": "Signing link",
  "dpa.handoff.email_label": "Prepared email",
  "dpa.copy_link": "Copy link",
  "dpa.copy_email": "Copy email",
  "dpa.copied": "Copied",
  "dpa.review.title": "Request submitted",
  "dpa.review.before_submit_title": "What happens next",
  "dpa.review.before_submit_help": "When you submit the request, the Teachino team will be notified. We will review your details as soon as possible and get back to you.",
  "dpa.review.submit": "Submit request",
  "dpa.review.help": "We will check whether your school already has a DPA and get back to you shortly.",
  "dpa.signed.title": "DPA signed successfully",
  "dpa.signed.help": "The feature has been enabled for your personal license.",
  "dpa.continue": "Back to Teachino",
  "dpa.error.generic": "Something went wrong. Please try again.",
  "dpa.error.invalid_code": "The code is invalid or expired. Check it and try again.",
  "dpa.public.title": "Sign Teachino's DPA",
  "dpa.public.review": "Review school details and agreement",
  "dpa.public.signed": "Thank you – the DPA has been signed",
  "dpa.public.signed_help": "The requesting teacher has been informed and the feature has been enabled.",
  "dpa.public.invalid": "This link is no longer valid",
  "dpa.public.invalid_help": "The link has expired, has already been used, or was replaced by a newer request. Please contact the requesting teacher.",
  "dpa.trust.label": "Privacy and trust",
  "dpa.trust.gdpr.title": "Data protection framework",
  "dpa.trust.gdpr.description": "The DPA documents the data protection framework for processing personal data.",
  "dpa.trust.eu.title": "Data processing in the EU",
  "dpa.trust.eu.description": "The DPA describes where personal data is processed and which processors are involved.",
  "dpa.trust.encryption.title": "Encryption",
  "dpa.trust.encryption.description": "Technical safeguards protect data in transit and at rest.",
  "dpa.loading": "Loading agreement…",
  "dpa.code.sent_to": "We sent the code to {{email}}.",
  "dpa.resend_in": "Resend in {{seconds}}s",
  "dpa.error.code_rejected": "This code is no longer valid. Please request a new one.",
  "material.student_visibility.continue_without_students": "Continue without students",
  "material.student_visibility.empty.title": "No students created yet",
  "material.student_visibility.empty.create_students_description": "Create students for your course \"{{courseName}}\" and hand out personal access codes.",
  "material.student_visibility.empty.without_students_description": "Alternatively: Students open the link and enter their name or initials themselves. They receive a code to access it again later.",
  "material.student_visibility.empty.description": "Create students first. They receive a personal code to access shared materials, including their own answers and submissions.",
  "material.unavailable.title": "This material is unavailable",
  "material.unavailable.description": "It may have been deleted, or you may not have permission to access it.",
  "material.unavailable.action": "Go to my courses",
  "ai.assistant.action.folders_created": "{{count}} folders created",
  "material.student_visibility.no_students.title": "No students yet",
  "material.student_visibility.no_students.description": "You don't have any students in this course yet. Create students or enable the public link.",
  "material.student_visibility.no_students.public_link_description": "Students can register themselves using the link.",
  "integration.authenticate_eduplaces.description": "Sign in to Teachino with Eduplaces and import shared groups and students into your courses.",
  "integration.eduplaces.description": "Connect Teachino with Eduplaces to use single sign-on and import courses and students.",
  "ai.assistant.voice.starting": "Waiting for microphone…",
  "ai.assistant.voice.detected": "Sound detected",
  "ai.assistant.voice.quiet": "No sound detected — check your microphone",
  "ai.assistant.voice.ready": "Recording complete. Ready to send.",
  "ai.assistant.voice.change_microphone": "Change microphone (starts a new recording)",
  "ai.assistant.voice.empty": "No speech was recognised. Please record your message again.",
  "material.assignment_open_question.edited_by_teacher": "Edited by teacher",
  "material.assignment_open_question.edit_feedback": "Edit feedback",
  "material.assignment_open_question.feedback_rating": "Emoji",
  "auth.two_factor.title": "Two-factor authentication",
  "auth.two_factor.verify": "Verify",
  "auth.two_factor.challenge_description": "Enter the six-digit code from your authenticator app or one of your recovery codes.",
  "auth.two_factor.code_label": "Authentication code",
  "auth.two_factor.invalid_or_expired": "The code is invalid or expired. Please try again.",
  "auth.two_factor.locked_out": "Too many incorrect codes. Two-factor verification is temporarily locked. Please try again in a few minutes.",
  "auth.two_factor.setup_failed": "Two-factor authentication setup could not be started.",
  "auth.two_factor.invalid_code": "The authentication code is invalid.",
  "auth.two_factor.enabled_description": "Two-factor authentication is enabled for your account.",
  "auth.two_factor.setup_description": "Add an authenticator app to protect your account with a second sign-in step.",
  "auth.two_factor.scan_qr_description": "Scan this QR code with your authenticator app, or enter the secret manually.",
  "auth.two_factor.six_digit_code": "Six-digit code",
  "auth.two_factor.enable": "Enable two-factor authentication",
  "auth.two_factor.code_placeholder": "Authenticator or recovery code",
  "auth.two_factor.regenerate_recovery_codes": "Generate new recovery codes",
  "auth.two_factor.disable": "Disable two-factor authentication",
  "auth.two_factor.setup": "Set up two-factor authentication",
  "auth.two_factor.save_recovery_codes": "Save these recovery codes now. They will not be shown again.",
  "auth.two_factor.download_recovery_codes": "Download recovery codes",
  "course.add_content_menu.create_blank_material": "Create blank material",
  "course.add_content_menu.create_link": "Create link",
  "course.add_content_menu.upload_files": "Upload files",
  "course.create_link.url": "Link",
  "course.create_link.placeholder": "https://example.com",
  "course.add_content_menu.new": "New",
  "ai.assistant.image_choice.preview_unavailable": "Preview unavailable",
  "ai.assistant.image_choice.open_source": "Open source",
  "ai.assistant.image_choice.select": "Select image",
  "ai.assistant.image_choice.selected": "Selected",
  "ai.assistant.image_choice.use_selected": "Use selected images ({{count}})",
  "ai.assistant.image_choice.request": "I select these images for my request:\n{{images}}",
  "ai.assistant.student_note.pending": "Awaiting approval",
  "ai.assistant.student_note.approved": "Approved",
  "ai.assistant.student_note.grade": "Grade",
  "ai.assistant.student_note.created": "AI generated",
  "material.schedule.visible_from": "Visible from",
  "material.schedule.editable_until": "Editable until",
  "material.schedule.immediately": "Immediately",
  "material.schedule.no_deadline": "No deadline",
  "material.schedule.timezone": "Timezone: {timezone}",
  "material.schedule.lesson": "Choose a lesson",
  "material.schedule.individual": "Individual schedules",
  "material.schedule.inherit": "Use shared date ({{date}})",
  "time_input.hours": "Hours",
  "time_input.minutes": "Minutes",
  "material.navigation_notice.title": "New material navigation",
  "material.navigation_notice.description": "You can now find material actions at the top right of the navigation bar.",
  "material.navigation_notice.dismiss": "Don't show again",
  "material.schedule.invalid_time": "Enter a valid time, for example 08:30.",
  "material.schedule.invalid": "The deadline must be after the release time.",
  "material.schedule.hidden": "Hidden",
  "material.schedule.scheduled": "Scheduled",
  "material.schedule.available": "Available",
  "material.schedule.expired": "Read-only: deadline passed",
  "material.schedule.print_codes": "Print access codes",
  "material.schedule.confirm": "Confirm release",
  "material.schedule.change": "Change",
  "material.schedule.retry": "Retry",
  "material.schedule.retry_lessons": "Reload lesson suggestions",
  "material.student_visibility.configure_individually": "Set individually for each student",
  "material.student_visibility.confirm_release": "Make material available",
  "material.student_visibility.confirm_revoke": "Remove access",
  "material.student_visibility.edit_settings": "Edit",
  "material.student_visibility.editable_until": "Editable until",
  "material.student_visibility.immediately": "Immediately",
  "material.student_visibility.invalid_dates": "The editing deadline must be on or after the visibility start date.",
  "material.student_visibility.tooltip_different_dates": "Different dates for each student",
  "material.student_visibility.tooltip_immediate_count": "{{count}} immediately",
  "material.student_visibility.tooltip_no_deadline_count": "{{count}} with no deadline",
  "material.student_visibility.tooltip_individual_one": "{{count}} individual date",
  "material.student_visibility.tooltip_individual_many": "{{count}} individual dates",
  "material.student_visibility.tooltip_all": "All students",
  "material.student_visibility.tooltip_selected": "All selected students",
  "material.student_visibility.tooltip_others": "All other students",
  "material.student_visibility.tooltip_other_selected": "All other selected students",
  "material.student_visibility.no_deadline": "No deadline",
  "material.student_visibility.no_upcoming_periods": "No upcoming course periods",
  "material.student_visibility.other_period": "Enter date",
  "material.student_visibility.change_date": "Change date",
  "material.student_visibility.periods_retry": "Reload course periods",
  "material.student_visibility.release_all": "Make material available to all students",
  "material.student_visibility.release_audience": "Available to {{visible}} of {{total}} students",
  "material.student_visibility.release_complete": "Material available",
  "material.student_visibility.release_revoked": "Access removed",
  "material.student_visibility.release_scheduled": "Release scheduled",
  "material.student_visibility.release_student": "Make available to {{name}}",
  "material.student_visibility.release_summary": "Available to {{visible}} of {{total}} students",
  "material.student_visibility.release_summary_scheduled": "Access scheduled for {{visible}} of {{total}} students",
  "material.student_visibility.qr_description": "This QR code links directly to the material.",
  "course.distribute_access": "Distribute access",
  "material.student_visibility.share_title": "Distribute",
  "material.student_visibility.release_title": "Material access",
  "material.student_visibility.retry": "Try again",
  "material.student_visibility.schedule_for_student": "Schedule for {{name}}",
  "material.student_visibility.share_link_error": "The material link could not be loaded.",
  "material.student_visibility.visible_from": "Visible from",
  "material.student_visibility.release_for_students": "Make available to students",
  "material.preview.banner": "Preview · This is how your students see the material.",
  "material.preview.tooltip": "Preview from your students’ perspective",
  "material.schedule.individual_releases": "Individual releases",
  "material.student_visibility.share_tooltip": "Make material available to students",
  "material.student_visibility.distribute_tooltip": "Share access to the material with students",
  "evaluation.overview.view_progress": "View learning progress",
  "material.print_tooltip": "Print material",
  "material.student_deadline.editable_until": "Editable until {{date}}",
  "material.student_deadline.expired": "Editing deadline passed: {{date}} · Read-only",
  "material.student_visibility.saved_refresh_failed": "Your changes were saved, but the course view could not be refreshed. Please reload the page.",
  "material.student_visibility.save_changes": "Save changes",
  "material.student_visibility.release_material": "Make material available to students",
  "material.student_deadline.access_check_failed": "Access could not be checked. Your input has been preserved. Please try again.",
  "integration.authenticate.required_integration_title": "Connect {{integration}} first",
  "integration.authenticate.required_integration_description": "Connect {{requiredIntegration}} to your Teachino account before connecting {{integration}}.",
  "integration.authenticate.required_integration_connect": "Sign in with {{integration}}",
  "integration.authenticate.required_integration_return": "Finish signing in and connecting your account in the new tab, then return here and continue. If no tab opened, try signing in again.",
  "integration.authenticate.required_integration_continue": "I’ve finished signing in — Continue",
  "material.divider.label": "Section",
  "material.pages.position": "Page {{current}} of {{total}}",
  "material.pages.progress": "Material progress",
  "material.pages.navigation": "Material pages",
  "material.pages.end": "You’ve reached the last page.",
  "presentation.controls": "Presentation controls",
  "presentation.close": "Close presentation",
  "presentation.lesson.overview": "Lesson overview",
  "presentation.settings.label": "Settings",
  "presentation.font.label": "Text size",
  "presentation.font.normal": "Normal",
  "presentation.font.large": "Large",
  "presentation.font.largest": "Extra large",
  "presentation.laser": "Laser pointer",
  "presentation.dark_mode": "Dark mode",
  "presentation.drawing.pen": "Pen",
  "presentation.drawing.highlighter": "Highlighter",
  "presentation.drawing.controls": "Drawing controls",
  "presentation.drawing.undo": "Undo last stroke",
  "presentation.drawing.clear": "Clear drawings on this page",
  "presentation.drawing.surface": "Drawing surface",
  "presentation.tools.label": "Tools",
  "presentation.tools.clock": "Clock",
  "presentation.tools.timer": "Timer",
  "presentation.tools.stopwatch": "Stopwatch",
  "presentation.tools.sound": "Sound level",
  "presentation.tools.traffic": "Traffic light",
  "presentation.tools.work": "Work format",
  "presentation.tools.move": "Move {{tool}} (drag or use arrow keys)",
  "presentation.tools.remove": "Remove tool",
  "presentation.tools.remaining": "Time remaining",
  "presentation.tools.finished": "Time is up",
  "presentation.tools.minutes": "Minutes",
  "presentation.tools.seconds": "Seconds",
  "presentation.tools.pause": "Pause",
  "presentation.tools.start": "Start",
  "presentation.tools.reset": "Reset",
  "presentation.tools.alarm": "Play a sound when finished",
  "presentation.tools.sound.loud": "A little quieter, please",
  "presentation.tools.sound.ok": "Sound level is fine",
  "presentation.tools.sound.requesting": "Allow microphone access to measure the sound level.",
  "presentation.tools.sound.denied": "Microphone access was denied. Allow it in your browser settings, then try again.",
  "presentation.tools.sound.unavailable": "No microphone is available. Check your device and try again.",
  "presentation.tools.sound.paused": "Microphone paused",
  "presentation.tools.sound.sensitivity": "Microphone sensitivity",
  "presentation.tools.sound.limit": "Maximum sound level",
  "presentation.tools.sound.enable": "Enable microphone",
  "presentation.tools.sound.local": "Measured on this device. No audio is recorded or sent.",
  "presentation.tools.traffic.red": "Stop",
  "presentation.tools.traffic.amber": "Get ready",
  "presentation.tools.traffic.green": "Go",
  "presentation.tools.work.silence": "Silence",
  "presentation.tools.work.whisper": "Whisper",
  "presentation.tools.work.group": "Group work",
  "presentation.tools.work.partner": "Ask a partner",
  "presentation.drawing.color": "Ink color",
  "presentation.drawing.color.red": "Red",
  "presentation.drawing.color.yellow": "Yellow",
  "presentation.drawing.color.green": "Green",
  "presentation.drawing.color.blue": "Blue",
  "presentation.drawing.color.purple": "Purple",
  "presentation.drawing.color.black": "Black",
  "presentation.drawing.color.white": "White",
  "presentation.drawing.width": "Stroke width",
  "presentation.drawing.width.thin": "Thin",
  "presentation.drawing.width.medium": "Medium",
  "presentation.drawing.width.thick": "Thick",
  "presentation.break.start": "Hide material",
  "presentation.break.resume": "Show material again",
  "presentation.pointer.label": "Cursor",
  "presentation.pointer.normal": "Normal cursor",
  "presentation.pointer.laser": "Laser pointer",
  "presentation.pointer.spotlight": "Spotlight",
  "presentation.spotlight.circleSmall": "Circle (small)",
  "presentation.spotlight.content": "Scan",
  "presentation.spotlight.circleLarge": "Circle (large)",
  "presentation.scan.move": "Move scan (drag or use arrow keys)",
  "presentation.scan.resize": "Resize scan (drag or use arrow keys)",
  "presentation.scan.close": "Close scan",
  "presentation.attention.label": "Attention signal",
  "presentation.attention.title": "Attention, please",
  "presentation.attention.instruction": "Pause what you’re doing. Listen to the teacher.",
  "presentation.sharing.open": "Student QR code",
  "presentation.sharing.close": "Return to presentation",
  "presentation.sharing.choose_course": "Which course?",
  "presentation.sharing.no_course": "Add this material to a course first to share it with students.",
  "presentation.sharing.edit": "Edit sharing",
  "presentation.sharing.release": "Share material with students",
  "presentation.sharing.retry": "Try again",
  "presentation.attention.ring": "Ring the bell",
  "presentation.promotion.hint": "The new presentation mode is here.",
  "presentation.promotion.try": "Try it",
  "presentation.promotion.dismiss": "Dismiss hint",
  "material.student_display.title": "Student display",
  "material.student_display.info": "Explain display modes",
  "material.student_display.scroll": "Scroll",
  "material.student_display.sections": "Sections",
  "material.student_display.intro": "These are the ways students can navigate the material.",
  "material.student_display.scroll_description": "The entire material is displayed on one page. Students scroll from top to bottom.",
  "material.student_display.sections_description": "Students see one section at a time and use Next and Back to move from page to page.",
  "material.student_display.section_title": "What is a section?",
  "material.student_display.section_description": "Sections can be added using the + in the material. Interactive assignments always form a separate section.",
  "material.student_display.image": "Image",
  "material.student_display.assignment": "Interactive assignment",
  "material.student_display.manual_section": "Manually created section",
  "material.student_display.scroll_hint": "Everything on one page · scroll down",
  "material.student_display.section_position": "Section {{current}} of {{total}}",
  "material.student_summary.title": "Your progress",
  "material.student_summary.success_title": "You did it!",
  "material.student_summary.success_description": "You solved every activity correctly. Great work — be proud of what you have learned!",
  "material.student_summary.review_title": "Look how far you have come",
  "material.student_summary.review_description": "Check your results below. You can jump back to any activity to finish it or try again. Submitted work may still need feedback.",
  "material.student_summary.no_activities": "You have reached the end of this material. Take a moment to think about what you have learned.",
  "material.student_summary.correct": "Correct",
  "material.student_summary.remaining": "Not yet marked correct",
  "material.student_summary.progress": "{{correct}} of {{total}} activities correct",
  "material.student_summary.activity": "Activity {{number}}",
  "material.student_summary.section": "Go to section {{number}}"
}
